import { Form, Spin, Typography } from "antd/es";
import { connect } from "react-redux";
import {
  AutoComplete,
  Button,
  Currency,
  Footer,
  Header,
  HorizontalStack,
  Icon,
  KCol,
  KDatePicker,
  KDrawer,
  KModal,
  KRow,
  KTable,
  KTableColumn,
  KTableHeader,
  KTableRow,
  KuikaEditableCell,
  Label,
  MultiSelect,
  NumberInput,
  Switch,
  TextArea,
  TextInput,
  VerticalStack,
} from "../../components/web-components";
import { KCheckbox, KSelectBox } from "../../kuika";
import {
  hideImportMappedExcelModal,
  hideIyzicoDrawer,
  hidePhotoTake,
  hideStripeDrawer,
  showImportMappedExcelModal,
  showIyzicoDrawer,
  showPhotoTake,
  showStripeDrawer,
} from "../../redux/modals/actions";
import { AppState } from "../../redux/root-reducer";
import { KuikaTabOrderProvider } from "../../shared/hoc/tab-order-provider";
import { withContext } from "../../shared/hoc/with-context";
import { withForm } from "../../shared/hoc/with-form";
import { withGoogleLogin } from "../../shared/hoc/with-google-login";
import { withHistory } from "../../shared/hoc/with-history";
import { withInlineOverlayNav } from "../../shared/hoc/with-inline-overlay-nav";
import { withScreenInput } from "../../shared/hoc/with-screen-input";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { UcusForm_ScreenBase } from "./ucusform-base";

import { InlineFormScope } from "../../routes/master-screen-wrapper";
import { DosyaGoster_Screen } from "../dosyagoster/dosyagoster";
import { LeftMenu_Screen } from "../leftmenu/leftmenu";
import { MasrafForm_Screen } from "../masrafform/masrafform";
import { MesajKutusu_Screen } from "../mesajkutusu/mesajkutusu";
import { TarihceList_Screen } from "../tarihcelist/tarihcelist";
import { YolcuForm_Screen } from "../yolcuform/yolcuform";

declare let window: any;
const { Title, Paragraph, Text, Link } = Typography;
const menuMap = [];

class UcusForm_Screen extends UcusForm_ScreenBase {
  render() {
    if (this.state.isPageVisible === false) {
      return <></>;
    }
    return (
      <>
        <Spin spinning={this.state.spinnerCount > 0}>
          <KuikaTabOrderProvider>
            <Form
              form={this.props.form}
              name="basic"
              initialValues={{
                ucusform_808539_value: undefined,
                ucusform_385661_checked:
                  this.state.GetYetki?.yolcu ?? undefined,
                ucusform_249814_checked:
                  this.state.GetYetki?.pilot ?? undefined,
                ucusform_24225_checked:
                  this.state.GetYetki?.asistan ?? undefined,
                ucusform_949529_checked:
                  this.state.GetYetki?.mudur ?? undefined,
                ucusform_422516_checked:
                  this.state.GetYetki?.teknisyen ?? undefined,
                ucusform_506865_value: undefined,
                ucusform_25952_value: "U",
                ucusform_510322_value: undefined,
                ucusform_49457_checked: false,
                ucusform_341783_value: false,
                ucusform_956539_value: undefined,
                ucusform_825552_value: undefined,
                ucusform_942023_value: undefined,
                ucusform_167735_value: undefined,
                ucusform_459685_value: "",
                ucusform_284227_value: undefined,
                ucusform_554090_value: "",
                ucusform_24259_value: "",
                ucusform_348523_value: "",
                ucusform_361964_value: undefined,
                ucusform_403791_value: undefined,
                ucusform_575039_value: undefined,
                ucusform_143451_value: undefined,
                ucusform_316139_value: undefined,
                ucusform_13544_value: undefined,
                ucusform_835559_value: undefined,
                ucusform_995117_value: undefined,
                ucusform_771172_value: undefined,
                ucusform_755702_value: "",
              }}
              onValuesChange={(changedValues, allValues) => {
                this.clearFieldValidation(changedValues);
              }}
            >
              <div
                style={
                  {
                    display: "flex",
                    flexDirection: "column",
                    minHeight: "100%",
                  } as any
                }
              >
                <Header
                  key="-2"
                  id="ucusform_header"
                  style={
                    {
                      borderStyle: "solid",
                      borderTopWidth: 0,
                      borderRightWidth: 0,
                      borderBottomWidth: 0,
                      borderLeftWidth: 0,
                      backgroundColor: "rgba(3, 88, 255, 0.1)",
                      paddingTop: 0,
                      paddingRight: 0,
                      paddingBottom: 0,
                      paddingLeft: 0,
                      fontFamily: "Poppins",
                      fontWeight: 400,
                      fontSize: "15px",
                      color: "rgba(68, 68, 68, 1)",
                    } as any
                  }
                >
                  <KRow
                    key="488941"
                    data-testid="Row17"
                    id="488941"
                    align="top"
                    justify="start"
                    horizontalGutter={0}
                    verticalGutter={0}
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        paddingTop: 0,
                        paddingRight: 0,
                        paddingBottom: 0,
                        paddingLeft: 0,
                        alignItems: "flex-start",
                        textAlign: "-webkit-left",
                        fontFamily: "Poppins",
                        fontWeight: 400,
                        fontSize: "15px",
                        color: "rgba(68, 68, 68, 1)",
                      } as any
                    }
                  >
                    <KCol
                      key="356299"
                      data-testid="Col40_0"
                      id="356299"
                      xs={16}
                      sm={16}
                      md={16}
                      lg={16}
                      xl={16}
                      xxl={16}
                      order={0}
                      pull={0}
                      push={0}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 8,
                          paddingRight: 0,
                          paddingBottom: 8,
                          paddingLeft: 8,
                          alignItems: "center",
                          textAlign: "-webkit-left",
                          fontFamily: "Poppins",
                          fontWeight: 400,
                          fontSize: "15px",
                          color: "rgba(68, 68, 68, 1)",
                        } as any
                      }
                    >
                      <KRow
                        key="665588"
                        data-testid="Row35"
                        id="665588"
                        align="top"
                        justify="start"
                        horizontalGutter={0}
                        verticalGutter={0}
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 0,
                            paddingRight: 0,
                            paddingBottom: 0,
                            paddingLeft: 0,
                            fontFamily: "Poppins",
                            fontWeight: 400,
                            fontSize: "15px",
                            color: "rgba(68, 68, 68, 1)",
                          } as any
                        }
                      >
                        <KCol
                          key="955218"
                          data-testid="Col61"
                          id="955218"
                          xs={24}
                          sm={24}
                          md={24}
                          lg={24}
                          xl={24}
                          xxl={24}
                          order={0}
                          pull={0}
                          push={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              alignItems: "flex-start",
                              textAlign: "-webkit-left",
                              fontFamily: "Poppins",
                              fontWeight: 400,
                              fontSize: "15px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <HorizontalStack
                            key="847183"
                            data-testid="HorizontalStack7"
                            id="847183"
                            direction="horizontal"
                            size={12}
                            overflowX="auto"
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                fontFamily: "Poppins",
                                fontWeight: 400,
                                fontSize: "15px",
                                color: "rgba(68, 68, 68, 1)",
                              } as any
                            }
                          >
                            <Icon
                              key="899034"
                              data-testid="btnMenu"
                              id="899034"
                              onClick={(e?: any) => {
                                if (e && e.stopPropagation) e.stopPropagation();
                                this.UcusFormComponent_899034_onClick();
                              }}
                              showCursorPointer
                              iconName="menu"
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  paddingTop: 0,
                                  paddingRight: 0,
                                  paddingBottom: 0,
                                  paddingLeft: 0,
                                  alignItems: "center",
                                  textAlign: "-webkit-left",
                                  display: "inline",
                                  fontFamily: "Montserrat",
                                  fontWeight: 500,
                                  fontSize: "20px",
                                  color: "rgba(0, 0, 0, 1)",
                                } as any
                              }
                            ></Icon>
                            <Label
                              key="972475"
                              data-testid="Label16"
                              id="972475"
                              visibility={this.state.isComp972475Visible}
                              value={ReactSystemFunctions.translate(
                                this.ml,
                                972475,
                                "value",
                                this.defaultML
                              )}
                              writingMode="horizontal"
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  paddingTop: 0,
                                  paddingRight: 0,
                                  paddingBottom: 0,
                                  paddingLeft: 0,
                                  alignItems: "center",
                                  textAlign: "-webkit-left",
                                  display: "inline",
                                  fontFamily: "Poppins",
                                  fontWeight: 500,
                                  fontSize: "16px",
                                  color: "rgba(74, 74, 74, 1)",
                                } as any
                              }
                            ></Label>
                            <Label
                              key="649358"
                              data-testid="Label29"
                              id="649358"
                              visibility={this.state.isComp649358Visible}
                              value={ReactSystemFunctions.translate(
                                this.ml,
                                649358,
                                "value",
                                this.defaultML
                              )}
                              writingMode="horizontal"
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  paddingTop: 0,
                                  paddingRight: 0,
                                  paddingBottom: 0,
                                  paddingLeft: 0,
                                  alignItems: "center",
                                  textAlign: "-webkit-left",
                                  display: "inline",
                                  fontFamily: "Poppins",
                                  fontWeight: 500,
                                  fontSize: "16px",
                                  color: "rgba(74, 74, 74, 1)",
                                } as any
                              }
                            ></Label>
                            <Form.Item
                              className="kFormItem"
                              name="ucusform_808539_value"
                            >
                              <TextInput
                                key="808539"
                                data-testid="EditId"
                                id="808539"
                                visibility={this.state.isComp808539Visible}
                                kuikaRef={
                                  this.ucusform_808539_value_kuikaTextInputRef
                                }
                                placeholder={ReactSystemFunctions.translate(
                                  this.ml,
                                  808539,
                                  "placeholder",
                                  this.defaultML
                                )}
                                allowClear={false}
                                bordered={true}
                                disabled={false}
                                type="text"
                                iconColor="rgba(0, 0, 0, 1)"
                                formatter="None"
                                isCharOnly={false}
                                autoComplete={true}
                                inputMode="all"
                                speechToText={false}
                                style={
                                  {
                                    borderTopLeftRadius: 8,
                                    borderTopRightRadius: 8,
                                    borderBottomRightRadius: 8,
                                    borderBottomLeftRadius: 8,
                                    borderTopWidth: 1,
                                    borderRightWidth: 1,
                                    borderBottomWidth: 1,
                                    borderLeftWidth: 1,
                                    borderColor: "rgba(218, 218, 218, 1)",
                                    borderStyle: "solid",
                                    backgroundColor: "rgba(255, 255, 255, 1)",
                                    backgroundRepeat: "no-repeat",
                                    backgroundSize: "contain",
                                    backgroundPosition: "left",
                                    paddingTop: 8,
                                    paddingRight: 8,
                                    paddingBottom: 8,
                                    paddingLeft: 8,
                                    alignItems: "center",
                                    textAlign: "-webkit-left",
                                    display: "block",
                                    fontFamily: "Poppins",
                                    fontWeight: 400,
                                    fontSize: "15px",
                                    color: "rgba(68, 68, 68, 1)",
                                  } as any
                                }
                              ></TextInput>
                            </Form.Item>

                            <Form.Item
                              className="kFormItem"
                              name="ucusform_385661_checked"
                            >
                              <KCheckbox
                                key="385661"
                                data-testid="IsYolcu"
                                id="385661"
                                visibility={this.state.isComp385661Visible}
                                label={ReactSystemFunctions.translate(
                                  this.ml,
                                  385661,
                                  "label",
                                  this.defaultML
                                )}
                                children={ReactSystemFunctions.translate(
                                  this.ml,
                                  385661,
                                  "children",
                                  this.defaultML
                                )}
                                disabled={false}
                                indeterminate={false}
                                autoFocus={false}
                                boxColor="#ffffff"
                                boxColorOnChecked="#246dff"
                                checkIconColor="#ffffff"
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 8,
                                    paddingRight: 8,
                                    paddingBottom: 8,
                                    paddingLeft: 8,
                                    alignItems: "center",
                                    textAlign: "-webkit-left",
                                    display: "inline",
                                    fontFamily: "Montserrat",
                                    fontWeight: 500,
                                    fontSize: "10px",
                                    color: "rgba(1, 1, 1, 1)",
                                  } as any
                                }
                              ></KCheckbox>
                            </Form.Item>

                            <Form.Item
                              className="kFormItem"
                              name="ucusform_249814_checked"
                            >
                              <KCheckbox
                                key="249814"
                                data-testid="IsPilot"
                                id="249814"
                                visibility={this.state.isComp249814Visible}
                                label={ReactSystemFunctions.translate(
                                  this.ml,
                                  249814,
                                  "label",
                                  this.defaultML
                                )}
                                children={ReactSystemFunctions.translate(
                                  this.ml,
                                  249814,
                                  "children",
                                  this.defaultML
                                )}
                                disabled={false}
                                indeterminate={false}
                                autoFocus={false}
                                boxColor="#ffffff"
                                boxColorOnChecked="#246dff"
                                checkIconColor="#ffffff"
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 8,
                                    paddingRight: 8,
                                    paddingBottom: 8,
                                    paddingLeft: 8,
                                    alignItems: "center",
                                    textAlign: "-webkit-left",
                                    display: "inline",
                                    fontFamily: "Montserrat",
                                    fontWeight: 500,
                                    fontSize: "10px",
                                    color: "rgba(1, 1, 1, 1)",
                                  } as any
                                }
                              ></KCheckbox>
                            </Form.Item>

                            <Form.Item
                              className="kFormItem"
                              name="ucusform_24225_checked"
                            >
                              <KCheckbox
                                key="24225"
                                data-testid="IsYoneticiAsistani"
                                id="24225"
                                visibility={this.state.isComp24225Visible}
                                label={ReactSystemFunctions.translate(
                                  this.ml,
                                  24225,
                                  "label",
                                  this.defaultML
                                )}
                                children={ReactSystemFunctions.translate(
                                  this.ml,
                                  24225,
                                  "children",
                                  this.defaultML
                                )}
                                disabled={false}
                                indeterminate={false}
                                autoFocus={false}
                                boxColor="#ffffff"
                                boxColorOnChecked="#246dff"
                                checkIconColor="#ffffff"
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 8,
                                    paddingRight: 8,
                                    paddingBottom: 8,
                                    paddingLeft: 8,
                                    alignItems: "center",
                                    textAlign: "-webkit-left",
                                    display: "inline",
                                    fontFamily: "Montserrat",
                                    fontWeight: 500,
                                    fontSize: "10px",
                                    color: "rgba(1, 1, 1, 1)",
                                  } as any
                                }
                              ></KCheckbox>
                            </Form.Item>

                            <Form.Item
                              className="kFormItem"
                              name="ucusform_949529_checked"
                            >
                              <KCheckbox
                                key="949529"
                                data-testid="IsUcusMuduru"
                                id="949529"
                                visibility={this.state.isComp949529Visible}
                                label={ReactSystemFunctions.translate(
                                  this.ml,
                                  949529,
                                  "label",
                                  this.defaultML
                                )}
                                children={ReactSystemFunctions.translate(
                                  this.ml,
                                  949529,
                                  "children",
                                  this.defaultML
                                )}
                                disabled={false}
                                indeterminate={false}
                                autoFocus={false}
                                boxColor="#ffffff"
                                boxColorOnChecked="#246dff"
                                checkIconColor="#ffffff"
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 8,
                                    paddingRight: 8,
                                    paddingBottom: 8,
                                    paddingLeft: 8,
                                    alignItems: "center",
                                    textAlign: "-webkit-left",
                                    display: "inline",
                                    fontFamily: "Montserrat",
                                    fontWeight: 500,
                                    fontSize: "10px",
                                    color: "rgba(1, 1, 1, 1)",
                                  } as any
                                }
                              ></KCheckbox>
                            </Form.Item>

                            <Form.Item
                              className="kFormItem"
                              name="ucusform_422516_checked"
                            >
                              <KCheckbox
                                key="422516"
                                data-testid="IsTeknisyen"
                                id="422516"
                                visibility={this.state.isComp422516Visible}
                                label={ReactSystemFunctions.translate(
                                  this.ml,
                                  422516,
                                  "label",
                                  this.defaultML
                                )}
                                children={ReactSystemFunctions.translate(
                                  this.ml,
                                  422516,
                                  "children",
                                  this.defaultML
                                )}
                                disabled={false}
                                indeterminate={false}
                                autoFocus={false}
                                boxColor="#ffffff"
                                boxColorOnChecked="#246dff"
                                checkIconColor="#ffffff"
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 8,
                                    paddingRight: 8,
                                    paddingBottom: 8,
                                    paddingLeft: 8,
                                    alignItems: "center",
                                    textAlign: "-webkit-left",
                                    display: "inline",
                                    fontFamily: "Montserrat",
                                    fontWeight: 500,
                                    fontSize: "10px",
                                    color: "rgba(1, 1, 1, 1)",
                                  } as any
                                }
                              ></KCheckbox>
                            </Form.Item>

                            <Form.Item
                              className="kFormItem"
                              name="ucusform_506865_value"
                            >
                              <TextInput
                                key="506865"
                                data-testid="UserRoleNames"
                                id="506865"
                                visibility={this.state.isComp506865Visible}
                                kuikaRef={
                                  this.ucusform_506865_value_kuikaTextInputRef
                                }
                                placeholder={ReactSystemFunctions.translate(
                                  this.ml,
                                  506865,
                                  "placeholder",
                                  this.defaultML
                                )}
                                allowClear={false}
                                bordered={true}
                                disabled={false}
                                type="text"
                                iconColor="rgba(0, 0, 0, 1)"
                                formatter="None"
                                isCharOnly={false}
                                autoComplete={true}
                                inputMode="all"
                                speechToText={false}
                                style={
                                  {
                                    borderTopLeftRadius: 8,
                                    borderTopRightRadius: 8,
                                    borderBottomRightRadius: 8,
                                    borderBottomLeftRadius: 8,
                                    borderTopWidth: 1,
                                    borderRightWidth: 1,
                                    borderBottomWidth: 1,
                                    borderLeftWidth: 1,
                                    borderColor: "rgba(218, 218, 218, 1)",
                                    borderStyle: "solid",
                                    backgroundColor: "rgba(255, 255, 255, 1)",
                                    backgroundRepeat: "no-repeat",
                                    backgroundSize: "contain",
                                    backgroundPosition: "left",
                                    paddingTop: 8,
                                    paddingRight: 8,
                                    paddingBottom: 8,
                                    paddingLeft: 8,
                                    alignItems: "center",
                                    textAlign: "-webkit-left",
                                    display: "block",
                                    fontFamily: "Poppins",
                                    fontWeight: 400,
                                    fontSize: "15px",
                                    color: "rgba(68, 68, 68, 1)",
                                  } as any
                                }
                              ></TextInput>
                            </Form.Item>

                            <Form.Item
                              className="kFormItem"
                              name="ucusform_25952_value"
                            >
                              <TextInput
                                key="25952"
                                data-testid="IslemRUMB"
                                id="25952"
                                visibility={this.state.isComp25952Visible}
                                kuikaRef={
                                  this.ucusform_25952_value_kuikaTextInputRef
                                }
                                placeholder={ReactSystemFunctions.translate(
                                  this.ml,
                                  25952,
                                  "placeholder",
                                  this.defaultML
                                )}
                                allowClear={false}
                                bordered={true}
                                disabled={false}
                                type="text"
                                iconColor="rgba(0, 0, 0, 1)"
                                formatter="None"
                                isCharOnly={false}
                                autoComplete={true}
                                inputMode="all"
                                speechToText={false}
                                style={
                                  {
                                    borderTopLeftRadius: 8,
                                    borderTopRightRadius: 8,
                                    borderBottomRightRadius: 8,
                                    borderBottomLeftRadius: 8,
                                    borderTopWidth: 1,
                                    borderRightWidth: 1,
                                    borderBottomWidth: 1,
                                    borderLeftWidth: 1,
                                    borderColor: "rgba(218, 218, 218, 1)",
                                    borderStyle: "solid",
                                    backgroundColor: "rgba(255, 255, 255, 1)",
                                    backgroundRepeat: "no-repeat",
                                    backgroundSize: "contain",
                                    backgroundPosition: "left",
                                    paddingTop: 8,
                                    paddingRight: 8,
                                    paddingBottom: 8,
                                    paddingLeft: 8,
                                    width: "10px",
                                    alignItems: "center",
                                    textAlign: "-webkit-left",
                                    display: "block",
                                    fontFamily: "Poppins",
                                    fontWeight: 400,
                                    fontSize: "15px",
                                    color: "rgba(68, 68, 68, 1)",
                                  } as any
                                }
                              ></TextInput>
                            </Form.Item>
                          </HorizontalStack>
                        </KCol>
                      </KRow>
                    </KCol>
                    <KCol
                      key="300397"
                      data-testid="Col40_1"
                      id="300397"
                      xs={8}
                      sm={8}
                      md={8}
                      lg={8}
                      xl={8}
                      xxl={8}
                      order={0}
                      pull={0}
                      push={0}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 8,
                          paddingRight: 8,
                          paddingBottom: 8,
                          paddingLeft: 0,
                          alignItems: "center",
                          textAlign: "-webkit-right",
                          fontFamily: "Poppins",
                          fontWeight: 400,
                          fontSize: "15px",
                          color: "rgba(68, 68, 68, 1)",
                        } as any
                      }
                    >
                      <Button
                        key="845921"
                        data-testid="Tarihce"
                        id="845921"
                        onClick={(e?: any) => {
                          if (e && e.stopPropagation) e.stopPropagation();
                          this.UcusFormComponent_845921_onClick();
                        }}
                        showCursorPointer
                        visibility={this.state.isComp845921Visible}
                        label={ReactSystemFunctions.translate(
                          this.ml,
                          845921,
                          "label",
                          this.defaultML
                        )}
                        size="middle"
                        loading={false}
                        ghost={false}
                        block={false}
                        htmlType="button"
                        icon="view_timeline"
                        iconPosition="left"
                        danger={false}
                        style={
                          {
                            borderTopLeftRadius: 8,
                            borderTopRightRadius: 8,
                            borderBottomRightRadius: 8,
                            borderBottomLeftRadius: 8,
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            backgroundColor: "rgba(3, 88, 255, 1)",
                            backgroundRepeat: "no-repeat",
                            backgroundSize: "contain",
                            backgroundPosition: "left",
                            paddingTop: 8,
                            paddingRight: 16,
                            paddingBottom: 8,
                            paddingLeft: 16,
                            alignItems: "center",
                            textAlign: "-webkit-center",
                            display: "inline",
                            fontFamily: "Poppins",
                            fontWeight: 500,
                            fontSize: "16px",
                            color: "rgba(255, 255, 255, 1)",
                            lineHeight: "22px",
                          } as any
                        }
                      ></Button>
                    </KCol>
                  </KRow>
                </Header>
                <div
                  key="-1"
                  id="ucusform_body"
                  style={
                    {
                      borderStyle: "solid",
                      borderTopWidth: 0,
                      borderRightWidth: 0,
                      borderBottomWidth: 0,
                      borderLeftWidth: 0,
                      backgroundColor: "rgba(244, 244, 244, 1)",
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "contain",
                      backgroundPosition: "left",
                      display: "block",
                    } as any
                  }
                >
                  <KRow
                    key="154338"
                    data-testid="Row1"
                    id="154338"
                    editability={this.state.isComp154338Enabled}
                    align="top"
                    justify="start"
                    horizontalGutter={0}
                    verticalGutter={0}
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        paddingTop: 0,
                        paddingRight: 0,
                        paddingBottom: 0,
                        paddingLeft: 0,
                        alignItems: "flex-start",
                        textAlign: "-webkit-left",
                        fontFamily: "Poppins",
                        fontWeight: 400,
                        fontSize: "15px",
                        color: "rgba(68, 68, 68, 1)",
                      } as any
                    }
                  >
                    <KCol
                      key="499819"
                      data-testid="Col1"
                      id="499819"
                      xs={24}
                      sm={24}
                      md={24}
                      lg={24}
                      xl={24}
                      xxl={24}
                      order={0}
                      pull={0}
                      push={0}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 3,
                          paddingRight: 8,
                          paddingBottom: 3,
                          paddingLeft: 8,
                          alignItems: "flex-start",
                          textAlign: "-webkit-left",
                          fontFamily: "Poppins",
                          fontWeight: 400,
                          fontSize: "15px",
                          color: "rgba(68, 68, 68, 1)",
                        } as any
                      }
                    >
                      <KRow
                        key="439531"
                        data-testid="Row2"
                        id="439531"
                        align="top"
                        justify="start"
                        horizontalGutter={0}
                        verticalGutter={0}
                        style={
                          {
                            borderTopLeftRadius: 8,
                            borderTopRightRadius: 8,
                            borderBottomRightRadius: 8,
                            borderBottomLeftRadius: 8,
                            backgroundColor: "rgba(255, 255, 255, 1)",
                            backgroundRepeat: "no-repeat",
                            backgroundSize: "contain",
                            backgroundPosition: "left",
                            paddingTop: 0,
                            paddingRight: 8,
                            paddingBottom: 0,
                            paddingLeft: 8,
                            alignItems: "flex-start",
                            textAlign: "-webkit-left",
                            fontFamily: "Poppins",
                            fontWeight: 400,
                            fontSize: "15px",
                            color: "rgba(68, 68, 68, 1)",
                          } as any
                        }
                      >
                        <KCol
                          key="545037"
                          data-testid="Col2_0"
                          id="545037"
                          xs={12}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={4}
                          xxl={4}
                          order={0}
                          pull={0}
                          push={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 8,
                              paddingRight: 8,
                              paddingBottom: 8,
                              paddingLeft: 8,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              fontFamily: "Poppins",
                              fontWeight: 400,
                              fontSize: "15px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <Label
                            key="860329"
                            data-testid="Label1"
                            id="860329"
                            value={ReactSystemFunctions.translate(
                              this.ml,
                              860329,
                              "value",
                              this.defaultML
                            )}
                            writingMode="horizontal"
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                alignItems: "center",
                                textAlign: "-webkit-left",
                                display: "inline",
                                fontFamily: "Poppins",
                                fontWeight: 400,
                                fontSize: "15px",
                                color: "rgba(68, 68, 68, 1)",
                              } as any
                            }
                          ></Label>
                        </KCol>
                        <KCol
                          key="802117"
                          data-testid="Col2_1"
                          id="802117"
                          xs={12}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={8}
                          xxl={8}
                          order={0}
                          pull={0}
                          push={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 8,
                              paddingRight: 8,
                              paddingBottom: 8,
                              paddingLeft: 8,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              fontFamily: "Poppins",
                              fontWeight: 400,
                              fontSize: "15px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <KRow
                            key="869736"
                            data-testid="Row46"
                            id="869736"
                            align="top"
                            justify="start"
                            horizontalGutter={0}
                            verticalGutter={0}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                alignItems: "flex-start",
                                textAlign: "-webkit-left",
                              } as any
                            }
                          >
                            <KCol
                              key="828688"
                              data-testid="Col70_0"
                              id="828688"
                              xs={6}
                              sm={6}
                              md={6}
                              lg={6}
                              xl={6}
                              xxl={6}
                              order={0}
                              pull={0}
                              push={0}
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  paddingTop: 0,
                                  paddingRight: 0,
                                  paddingBottom: 0,
                                  paddingLeft: 0,
                                  alignItems: "flex-start",
                                  textAlign: "-webkit-left",
                                } as any
                              }
                            >
                              <Form.Item
                                className="kFormItem"
                                name="ucusform_510322_value"
                              >
                                <TextInput
                                  key="510322"
                                  data-testid="UcusNo"
                                  id="510322"
                                  editability={this.state.isComp510322Enabled}
                                  kuikaRef={
                                    this.ucusform_510322_value_kuikaTextInputRef
                                  }
                                  placeholder={ReactSystemFunctions.translate(
                                    this.ml,
                                    510322,
                                    "placeholder",
                                    this.defaultML
                                  )}
                                  allowClear={false}
                                  bordered={true}
                                  disabled={false}
                                  type="text"
                                  iconColor="rgba(0, 0, 0, 1)"
                                  formatter="None"
                                  isCharOnly={false}
                                  autoComplete={true}
                                  inputMode="all"
                                  speechToText={false}
                                  style={
                                    {
                                      borderTopLeftRadius: 8,
                                      borderTopRightRadius: 8,
                                      borderBottomRightRadius: 8,
                                      borderBottomLeftRadius: 8,
                                      borderTopWidth: 1,
                                      borderRightWidth: 1,
                                      borderBottomWidth: 1,
                                      borderLeftWidth: 1,
                                      borderColor: "rgba(218, 218, 218, 1)",
                                      borderStyle: "solid",
                                      backgroundColor: "rgba(255, 255, 255, 1)",
                                      backgroundRepeat: "no-repeat",
                                      backgroundSize: "contain",
                                      backgroundPosition: "left",
                                      paddingTop: 8,
                                      paddingRight: 8,
                                      paddingBottom: 8,
                                      paddingLeft: 8,
                                      alignItems: "center",
                                      textAlign: "-webkit-left",
                                      display: "block",
                                      fontFamily: "Poppins",
                                      fontWeight: 400,
                                      fontSize: "15px",
                                      color: "rgba(68, 68, 68, 1)",
                                    } as any
                                  }
                                ></TextInput>
                              </Form.Item>
                            </KCol>
                            <KCol
                              key="206663"
                              data-testid="Col70_1"
                              id="206663"
                              xs={18}
                              sm={18}
                              md={18}
                              lg={18}
                              xl={18}
                              xxl={18}
                              order={0}
                              pull={0}
                              push={0}
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  paddingTop: 0,
                                  paddingRight: 0,
                                  paddingBottom: 0,
                                  paddingLeft: 0,
                                  alignItems: "center",
                                  textAlign: "-webkit-left",
                                } as any
                              }
                            >
                              <Form.Item
                                className="kFormItem"
                                name="ucusform_49457_checked"
                              >
                                <KCheckbox
                                  key="49457"
                                  data-testid="chkSilindi"
                                  id="49457"
                                  visibility={this.state.isComp49457Visible}
                                  label={ReactSystemFunctions.translate(
                                    this.ml,
                                    49457,
                                    "label",
                                    this.defaultML
                                  )}
                                  children={ReactSystemFunctions.translate(
                                    this.ml,
                                    49457,
                                    "children",
                                    this.defaultML
                                  )}
                                  disabled={false}
                                  indeterminate={false}
                                  autoFocus={false}
                                  boxColor="#ffffff"
                                  boxColorOnChecked="#246dff"
                                  checkIconColor="#ffffff"
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      paddingTop: 8,
                                      paddingRight: 8,
                                      paddingBottom: 8,
                                      paddingLeft: 8,
                                      width: "100px",
                                      alignItems: "center",
                                      textAlign: "-webkit-left",
                                      display: "inline",
                                      fontFamily: "Poppins",
                                      fontWeight: 400,
                                      fontSize: "15px",
                                      color: "rgba(68, 68, 68, 1)",
                                    } as any
                                  }
                                ></KCheckbox>
                              </Form.Item>
                            </KCol>
                          </KRow>
                        </KCol>
                        <KCol
                          key="276964"
                          data-testid="Col2_2"
                          id="276964"
                          xs={12}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={4}
                          xxl={4}
                          order={0}
                          pull={0}
                          push={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 8,
                              paddingRight: 8,
                              paddingBottom: 8,
                              paddingLeft: 8,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              fontFamily: "Poppins",
                              fontWeight: 400,
                              fontSize: "15px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <Label
                            key="70519"
                            data-testid="Label22"
                            id="70519"
                            value={ReactSystemFunctions.translate(
                              this.ml,
                              70519,
                              "value",
                              this.defaultML
                            )}
                            writingMode="horizontal"
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                alignItems: "center",
                                textAlign: "-webkit-left",
                                display: "inline",
                                fontFamily: "Poppins",
                                fontWeight: 400,
                                fontSize: "15px",
                                color: "rgba(68, 68, 68, 1)",
                              } as any
                            }
                          ></Label>
                        </KCol>
                        <KCol
                          key="551890"
                          data-testid="Col5"
                          id="551890"
                          xs={12}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={8}
                          xxl={8}
                          order={0}
                          pull={0}
                          push={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 8,
                              paddingRight: 8,
                              paddingBottom: 8,
                              paddingLeft: 8,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              fontFamily: "Poppins",
                              fontWeight: 400,
                              fontSize: "15px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <KRow
                            key="703688"
                            data-testid="Row41"
                            id="703688"
                            align="top"
                            justify="start"
                            horizontalGutter={0}
                            verticalGutter={0}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                alignItems: "flex-start",
                                textAlign: "-webkit-left",
                                fontFamily: "Poppins",
                                fontWeight: 400,
                                fontSize: "15px",
                                color: "rgba(68, 68, 68, 1)",
                              } as any
                            }
                          >
                            <KCol
                              key="704872"
                              data-testid="Col62_0"
                              id="704872"
                              xs={8}
                              sm={8}
                              md={8}
                              lg={8}
                              xl={8}
                              xxl={8}
                              order={0}
                              pull={0}
                              push={0}
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  paddingTop: 0,
                                  paddingRight: 0,
                                  paddingBottom: 0,
                                  paddingLeft: 0,
                                  alignItems: "center",
                                  textAlign: "-webkit-left",
                                  fontFamily: "Poppins",
                                  fontWeight: 400,
                                  fontSize: "15px",
                                  color: "rgba(68, 68, 68, 1)",
                                } as any
                              }
                            >
                              <Form.Item
                                className="kFormItem"
                                name="ucusform_341783_value"
                              >
                                <Switch
                                  key="341783"
                                  data-testid="OnayDurumu"
                                  id="341783"
                                  editability={this.state.isComp341783Enabled}
                                  disabled={false}
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      paddingTop: 0,
                                      paddingRight: 0,
                                      paddingBottom: 0,
                                      paddingLeft: 0,
                                      fontFamily: "Poppins",
                                      fontWeight: 400,
                                      fontSize: "15px",
                                      color: "rgba(68, 68, 68, 1)",
                                    } as any
                                  }
                                ></Switch>
                              </Form.Item>
                            </KCol>
                            <KCol
                              key="995965"
                              data-testid="Col62_1"
                              id="995965"
                              xs={16}
                              sm={16}
                              md={16}
                              lg={16}
                              xl={16}
                              xxl={16}
                              order={0}
                              pull={0}
                              push={0}
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  paddingTop: 0,
                                  paddingRight: 0,
                                  paddingBottom: 0,
                                  paddingLeft: 0,
                                  alignItems: "flex-start",
                                  textAlign: "-webkit-left",
                                  fontFamily: "Poppins",
                                  fontWeight: 400,
                                  fontSize: "15px",
                                  color: "rgba(68, 68, 68, 1)",
                                } as any
                              }
                            >
                              <Form.Item
                                className="kFormItem"
                                name="ucusform_956539_value"
                              >
                                <TextInput
                                  key="956539"
                                  data-testid="Onaylayan"
                                  id="956539"
                                  editability={this.state.isComp956539Enabled}
                                  kuikaRef={
                                    this.ucusform_956539_value_kuikaTextInputRef
                                  }
                                  placeholder={ReactSystemFunctions.translate(
                                    this.ml,
                                    956539,
                                    "placeholder",
                                    this.defaultML
                                  )}
                                  allowClear={false}
                                  bordered={true}
                                  disabled={false}
                                  type="text"
                                  iconColor="rgba(0, 0, 0, 1)"
                                  formatter="None"
                                  isCharOnly={false}
                                  autoComplete={true}
                                  inputMode="all"
                                  speechToText={false}
                                  style={
                                    {
                                      borderTopLeftRadius: 8,
                                      borderTopRightRadius: 8,
                                      borderBottomRightRadius: 8,
                                      borderBottomLeftRadius: 8,
                                      borderTopWidth: 1,
                                      borderRightWidth: 1,
                                      borderBottomWidth: 1,
                                      borderLeftWidth: 1,
                                      borderColor: "rgba(218, 218, 218, 1)",
                                      borderStyle: "solid",
                                      backgroundColor: "rgba(255, 255, 255, 1)",
                                      backgroundRepeat: "no-repeat",
                                      backgroundSize: "contain",
                                      backgroundPosition: "left",
                                      paddingTop: 8,
                                      paddingRight: 8,
                                      paddingBottom: 8,
                                      paddingLeft: 8,
                                      alignItems: "center",
                                      textAlign: "-webkit-left",
                                      display: "block",
                                      fontFamily: "Poppins",
                                      fontWeight: 400,
                                      fontSize: "15px",
                                      color: "rgba(68, 68, 68, 1)",
                                    } as any
                                  }
                                ></TextInput>
                              </Form.Item>
                            </KCol>
                          </KRow>
                        </KCol>
                      </KRow>
                    </KCol>
                  </KRow>
                  <KRow
                    key="380974"
                    data-testid="Row7"
                    id="380974"
                    editability={this.state.isComp380974Enabled}
                    align="top"
                    justify="start"
                    horizontalGutter={0}
                    verticalGutter={0}
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        paddingTop: 0,
                        paddingRight: 0,
                        paddingBottom: 0,
                        paddingLeft: 0,
                        alignItems: "flex-start",
                        textAlign: "-webkit-left",
                        fontFamily: "Poppins",
                        fontWeight: 400,
                        fontSize: "15px",
                        color: "rgba(68, 68, 68, 1)",
                      } as any
                    }
                  >
                    <KCol
                      key="739928"
                      data-testid="Col4"
                      id="739928"
                      xs={24}
                      sm={24}
                      md={24}
                      lg={24}
                      xl={24}
                      xxl={24}
                      order={0}
                      pull={0}
                      push={0}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 3,
                          paddingRight: 8,
                          paddingBottom: 3,
                          paddingLeft: 8,
                          alignItems: "flex-start",
                          textAlign: "-webkit-left",
                          fontFamily: "Poppins",
                          fontWeight: 400,
                          fontSize: "15px",
                          color: "rgba(68, 68, 68, 1)",
                        } as any
                      }
                    >
                      <KRow
                        key="674124"
                        data-testid="Row8"
                        id="674124"
                        align="top"
                        justify="start"
                        horizontalGutter={0}
                        verticalGutter={0}
                        style={
                          {
                            borderTopLeftRadius: 8,
                            borderTopRightRadius: 8,
                            borderBottomRightRadius: 8,
                            borderBottomLeftRadius: 8,
                            backgroundColor: "rgba(255, 255, 255, 1)",
                            backgroundRepeat: "no-repeat",
                            backgroundSize: "contain",
                            backgroundPosition: "left",
                            paddingTop: 0,
                            paddingRight: 8,
                            paddingBottom: 0,
                            paddingLeft: 8,
                            alignItems: "flex-start",
                            textAlign: "-webkit-left",
                            fontFamily: "Poppins",
                            fontWeight: 400,
                            fontSize: "15px",
                            color: "rgba(68, 68, 68, 1)",
                          } as any
                        }
                      >
                        <KCol
                          key="537305"
                          data-testid="Col2_9"
                          id="537305"
                          xs={12}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={4}
                          xxl={4}
                          order={0}
                          pull={0}
                          push={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 8,
                              paddingRight: 8,
                              paddingBottom: 8,
                              paddingLeft: 8,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              fontFamily: "Poppins",
                              fontWeight: 400,
                              fontSize: "15px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <Label
                            key="356931"
                            data-testid="Label23"
                            id="356931"
                            value={ReactSystemFunctions.translate(
                              this.ml,
                              356931,
                              "value",
                              this.defaultML
                            )}
                            writingMode="horizontal"
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                alignItems: "center",
                                textAlign: "-webkit-left",
                                display: "inline",
                                fontFamily: "Poppins",
                                fontWeight: 400,
                                fontSize: "15px",
                                color: "rgba(68, 68, 68, 1)",
                              } as any
                            }
                          ></Label>
                          <Label
                            key="907296"
                            data-testid="LblGidisRezervasyonNo"
                            id="907296"
                            value={ReactSystemFunctions.translate(
                              this.ml,
                              907296,
                              "value",
                              this.defaultML
                            )}
                            writingMode="horizontal"
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                alignItems: "center",
                                textAlign: "-webkit-left",
                                display: "inline",
                                fontFamily: "Poppins",
                                fontWeight: 400,
                                fontSize: "15px",
                                color: "rgba(68, 68, 68, 1)",
                              } as any
                            }
                          ></Label>
                        </KCol>
                        <KCol
                          key="287513"
                          data-testid="Col2_10"
                          id="287513"
                          xs={12}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={8}
                          xxl={8}
                          order={0}
                          pull={0}
                          push={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 8,
                              paddingRight: 8,
                              paddingBottom: 8,
                              paddingLeft: 8,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              fontFamily: "Poppins",
                              fontWeight: 400,
                              fontSize: "15px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <KRow
                            key="525691"
                            data-testid="Row47"
                            id="525691"
                            align="top"
                            justify="start"
                            horizontalGutter={0}
                            verticalGutter={0}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                alignItems: "flex-start",
                                textAlign: "-webkit-left",
                              } as any
                            }
                          >
                            <KCol
                              key="450082"
                              data-testid="Col70_0"
                              id="450082"
                              xs={6}
                              sm={6}
                              md={6}
                              lg={6}
                              xl={6}
                              xxl={6}
                              order={0}
                              pull={0}
                              push={0}
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  paddingTop: 0,
                                  paddingRight: 0,
                                  paddingBottom: 0,
                                  paddingLeft: 0,
                                  alignItems: "flex-start",
                                  textAlign: "-webkit-left",
                                } as any
                              }
                            >
                              <Form.Item
                                className="kFormItem"
                                name="ucusform_825552_value"
                              >
                                <NumberInput
                                  key="825552"
                                  data-testid="RezervasyonNo"
                                  id="825552"
                                  onPressEnter={(e?: any) => {
                                    if (e && e.stopPropagation)
                                      e.stopPropagation();
                                    this.UcusFormComponent_825552_onPressEnter();
                                  }}
                                  editability={this.state.isComp825552Enabled}
                                  decimalSeparator="."
                                  decimalScale={0}
                                  disabled={false}
                                  placeholder={ReactSystemFunctions.translate(
                                    this.ml,
                                    825552,
                                    "placeholder",
                                    this.defaultML
                                  )}
                                  fixedDecimalScale={false}
                                  allowNegative={true}
                                  allowEmptyFormatting={false}
                                  isThousandSeperatorOn={true}
                                  style={
                                    {
                                      borderTopLeftRadius: 8,
                                      borderTopRightRadius: 8,
                                      borderBottomRightRadius: 8,
                                      borderBottomLeftRadius: 8,
                                      borderTopWidth: 1,
                                      borderRightWidth: 1,
                                      borderBottomWidth: 1,
                                      borderLeftWidth: 1,
                                      borderColor: "rgba(218, 218, 218, 1)",
                                      borderStyle: "solid",
                                      backgroundColor: "rgba(255, 255, 255, 1)",
                                      backgroundRepeat: "no-repeat",
                                      backgroundSize: "contain",
                                      backgroundPosition: "left",
                                      paddingTop: 8,
                                      paddingRight: 8,
                                      paddingBottom: 8,
                                      paddingLeft: 8,
                                      alignItems: "center",
                                      textAlign: "-webkit-left",
                                      display: "block",
                                      fontFamily: "Poppins",
                                      fontWeight: 400,
                                      fontSize: "15px",
                                      color: "rgba(68, 68, 68, 1)",
                                    } as any
                                  }
                                ></NumberInput>
                              </Form.Item>
                            </KCol>
                            <KCol
                              key="701880"
                              data-testid="Col70_1"
                              id="701880"
                              xs={18}
                              sm={18}
                              md={18}
                              lg={18}
                              xl={18}
                              xxl={18}
                              order={0}
                              pull={0}
                              push={0}
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  paddingTop: 0,
                                  paddingRight: 0,
                                  paddingBottom: 0,
                                  paddingLeft: 0,
                                  alignItems: "flex-start",
                                  textAlign: "-webkit-left",
                                } as any
                              }
                            ></KCol>
                          </KRow>
                        </KCol>
                        <KCol
                          key="168429"
                          data-testid="Col2_11"
                          id="168429"
                          xs={12}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={4}
                          xxl={4}
                          order={0}
                          pull={0}
                          push={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 8,
                              paddingRight: 8,
                              paddingBottom: 8,
                              paddingLeft: 8,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              fontFamily: "Poppins",
                              fontWeight: 400,
                              fontSize: "15px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <Label
                            key="311746"
                            data-testid="Label7"
                            id="311746"
                            value={ReactSystemFunctions.translate(
                              this.ml,
                              311746,
                              "value",
                              this.defaultML
                            )}
                            writingMode="horizontal"
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                alignItems: "center",
                                textAlign: "-webkit-left",
                                display: "inline",
                                fontFamily: "Poppins",
                                fontWeight: 400,
                                fontSize: "15px",
                                color: "rgba(68, 68, 68, 1)",
                              } as any
                            }
                          ></Label>
                          <Label
                            key="7557"
                            data-testid="Label18"
                            id="7557"
                            value={ReactSystemFunctions.translate(
                              this.ml,
                              7557,
                              "value",
                              this.defaultML
                            )}
                            writingMode="horizontal"
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                alignItems: "center",
                                textAlign: "-webkit-left",
                                display: "inline",
                                fontFamily: "Poppins",
                                fontWeight: 400,
                                fontSize: "15px",
                                color: "rgba(68, 68, 68, 1)",
                              } as any
                            }
                          ></Label>
                        </KCol>
                        <KCol
                          key="52628"
                          data-testid="Col2_15"
                          id="52628"
                          xs={12}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={8}
                          xxl={8}
                          order={0}
                          pull={0}
                          push={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 8,
                              paddingRight: 8,
                              paddingBottom: 8,
                              paddingLeft: 8,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              fontFamily: "Poppins",
                              fontWeight: 400,
                              fontSize: "15px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <Form.Item
                            className="kFormItem"
                            name="ucusform_942023_value"
                          >
                            <KSelectBox
                              key="942023"
                              data-testid="UcusTipi"
                              id="942023"
                              kuikaRef={
                                this.ucusform_942023_value_kuikaSelectBoxRef
                              }
                              options={this.state.UcusTipiListe2}
                              placeholder={ReactSystemFunctions.translate(
                                this.ml,
                                942023,
                                "placeholder",
                                this.defaultML
                              )}
                              allowClear={false}
                              autoClearSearchValue={true}
                              showSearch={false}
                              widthType="fill"
                              containsNullItem={false}
                              sortBy="none"
                              datavaluefield="kod"
                              datatextfield="ad"
                              style={
                                {
                                  borderTopLeftRadius: 8,
                                  borderTopRightRadius: 8,
                                  borderBottomRightRadius: 8,
                                  borderBottomLeftRadius: 8,
                                  borderTopWidth: 1,
                                  borderRightWidth: 1,
                                  borderBottomWidth: 1,
                                  borderLeftWidth: 1,
                                  borderColor: "rgba(218, 218, 218, 1)",
                                  borderStyle: "solid",
                                  backgroundColor: "rgba(255, 255, 255, 1)",
                                  backgroundRepeat: "no-repeat",
                                  backgroundSize: "contain",
                                  backgroundPosition: "left",
                                  paddingTop: 8,
                                  paddingRight: 8,
                                  paddingBottom: 8,
                                  paddingLeft: 8,
                                  alignItems: "center",
                                  textAlign: "-webkit-left",
                                  display: "block",
                                  fontFamily: "Poppins",
                                  fontWeight: 400,
                                  fontSize: "15px",
                                  color: "rgba(68, 68, 68, 1)",
                                } as any
                              }
                            ></KSelectBox>
                          </Form.Item>
                        </KCol>
                      </KRow>
                    </KCol>
                  </KRow>
                  <KRow
                    key="289033"
                    data-testid="Row19"
                    id="289033"
                    editability={this.state.isComp289033Enabled}
                    align="top"
                    justify="start"
                    horizontalGutter={0}
                    verticalGutter={0}
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        paddingTop: 0,
                        paddingRight: 0,
                        paddingBottom: 0,
                        paddingLeft: 0,
                        alignItems: "flex-start",
                        textAlign: "-webkit-left",
                        fontFamily: "Poppins",
                        fontWeight: 400,
                        fontSize: "15px",
                        color: "rgba(68, 68, 68, 1)",
                      } as any
                    }
                  >
                    <KCol
                      key="650917"
                      data-testid="Col16"
                      id="650917"
                      xs={24}
                      sm={24}
                      md={24}
                      lg={24}
                      xl={24}
                      xxl={24}
                      order={0}
                      pull={0}
                      push={0}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 3,
                          paddingRight: 8,
                          paddingBottom: 3,
                          paddingLeft: 8,
                          alignItems: "flex-start",
                          textAlign: "-webkit-left",
                          fontFamily: "Poppins",
                          fontWeight: 400,
                          fontSize: "15px",
                          color: "rgba(68, 68, 68, 1)",
                        } as any
                      }
                    >
                      <KRow
                        key="402501"
                        data-testid="Row20"
                        id="402501"
                        align="top"
                        justify="start"
                        horizontalGutter={0}
                        verticalGutter={0}
                        style={
                          {
                            borderTopLeftRadius: 8,
                            borderTopRightRadius: 8,
                            borderBottomRightRadius: 8,
                            borderBottomLeftRadius: 8,
                            backgroundColor: "rgba(255, 255, 255, 1)",
                            backgroundRepeat: "no-repeat",
                            backgroundSize: "contain",
                            backgroundPosition: "left",
                            paddingTop: 0,
                            paddingRight: 8,
                            paddingBottom: 0,
                            paddingLeft: 8,
                            alignItems: "flex-start",
                            textAlign: "-webkit-left",
                            fontFamily: "Poppins",
                            fontWeight: 400,
                            fontSize: "15px",
                            color: "rgba(68, 68, 68, 1)",
                          } as any
                        }
                      >
                        <KCol
                          key="404930"
                          data-testid="Col2_23"
                          id="404930"
                          xs={12}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={4}
                          xxl={4}
                          order={0}
                          pull={0}
                          push={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 8,
                              paddingRight: 8,
                              paddingBottom: 8,
                              paddingLeft: 8,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              fontFamily: "Poppins",
                              fontWeight: 400,
                              fontSize: "15px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <Label
                            key="969375"
                            data-testid="Label15"
                            id="969375"
                            value={ReactSystemFunctions.translate(
                              this.ml,
                              969375,
                              "value",
                              this.defaultML
                            )}
                            writingMode="horizontal"
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                alignItems: "center",
                                textAlign: "-webkit-left",
                                display: "inline",
                                fontFamily: "Poppins",
                                fontWeight: 400,
                                fontSize: "15px",
                                color: "rgba(68, 68, 68, 1)",
                              } as any
                            }
                          ></Label>
                        </KCol>
                        <KCol
                          key="609855"
                          data-testid="Col2_24"
                          id="609855"
                          xs={12}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={8}
                          xxl={8}
                          order={0}
                          pull={0}
                          push={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 8,
                              paddingRight: 8,
                              paddingBottom: 8,
                              paddingLeft: 8,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              fontFamily: "Poppins",
                              fontWeight: 400,
                              fontSize: "15px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <KRow
                            key="108695"
                            data-testid="Row36"
                            id="108695"
                            align="top"
                            justify="start"
                            horizontalGutter={0}
                            verticalGutter={0}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                alignItems: "flex-start",
                                textAlign: "-webkit-left",
                                fontFamily: "Poppins",
                                fontWeight: 400,
                                fontSize: "15px",
                                color: "rgba(68, 68, 68, 1)",
                              } as any
                            }
                          >
                            <KCol
                              key="253655"
                              data-testid="Col62_0"
                              id="253655"
                              xs={24}
                              sm={24}
                              md={24}
                              lg={24}
                              xl={6}
                              xxl={6}
                              order={0}
                              pull={0}
                              push={0}
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  paddingTop: 0,
                                  paddingRight: 0,
                                  paddingBottom: 0,
                                  paddingLeft: 0,
                                  alignItems: "flex-start",
                                  textAlign: "-webkit-left",
                                  fontFamily: "Poppins",
                                  fontWeight: 400,
                                  fontSize: "15px",
                                  color: "rgba(68, 68, 68, 1)",
                                } as any
                              }
                            >
                              <Form.Item
                                className="kFormItem"
                                name="ucusform_167735_value"
                              >
                                <KSelectBox
                                  key="167735"
                                  data-testid="KalkisUlke"
                                  id="167735"
                                  onChange={(e?: any) => {
                                    if (e && e.stopPropagation)
                                      e.stopPropagation();
                                    this.UcusFormComponent_167735_onChange();
                                  }}
                                  kuikaRef={
                                    this
                                      .ucusform_167735_value_kuikaAutoCompleteRef
                                  }
                                  options={this.state.UlkeListe}
                                  placeholder={ReactSystemFunctions.translate(
                                    this.ml,
                                    167735,
                                    "placeholder",
                                    this.defaultML
                                  )}
                                  allowClear={false}
                                  autoClearSearchValue={true}
                                  showSearch={true}
                                  widthType="fill"
                                  containsNullItem={false}
                                  sortBy="none"
                                  datavaluefield="code"
                                  datatextfield="name"
                                  style={
                                    {
                                      borderTopLeftRadius: 8,
                                      borderTopRightRadius: 8,
                                      borderBottomRightRadius: 8,
                                      borderBottomLeftRadius: 8,
                                      borderTopWidth: 1,
                                      borderRightWidth: 1,
                                      borderBottomWidth: 1,
                                      borderLeftWidth: 1,
                                      borderColor: "rgba(218, 218, 218, 1)",
                                      borderStyle: "solid",
                                      backgroundColor: "rgba(255, 255, 255, 1)",
                                      backgroundRepeat: "no-repeat",
                                      backgroundSize: "contain",
                                      backgroundPosition: "left",
                                      paddingTop: 8,
                                      paddingRight: 8,
                                      paddingBottom: 8,
                                      paddingLeft: 8,
                                      alignItems: "center",
                                      textAlign: "-webkit-left",
                                      display: "block",
                                      fontFamily: "Poppins",
                                      fontWeight: 400,
                                      fontSize: "15px",
                                      color: "rgba(68, 68, 68, 1)",
                                    } as any
                                  }
                                ></KSelectBox>
                              </Form.Item>
                            </KCol>
                            <KCol
                              key="119975"
                              data-testid="Col62_1"
                              id="119975"
                              xs={24}
                              sm={24}
                              md={24}
                              lg={24}
                              xl={18}
                              xxl={18}
                              order={0}
                              pull={0}
                              push={0}
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  paddingTop: 0,
                                  paddingRight: 0,
                                  paddingBottom: 0,
                                  paddingLeft: 0,
                                  alignItems: "flex-start",
                                  textAlign: "-webkit-left",
                                  fontFamily: "Poppins",
                                  fontWeight: 400,
                                  fontSize: "15px",
                                  color: "rgba(68, 68, 68, 1)",
                                } as any
                              }
                            >
                              <Form.Item
                                className="kFormItem"
                                name="ucusform_459685_value"
                              >
                                <AutoComplete
                                  key="459685"
                                  data-testid="KalkisNokta"
                                  id="459685"
                                  onSearch={(e?: any) => {
                                    if (e && e.stopPropagation)
                                      e.stopPropagation();
                                    this.UcusFormComponent_459685_onSearch();
                                  }}
                                  kuikaRef={
                                    this
                                      .ucusform_459685_value_kuikaAutoCompleteRef
                                  }
                                  options={this.state.NoktaListe}
                                  placeholder={ReactSystemFunctions.translate(
                                    this.ml,
                                    459685,
                                    "placeholder",
                                    this.defaultML
                                  )}
                                  allowClear={false}
                                  searchable={true}
                                  datavaluefield="icaoCode"
                                  datatextfield="secim"
                                  style={
                                    {
                                      borderTopLeftRadius: 8,
                                      borderTopRightRadius: 8,
                                      borderBottomRightRadius: 8,
                                      borderBottomLeftRadius: 8,
                                      borderTopWidth: 1,
                                      borderRightWidth: 1,
                                      borderBottomWidth: 1,
                                      borderLeftWidth: 1,
                                      borderColor: "rgba(218, 218, 218, 1)",
                                      borderStyle: "solid",
                                      backgroundColor: "rgba(255, 255, 255, 1)",
                                      backgroundRepeat: "no-repeat",
                                      backgroundSize: "contain",
                                      backgroundPosition: "left",
                                      paddingTop: 8,
                                      paddingRight: 8,
                                      paddingBottom: 8,
                                      paddingLeft: 8,
                                      alignItems: "center",
                                      textAlign: "-webkit-left",
                                      display: "block",
                                      fontFamily: "Poppins",
                                      fontWeight: 400,
                                      fontSize: "15px",
                                      color: "rgba(68, 68, 68, 1)",
                                    } as any
                                  }
                                ></AutoComplete>
                              </Form.Item>
                            </KCol>
                          </KRow>
                        </KCol>
                        <KCol
                          key="71241"
                          data-testid="Col2_25"
                          id="71241"
                          xs={12}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={4}
                          xxl={4}
                          order={0}
                          pull={0}
                          push={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 8,
                              paddingRight: 8,
                              paddingBottom: 8,
                              paddingLeft: 8,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              fontFamily: "Poppins",
                              fontWeight: 400,
                              fontSize: "15px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <Label
                            key="259846"
                            data-testid="Label17"
                            id="259846"
                            value={ReactSystemFunctions.translate(
                              this.ml,
                              259846,
                              "value",
                              this.defaultML
                            )}
                            writingMode="horizontal"
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                alignItems: "center",
                                textAlign: "-webkit-left",
                                display: "inline",
                                fontFamily: "Poppins",
                                fontWeight: 400,
                                fontSize: "15px",
                                color: "rgba(68, 68, 68, 1)",
                              } as any
                            }
                          ></Label>
                          <Label
                            key="520444"
                            data-testid="Label8"
                            id="520444"
                            value={ReactSystemFunctions.translate(
                              this.ml,
                              520444,
                              "value",
                              this.defaultML
                            )}
                            writingMode="horizontal"
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                alignItems: "center",
                                textAlign: "-webkit-left",
                                display: "inline",
                                fontFamily: "Poppins",
                                fontWeight: 400,
                                fontSize: "15px",
                                color: "rgba(68, 68, 68, 1)",
                              } as any
                            }
                          ></Label>
                        </KCol>
                        <KCol
                          key="208030"
                          data-testid="Col17"
                          id="208030"
                          xs={12}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={8}
                          xxl={8}
                          order={0}
                          pull={0}
                          push={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 8,
                              paddingRight: 8,
                              paddingBottom: 8,
                              paddingLeft: 8,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              fontFamily: "Poppins",
                              fontWeight: 400,
                              fontSize: "15px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <KRow
                            key="197177"
                            data-testid="Row37"
                            id="197177"
                            align="top"
                            justify="start"
                            horizontalGutter={0}
                            verticalGutter={0}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                alignItems: "flex-start",
                                textAlign: "-webkit-left",
                                fontFamily: "Poppins",
                                fontWeight: 400,
                                fontSize: "15px",
                                color: "rgba(68, 68, 68, 1)",
                              } as any
                            }
                          >
                            <KCol
                              key="797257"
                              data-testid="Col64_0"
                              id="797257"
                              xs={24}
                              sm={24}
                              md={24}
                              lg={24}
                              xl={6}
                              xxl={6}
                              order={0}
                              pull={0}
                              push={0}
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  paddingTop: 0,
                                  paddingRight: 0,
                                  paddingBottom: 0,
                                  paddingLeft: 0,
                                  alignItems: "flex-start",
                                  textAlign: "-webkit-left",
                                  fontFamily: "Poppins",
                                  fontWeight: 400,
                                  fontSize: "15px",
                                  color: "rgba(68, 68, 68, 1)",
                                } as any
                              }
                            >
                              <Form.Item
                                className="kFormItem"
                                name="ucusform_284227_value"
                              >
                                <KSelectBox
                                  key="284227"
                                  data-testid="VarisUlke"
                                  id="284227"
                                  onChange={(e?: any) => {
                                    if (e && e.stopPropagation)
                                      e.stopPropagation();
                                    this.UcusFormComponent_284227_onChange();
                                  }}
                                  kuikaRef={
                                    this
                                      .ucusform_284227_value_kuikaAutoCompleteRef
                                  }
                                  options={this.state.UlkeListe}
                                  placeholder={ReactSystemFunctions.translate(
                                    this.ml,
                                    284227,
                                    "placeholder",
                                    this.defaultML
                                  )}
                                  allowClear={false}
                                  autoClearSearchValue={true}
                                  showSearch={true}
                                  widthType="fill"
                                  containsNullItem={false}
                                  sortBy="none"
                                  datavaluefield="code"
                                  datatextfield="name"
                                  style={
                                    {
                                      borderTopLeftRadius: 8,
                                      borderTopRightRadius: 8,
                                      borderBottomRightRadius: 8,
                                      borderBottomLeftRadius: 8,
                                      borderTopWidth: 1,
                                      borderRightWidth: 1,
                                      borderBottomWidth: 1,
                                      borderLeftWidth: 1,
                                      borderColor: "rgba(218, 218, 218, 1)",
                                      borderStyle: "solid",
                                      backgroundColor: "rgba(255, 255, 255, 1)",
                                      backgroundRepeat: "no-repeat",
                                      backgroundSize: "contain",
                                      backgroundPosition: "left",
                                      paddingTop: 8,
                                      paddingRight: 8,
                                      paddingBottom: 8,
                                      paddingLeft: 8,
                                      alignItems: "center",
                                      textAlign: "-webkit-left",
                                      display: "block",
                                      fontFamily: "Poppins",
                                      fontWeight: 400,
                                      fontSize: "15px",
                                      color: "rgba(68, 68, 68, 1)",
                                    } as any
                                  }
                                ></KSelectBox>
                              </Form.Item>
                            </KCol>
                            <KCol
                              key="180539"
                              data-testid="Col64_1"
                              id="180539"
                              xs={24}
                              sm={24}
                              md={24}
                              lg={24}
                              xl={18}
                              xxl={18}
                              order={0}
                              pull={0}
                              push={0}
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  paddingTop: 0,
                                  paddingRight: 0,
                                  paddingBottom: 0,
                                  paddingLeft: 0,
                                  alignItems: "flex-start",
                                  textAlign: "-webkit-left",
                                  fontFamily: "Poppins",
                                  fontWeight: 400,
                                  fontSize: "15px",
                                  color: "rgba(68, 68, 68, 1)",
                                } as any
                              }
                            >
                              <Form.Item
                                className="kFormItem"
                                name="ucusform_554090_value"
                              >
                                <AutoComplete
                                  key="554090"
                                  data-testid="VarisNokta"
                                  id="554090"
                                  onSearch={(e?: any) => {
                                    if (e && e.stopPropagation)
                                      e.stopPropagation();
                                    this.UcusFormComponent_554090_onSearch();
                                  }}
                                  kuikaRef={
                                    this
                                      .ucusform_554090_value_kuikaAutoCompleteRef
                                  }
                                  options={this.state.VarisNoktaListe}
                                  placeholder={ReactSystemFunctions.translate(
                                    this.ml,
                                    554090,
                                    "placeholder",
                                    this.defaultML
                                  )}
                                  allowClear={false}
                                  searchable={true}
                                  datavaluefield="icaoCode"
                                  datatextfield="secim"
                                  style={
                                    {
                                      borderTopLeftRadius: 8,
                                      borderTopRightRadius: 8,
                                      borderBottomRightRadius: 8,
                                      borderBottomLeftRadius: 8,
                                      borderTopWidth: 1,
                                      borderRightWidth: 1,
                                      borderBottomWidth: 1,
                                      borderLeftWidth: 1,
                                      borderColor: "rgba(218, 218, 218, 1)",
                                      borderStyle: "solid",
                                      backgroundColor: "rgba(255, 255, 255, 1)",
                                      backgroundRepeat: "no-repeat",
                                      backgroundSize: "contain",
                                      backgroundPosition: "left",
                                      paddingTop: 8,
                                      paddingRight: 8,
                                      paddingBottom: 8,
                                      paddingLeft: 8,
                                      alignItems: "center",
                                      textAlign: "-webkit-left",
                                      display: "block",
                                      fontFamily: "Poppins",
                                      fontWeight: 400,
                                      fontSize: "15px",
                                      color: "rgba(68, 68, 68, 1)",
                                    } as any
                                  }
                                ></AutoComplete>
                              </Form.Item>
                            </KCol>
                          </KRow>
                        </KCol>
                      </KRow>
                    </KCol>
                  </KRow>
                  <KRow
                    key="227059"
                    data-testid="Row5"
                    id="227059"
                    editability={this.state.isComp227059Enabled}
                    align="top"
                    justify="start"
                    horizontalGutter={0}
                    verticalGutter={0}
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        paddingTop: 0,
                        paddingRight: 0,
                        paddingBottom: 0,
                        paddingLeft: 0,
                        alignItems: "flex-start",
                        textAlign: "-webkit-left",
                        fontFamily: "Poppins",
                        fontWeight: 400,
                        fontSize: "15px",
                        color: "rgba(68, 68, 68, 1)",
                      } as any
                    }
                  >
                    <KCol
                      key="915844"
                      data-testid="Col2"
                      id="915844"
                      xs={24}
                      sm={24}
                      md={24}
                      lg={24}
                      xl={24}
                      xxl={24}
                      order={0}
                      pull={0}
                      push={0}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 3,
                          paddingRight: 8,
                          paddingBottom: 3,
                          paddingLeft: 8,
                          alignItems: "flex-start",
                          textAlign: "-webkit-left",
                          fontFamily: "Poppins",
                          fontWeight: 400,
                          fontSize: "15px",
                          color: "rgba(68, 68, 68, 1)",
                        } as any
                      }
                    >
                      <KRow
                        key="648567"
                        data-testid="Row3"
                        id="648567"
                        align="top"
                        justify="start"
                        horizontalGutter={0}
                        verticalGutter={0}
                        style={
                          {
                            borderTopLeftRadius: 8,
                            borderTopRightRadius: 8,
                            borderBottomRightRadius: 8,
                            borderBottomLeftRadius: 8,
                            backgroundColor: "rgba(255, 255, 255, 1)",
                            backgroundRepeat: "no-repeat",
                            backgroundSize: "contain",
                            backgroundPosition: "left",
                            paddingTop: 0,
                            paddingRight: 8,
                            paddingBottom: 0,
                            paddingLeft: 8,
                            alignItems: "flex-start",
                            textAlign: "-webkit-left",
                            fontFamily: "Poppins",
                            fontWeight: 400,
                            fontSize: "15px",
                            color: "rgba(68, 68, 68, 1)",
                          } as any
                        }
                      >
                        <KCol
                          key="917317"
                          data-testid="Col2_3"
                          id="917317"
                          xs={12}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={4}
                          xxl={4}
                          order={0}
                          pull={0}
                          push={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 8,
                              paddingRight: 8,
                              paddingBottom: 8,
                              paddingLeft: 8,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              fontFamily: "Poppins",
                              fontWeight: 400,
                              fontSize: "15px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <Label
                            key="497421"
                            data-testid="Label2"
                            id="497421"
                            value={ReactSystemFunctions.translate(
                              this.ml,
                              497421,
                              "value",
                              this.defaultML
                            )}
                            writingMode="horizontal"
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                alignItems: "center",
                                textAlign: "-webkit-left",
                                display: "inline",
                                fontFamily: "Poppins",
                                fontWeight: 400,
                                fontSize: "15px",
                                color: "rgba(68, 68, 68, 1)",
                              } as any
                            }
                          ></Label>
                        </KCol>
                        <KCol
                          key="666909"
                          data-testid="Col2_4"
                          id="666909"
                          xs={12}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={8}
                          xxl={8}
                          order={0}
                          pull={0}
                          push={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 8,
                              paddingRight: 8,
                              paddingBottom: 8,
                              paddingLeft: 8,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              fontFamily: "Poppins",
                              fontWeight: 400,
                              fontSize: "15px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <Form.Item
                            className="kFormItem"
                            name="ucusform_24259_value"
                          >
                            <KDatePicker
                              key="24259"
                              data-testid="MotorCalistirma"
                              id="24259"
                              kuikaRef={
                                this.ucusform_24259_value_kuikaDatetimeRef
                              }
                              placeholder={ReactSystemFunctions.translate(
                                this.ml,
                                24259,
                                "placeholder",
                                this.defaultML
                              )}
                              allowClear={true}
                              format="DD.MM.YYYY HH:mm"
                              use12Hours={false}
                              displayType="datetime"
                              returnDisplayValue={false}
                              style={
                                {
                                  borderTopLeftRadius: 8,
                                  borderTopRightRadius: 8,
                                  borderBottomRightRadius: 8,
                                  borderBottomLeftRadius: 8,
                                  borderTopWidth: 1,
                                  borderRightWidth: 1,
                                  borderBottomWidth: 1,
                                  borderLeftWidth: 1,
                                  borderColor: "rgba(218, 218, 218, 1)",
                                  borderStyle: "solid",
                                  backgroundColor: "rgba(255, 255, 255, 1)",
                                  backgroundRepeat: "no-repeat",
                                  backgroundSize: "contain",
                                  backgroundPosition: "left",
                                  paddingTop: 8,
                                  paddingRight: 8,
                                  paddingBottom: 8,
                                  paddingLeft: 8,
                                  alignItems: "center",
                                  textAlign: "-webkit-left",
                                  display: "block",
                                  fontFamily: "Poppins",
                                  fontWeight: 400,
                                  fontSize: "15px",
                                  color: "rgba(68, 68, 68, 1)",
                                } as any
                              }
                            ></KDatePicker>
                          </Form.Item>
                        </KCol>
                        <KCol
                          key="454681"
                          data-testid="Col2_5"
                          id="454681"
                          xs={12}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={4}
                          xxl={4}
                          order={0}
                          pull={0}
                          push={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 8,
                              paddingRight: 8,
                              paddingBottom: 8,
                              paddingLeft: 8,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              fontFamily: "Poppins",
                              fontWeight: 400,
                              fontSize: "15px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <Label
                            key="617128"
                            data-testid="Label3"
                            id="617128"
                            value={ReactSystemFunctions.translate(
                              this.ml,
                              617128,
                              "value",
                              this.defaultML
                            )}
                            writingMode="horizontal"
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                alignItems: "center",
                                textAlign: "-webkit-left",
                                display: "inline",
                                fontFamily: "Poppins",
                                fontWeight: 400,
                                fontSize: "15px",
                                color: "rgba(68, 68, 68, 1)",
                              } as any
                            }
                          ></Label>
                        </KCol>
                        <KCol
                          key="961951"
                          data-testid="Col6"
                          id="961951"
                          xs={12}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={8}
                          xxl={8}
                          order={0}
                          pull={0}
                          push={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 8,
                              paddingRight: 8,
                              paddingBottom: 8,
                              paddingLeft: 8,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              fontFamily: "Poppins",
                              fontWeight: 400,
                              fontSize: "15px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <Form.Item
                            className="kFormItem"
                            name="ucusform_348523_value"
                          >
                            <KDatePicker
                              key="348523"
                              data-testid="MotorSusturma"
                              id="348523"
                              kuikaRef={
                                this.ucusform_348523_value_kuikaDatetimeRef
                              }
                              placeholder={ReactSystemFunctions.translate(
                                this.ml,
                                348523,
                                "placeholder",
                                this.defaultML
                              )}
                              allowClear={true}
                              format="DD.MM.YYYY HH:mm"
                              use12Hours={false}
                              displayType="datetime"
                              returnDisplayValue={false}
                              style={
                                {
                                  borderTopLeftRadius: 8,
                                  borderTopRightRadius: 8,
                                  borderBottomRightRadius: 8,
                                  borderBottomLeftRadius: 8,
                                  borderTopWidth: 1,
                                  borderRightWidth: 1,
                                  borderBottomWidth: 1,
                                  borderLeftWidth: 1,
                                  borderColor: "rgba(218, 218, 218, 1)",
                                  borderStyle: "solid",
                                  backgroundColor: "rgba(255, 255, 255, 1)",
                                  backgroundRepeat: "no-repeat",
                                  backgroundSize: "contain",
                                  backgroundPosition: "left",
                                  paddingTop: 8,
                                  paddingRight: 8,
                                  paddingBottom: 8,
                                  paddingLeft: 8,
                                  alignItems: "center",
                                  textAlign: "-webkit-left",
                                  display: "block",
                                  fontFamily: "Poppins",
                                  fontWeight: 400,
                                  fontSize: "15px",
                                  color: "rgba(68, 68, 68, 1)",
                                } as any
                              }
                            ></KDatePicker>
                          </Form.Item>
                        </KCol>
                      </KRow>
                    </KCol>
                  </KRow>
                  <KRow
                    key="845007"
                    data-testid="Row21"
                    id="845007"
                    editability={this.state.isComp845007Enabled}
                    align="top"
                    justify="start"
                    horizontalGutter={0}
                    verticalGutter={0}
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        paddingTop: 0,
                        paddingRight: 0,
                        paddingBottom: 0,
                        paddingLeft: 0,
                        alignItems: "flex-start",
                        textAlign: "-webkit-left",
                        fontFamily: "Poppins",
                        fontWeight: 400,
                        fontSize: "15px",
                        color: "rgba(68, 68, 68, 1)",
                      } as any
                    }
                  >
                    <KCol
                      key="350152"
                      data-testid="Col8"
                      id="350152"
                      xs={24}
                      sm={24}
                      md={24}
                      lg={24}
                      xl={24}
                      xxl={24}
                      order={0}
                      pull={0}
                      push={0}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 3,
                          paddingRight: 8,
                          paddingBottom: 3,
                          paddingLeft: 8,
                          alignItems: "flex-start",
                          textAlign: "-webkit-left",
                          fontFamily: "Poppins",
                          fontWeight: 400,
                          fontSize: "15px",
                          color: "rgba(68, 68, 68, 1)",
                        } as any
                      }
                    >
                      <KRow
                        key="509424"
                        data-testid="Row22"
                        id="509424"
                        align="top"
                        justify="start"
                        horizontalGutter={0}
                        verticalGutter={0}
                        style={
                          {
                            borderTopLeftRadius: 8,
                            borderTopRightRadius: 8,
                            borderBottomRightRadius: 8,
                            borderBottomLeftRadius: 8,
                            backgroundColor: "rgba(255, 255, 255, 1)",
                            backgroundRepeat: "no-repeat",
                            backgroundSize: "contain",
                            backgroundPosition: "left",
                            paddingTop: 0,
                            paddingRight: 8,
                            paddingBottom: 0,
                            paddingLeft: 8,
                            alignItems: "flex-start",
                            textAlign: "-webkit-left",
                            fontFamily: "Poppins",
                            fontWeight: 400,
                            fontSize: "15px",
                            color: "rgba(68, 68, 68, 1)",
                          } as any
                        }
                      >
                        <KCol
                          key="687620"
                          data-testid="Col2_16"
                          id="687620"
                          xs={12}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={4}
                          xxl={4}
                          order={0}
                          pull={0}
                          push={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 8,
                              paddingRight: 8,
                              paddingBottom: 8,
                              paddingLeft: 8,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              fontFamily: "Poppins",
                              fontWeight: 400,
                              fontSize: "15px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <Label
                            key="585990"
                            data-testid="Label4"
                            id="585990"
                            value={ReactSystemFunctions.translate(
                              this.ml,
                              585990,
                              "value",
                              this.defaultML
                            )}
                            writingMode="horizontal"
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                alignItems: "center",
                                textAlign: "-webkit-left",
                                display: "inline",
                                fontFamily: "Poppins",
                                fontWeight: 400,
                                fontSize: "15px",
                                color: "rgba(68, 68, 68, 1)",
                              } as any
                            }
                          ></Label>
                        </KCol>
                        <KCol
                          key="249271"
                          data-testid="Col2_17"
                          id="249271"
                          xs={12}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={8}
                          xxl={8}
                          order={0}
                          pull={0}
                          push={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 8,
                              paddingRight: 8,
                              paddingBottom: 8,
                              paddingLeft: 8,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              fontFamily: "Poppins",
                              fontWeight: 400,
                              fontSize: "15px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <Form.Item
                            className="kFormItem"
                            name="ucusform_361964_value"
                          >
                            <NumberInput
                              key="361964"
                              data-testid="ToLanding"
                              id="361964"
                              decimalSeparator="."
                              decimalScale={2}
                              disabled={false}
                              placeholder={ReactSystemFunctions.translate(
                                this.ml,
                                361964,
                                "placeholder",
                                this.defaultML
                              )}
                              fixedDecimalScale={true}
                              allowNegative={false}
                              allowEmptyFormatting={false}
                              isThousandSeperatorOn={false}
                              max={9999999}
                              min={0}
                              style={
                                {
                                  borderTopLeftRadius: 8,
                                  borderTopRightRadius: 8,
                                  borderBottomRightRadius: 8,
                                  borderBottomLeftRadius: 8,
                                  borderTopWidth: 1,
                                  borderRightWidth: 1,
                                  borderBottomWidth: 1,
                                  borderLeftWidth: 1,
                                  borderColor: "rgba(218, 218, 218, 1)",
                                  borderStyle: "solid",
                                  backgroundColor: "rgba(255, 255, 255, 1)",
                                  backgroundRepeat: "no-repeat",
                                  backgroundSize: "contain",
                                  backgroundPosition: "left",
                                  paddingTop: 8,
                                  paddingRight: 8,
                                  paddingBottom: 8,
                                  paddingLeft: 8,
                                  alignItems: "center",
                                  textAlign: "-webkit-right",
                                  display: "block",
                                  fontFamily: "Poppins",
                                  fontWeight: 400,
                                  fontSize: "15px",
                                  color: "rgba(68, 68, 68, 1)",
                                } as any
                              }
                            ></NumberInput>
                          </Form.Item>
                        </KCol>
                        <KCol
                          key="375870"
                          data-testid="Col2_27"
                          id="375870"
                          xs={12}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={4}
                          xxl={4}
                          order={0}
                          pull={0}
                          push={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 8,
                              paddingRight: 8,
                              paddingBottom: 8,
                              paddingLeft: 8,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              fontFamily: "Poppins",
                              fontWeight: 400,
                              fontSize: "15px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <Label
                            key="991673"
                            data-testid="Label5"
                            id="991673"
                            value={ReactSystemFunctions.translate(
                              this.ml,
                              991673,
                              "value",
                              this.defaultML
                            )}
                            writingMode="horizontal"
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                alignItems: "center",
                                textAlign: "-webkit-left",
                                display: "inline",
                                fontFamily: "Poppins",
                                fontWeight: 400,
                                fontSize: "15px",
                                color: "rgba(68, 68, 68, 1)",
                              } as any
                            }
                          ></Label>
                        </KCol>
                        <KCol
                          key="370607"
                          data-testid="Col2_29"
                          id="370607"
                          xs={12}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={8}
                          xxl={8}
                          order={0}
                          pull={0}
                          push={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 8,
                              paddingRight: 8,
                              paddingBottom: 8,
                              paddingLeft: 8,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              fontFamily: "Poppins",
                              fontWeight: 400,
                              fontSize: "15px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <Form.Item
                            className="kFormItem"
                            name="ucusform_403791_value"
                          >
                            <NumberInput
                              key="403791"
                              data-testid="SonTaco"
                              id="403791"
                              editability={this.state.isComp403791Enabled}
                              decimalSeparator="."
                              decimalScale={2}
                              disabled={false}
                              placeholder={ReactSystemFunctions.translate(
                                this.ml,
                                403791,
                                "placeholder",
                                this.defaultML
                              )}
                              fixedDecimalScale={false}
                              allowNegative={true}
                              allowEmptyFormatting={false}
                              isThousandSeperatorOn={true}
                              style={
                                {
                                  borderTopLeftRadius: 8,
                                  borderTopRightRadius: 8,
                                  borderBottomRightRadius: 8,
                                  borderBottomLeftRadius: 8,
                                  borderTopWidth: 1,
                                  borderRightWidth: 1,
                                  borderBottomWidth: 1,
                                  borderLeftWidth: 1,
                                  borderColor: "rgba(218, 218, 218, 1)",
                                  borderStyle: "solid",
                                  backgroundColor: "rgba(255, 255, 255, 1)",
                                  backgroundRepeat: "no-repeat",
                                  backgroundSize: "contain",
                                  backgroundPosition: "left",
                                  paddingTop: 8,
                                  paddingRight: 8,
                                  paddingBottom: 8,
                                  paddingLeft: 8,
                                  alignItems: "center",
                                  textAlign: "-webkit-right",
                                  display: "block",
                                  fontFamily: "Poppins",
                                  fontWeight: 400,
                                  fontSize: "15px",
                                  color: "rgba(68, 68, 68, 1)",
                                } as any
                              }
                            ></NumberInput>
                          </Form.Item>
                        </KCol>
                      </KRow>
                    </KCol>
                  </KRow>
                  <KRow
                    key="505477"
                    data-testid="Row12"
                    id="505477"
                    align="top"
                    justify="start"
                    horizontalGutter={0}
                    verticalGutter={0}
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        paddingTop: 0,
                        paddingRight: 0,
                        paddingBottom: 0,
                        paddingLeft: 0,
                        alignItems: "flex-start",
                        textAlign: "-webkit-left",
                        fontFamily: "Poppins",
                        fontWeight: 400,
                        fontSize: "15px",
                        color: "rgba(68, 68, 68, 1)",
                      } as any
                    }
                  >
                    <KCol
                      key="247000"
                      data-testid="Col19"
                      id="247000"
                      xs={24}
                      sm={24}
                      md={24}
                      lg={24}
                      xl={24}
                      xxl={24}
                      order={0}
                      pull={0}
                      push={0}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 3,
                          paddingRight: 8,
                          paddingBottom: 3,
                          paddingLeft: 8,
                          alignItems: "flex-start",
                          textAlign: "-webkit-left",
                          fontFamily: "Poppins",
                          fontWeight: 400,
                          fontSize: "15px",
                          color: "rgba(68, 68, 68, 1)",
                        } as any
                      }
                    >
                      <KRow
                        key="380433"
                        data-testid="Row23"
                        id="380433"
                        align="top"
                        justify="start"
                        horizontalGutter={0}
                        verticalGutter={0}
                        style={
                          {
                            borderTopLeftRadius: 8,
                            borderTopRightRadius: 8,
                            borderBottomRightRadius: 8,
                            borderBottomLeftRadius: 8,
                            backgroundColor: "rgba(255, 255, 255, 1)",
                            backgroundRepeat: "no-repeat",
                            backgroundSize: "contain",
                            backgroundPosition: "left",
                            paddingTop: 0,
                            paddingRight: 8,
                            paddingBottom: 0,
                            paddingLeft: 8,
                            alignItems: "flex-start",
                            textAlign: "-webkit-left",
                            fontFamily: "Poppins",
                            fontWeight: 400,
                            fontSize: "15px",
                            color: "rgba(68, 68, 68, 1)",
                          } as any
                        }
                      >
                        <KCol
                          key="935762"
                          data-testid="Col2_31"
                          id="935762"
                          xs={24}
                          sm={24}
                          md={24}
                          lg={24}
                          xl={4}
                          xxl={4}
                          order={0}
                          pull={0}
                          push={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 8,
                              paddingRight: 8,
                              paddingBottom: 0,
                              paddingLeft: 8,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              fontFamily: "Poppins",
                              fontWeight: 400,
                              fontSize: "15px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <HorizontalStack
                            key="718288"
                            data-testid="HorizontalStack4"
                            id="718288"
                            direction="horizontal"
                            size={22}
                            overflowX="auto"
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                alignItems: "center",
                                fontFamily: "Poppins",
                                fontWeight: 400,
                                fontSize: "15px",
                                color: "rgba(68, 68, 68, 1)",
                              } as any
                            }
                          >
                            <Label
                              key="838670"
                              data-testid="Label14"
                              id="838670"
                              value={ReactSystemFunctions.translate(
                                this.ml,
                                838670,
                                "value",
                                this.defaultML
                              )}
                              writingMode="horizontal"
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  paddingTop: 0,
                                  paddingRight: 0,
                                  paddingBottom: 0,
                                  paddingLeft: 0,
                                  alignItems: "center",
                                  textAlign: "-webkit-left",
                                  display: "inline",
                                  fontFamily: "Poppins",
                                  fontWeight: 400,
                                  fontSize: "15px",
                                  color: "rgba(68, 68, 68, 1)",
                                } as any
                              }
                            ></Label>
                            <Form.Item
                              className="kFormItem"
                              name="ucusform_575039_value"
                            >
                              <Currency
                                key="575039"
                                data-testid="YolcuAdet"
                                id="575039"
                                visibility={this.state.isComp575039Visible}
                                decimalSeparator="."
                                disabled={false}
                                placeholder={ReactSystemFunctions.translate(
                                  this.ml,
                                  575039,
                                  "placeholder",
                                  this.defaultML
                                )}
                                decimalScale={0}
                                fixedDecimalScale={false}
                                allowNegative={true}
                                suffix="&nbsp;Adet"
                                displayType="input"
                                style={
                                  {
                                    borderTopLeftRadius: 8,
                                    borderTopRightRadius: 8,
                                    borderBottomRightRadius: 8,
                                    borderBottomLeftRadius: 8,
                                    borderTopWidth: 1,
                                    borderRightWidth: 1,
                                    borderBottomWidth: 1,
                                    borderLeftWidth: 1,
                                    borderColor: "rgba(218, 218, 218, 1)",
                                    borderStyle: "solid",
                                    backgroundColor: "rgba(255, 255, 255, 1)",
                                    backgroundRepeat: "no-repeat",
                                    backgroundSize: "contain",
                                    backgroundPosition: "left",
                                    paddingTop: 8,
                                    paddingRight: 8,
                                    paddingBottom: 8,
                                    paddingLeft: 8,
                                    width: "100px",
                                    alignItems: "center",
                                    textAlign: "-webkit-left",
                                    display: "block",
                                    fontFamily: "Poppins",
                                    fontWeight: 400,
                                    fontSize: "15px",
                                    color: "rgba(68, 68, 68, 1)",
                                  } as any
                                }
                              ></Currency>
                            </Form.Item>
                            <Button
                              key="641052"
                              data-testid="YolcuEkle"
                              id="641052"
                              onClick={(e?: any) => {
                                if (e && e.stopPropagation) e.stopPropagation();
                                this.UcusFormComponent_641052_onClick();
                              }}
                              showCursorPointer
                              visibility={this.state.isComp641052Visible}
                              label={ReactSystemFunctions.translate(
                                this.ml,
                                641052,
                                "label",
                                this.defaultML
                              )}
                              size="middle"
                              loading={false}
                              ghost={false}
                              block={false}
                              htmlType="button"
                              icon="add"
                              iconPosition="left"
                              danger={false}
                              style={
                                {
                                  borderTopLeftRadius: 8,
                                  borderTopRightRadius: 8,
                                  borderBottomRightRadius: 8,
                                  borderBottomLeftRadius: 8,
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  backgroundColor: "rgba(3, 88, 255, 1)",
                                  backgroundRepeat: "no-repeat",
                                  backgroundSize: "contain",
                                  backgroundPosition: "left",
                                  paddingTop: 8,
                                  paddingRight: 16,
                                  paddingBottom: 8,
                                  paddingLeft: 16,
                                  alignItems: "center",
                                  textAlign: "-webkit-center",
                                  display: "block",
                                  fontFamily: "Poppins",
                                  fontWeight: 500,
                                  fontSize: "16px",
                                  color: "rgba(255, 255, 255, 1)",
                                  lineHeight: "22px",
                                } as any
                              }
                            ></Button>
                          </HorizontalStack>
                        </KCol>
                        <KCol
                          key="212873"
                          data-testid="Col2_26"
                          id="212873"
                          xs={24}
                          sm={24}
                          md={24}
                          lg={24}
                          xl={24}
                          xxl={24}
                          order={0}
                          pull={0}
                          push={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 8,
                              paddingLeft: 0,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              fontFamily: "Poppins",
                              fontWeight: 400,
                              fontSize: "15px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <KTable
                            key="990298"
                            data-testid="TblYolcular"
                            id="990298"
                            kuikaRef={this.ucusform_990298_value_kuikaTableRef}
                            form={this.props.form}
                            screenId="83fd6de0-fc3c-4e49-9dae-d9f2dcd1e499"
                            dataSource={this.state.YolcuTmpListe}
                            size="middle"
                            bordered={true}
                            loading={false}
                            rowKey="id"
                            transformedOnMobileResolution={false}
                            hideHeaderOnMobileResolution={false}
                            showHeader={true}
                            fixedHeader={false}
                            editable={true}
                            tableWidthMode="fit"
                            globalSearch={false}
                            searchable={false}
                            shouldSearchOnChange={true}
                            searchDelay={200}
                            sorter={false}
                            filtering={false}
                            pagination={false}
                            pageSize={10}
                            showSizeChanger={false}
                            paginationSelectedTextColor="#246eff"
                            paginationUnselectedTextColor="#000"
                            columnChooser={false}
                            resizableColumns={false}
                            striped={true}
                            stripedColor="#F5F7FA"
                            rowHoverBgColor="#fafafa"
                            insertRowActive={false}
                            insertRowPosition="top"
                            showNoDataFound={true}
                            nodatafoundmessage={ReactSystemFunctions.translate(
                              this.ml,
                              990298,
                              "nodatafoundmessage",
                              this.defaultML
                            )}
                            multiSelect={false}
                            multiSelectScope="page"
                            export={false}
                            editableAlwaysActive={false}
                            showRowNumbers={false}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                fontFamily: "Poppins",
                                fontWeight: 400,
                                fontSize: "15px",
                                color: "rgba(68, 68, 68, 1)",
                              } as any
                            }
                          >
                            <KTableHeader
                              key="708573"
                              data-testid="TableHeader1_0"
                              id="708573"
                              hideOnMobileResolution={false}
                              textDirection="Default"
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  fontFamily: "Poppins",
                                  fontWeight: 400,
                                  fontSize: "14px",
                                  color: "rgba(155, 155, 155, 1)",
                                  lineHeight: "20px",
                                } as any
                              }
                            ></KTableHeader>
                            <KTableRow
                              key="965161"
                              data-testid="TableRow1_0"
                              id="965161"
                              hoverFontColor="red"
                              hoverBgColor="#F5F5F5"
                              style={
                                {
                                  borderTopWidth: 1,
                                  borderRightWidth: 1,
                                  borderBottomWidth: 1,
                                  borderLeftWidth: 1,
                                  borderColor: "rgba(218, 218, 218, 1)",
                                  borderStyle: "solid",
                                  paddingTop: 0,
                                  paddingRight: 0,
                                  paddingBottom: 0,
                                  paddingLeft: 0,
                                  fontFamily: "Poppins",
                                  fontWeight: 400,
                                  fontSize: "15px",
                                  color: "rgba(68, 68, 68, 1)",
                                } as any
                              }
                            >
                              <KTableColumn
                                key="489617"
                                data-testid="TableTemplateColumn3"
                                id="489617"
                                title={ReactSystemFunctions.translate(
                                  this.ml,
                                  489617,
                                  "title",
                                  this.defaultML
                                )}
                                alwaysVisibleOnMobileResolution={false}
                                hideFiltering={false}
                                hideSorting={false}
                                hideSearch={false}
                                footerOptions="none"
                                footerFontSize={14}
                                footerFontColor="rgb(68, 68, 68)"
                                excludeFromExport={false}
                                footerFontWeight="Regular"
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 0,
                                    paddingRight: 8,
                                    paddingBottom: 0,
                                    paddingLeft: 8,
                                    alignItems: "center",
                                    textAlign: "-webkit-left",
                                    fontFamily: "Poppins",
                                    fontWeight: 400,
                                    fontSize: "15px",
                                    color: "rgba(68, 68, 68, 1)",
                                  } as any
                                }
                              >
                                <Label
                                  key="115207"
                                  data-testid="lblKayitli"
                                  id="115207"
                                  visibility={this.state.isComp115207Visible}
                                  visibilityCondition={(rowData: object) =>
                                    ReactSystemFunctions.isEqualTo(
                                      rowData.isManuel,
                                      "false"
                                    )
                                  }
                                  value={ReactSystemFunctions.translate(
                                    this.ml,
                                    115207,
                                    "value",
                                    this.defaultML
                                  )}
                                  writingMode="horizontal"
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      paddingTop: 0,
                                      paddingRight: 0,
                                      paddingBottom: 0,
                                      paddingLeft: 0,
                                      alignItems: "center",
                                      textAlign: "-webkit-left",
                                      display: "inline",
                                      fontFamily: "Poppins",
                                      fontWeight: 400,
                                      fontSize: "15px",
                                      color: "rgba(68, 68, 68, 1)",
                                    } as any
                                  }
                                ></Label>
                                <Label
                                  key="861472"
                                  data-testid="lblKayitsiz"
                                  id="861472"
                                  visibility={this.state.isComp861472Visible}
                                  visibilityCondition={(rowData: object) =>
                                    ReactSystemFunctions.isEqualTo(
                                      rowData.isManuel,
                                      "true"
                                    )
                                  }
                                  value={ReactSystemFunctions.translate(
                                    this.ml,
                                    861472,
                                    "value",
                                    this.defaultML
                                  )}
                                  writingMode="horizontal"
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      paddingTop: 0,
                                      paddingRight: 0,
                                      paddingBottom: 0,
                                      paddingLeft: 0,
                                      alignItems: "center",
                                      textAlign: "-webkit-left",
                                      display: "inline",
                                      fontFamily: "Poppins",
                                      fontWeight: 400,
                                      fontSize: "15px",
                                      color: "rgba(68, 68, 68, 1)",
                                    } as any
                                  }
                                ></Label>
                              </KTableColumn>
                              <KTableColumn
                                key="937170"
                                data-testid="TableDefaultColumn1_0"
                                id="937170"
                                title={ReactSystemFunctions.translate(
                                  this.ml,
                                  937170,
                                  "title",
                                  this.defaultML
                                )}
                                isEditableColumn={true}
                                alwaysVisibleOnMobileResolution={false}
                                hideFiltering={false}
                                hideSorting={false}
                                hideSearch={false}
                                footerOptions="none"
                                footerFontSize={14}
                                footerFontWeight="Regular"
                                footerFontColor="rgb(68, 68, 68)"
                                excludeFromExport={false}
                                dateSearchFormat="DD.MM.YYYY"
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 0,
                                    paddingRight: 8,
                                    paddingBottom: 0,
                                    paddingLeft: 8,
                                    alignItems: "center",
                                    textAlign: "-webkit-left",
                                    fontFamily: "Poppins",
                                    fontWeight: 400,
                                    fontSize: "15px",
                                    color: "rgba(68, 68, 68, 1)",
                                  } as any
                                }
                              >
                                <Label
                                  key="707202"
                                  data-testid="Label15_1"
                                  id="707202"
                                  value="[datafield:adSoyad]"
                                  writingMode="horizontal"
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      paddingTop: 0,
                                      paddingRight: 0,
                                      paddingBottom: 0,
                                      paddingLeft: 0,
                                      alignItems: "center",
                                      textAlign: "-webkit-left",
                                      display: "inline",
                                      fontFamily: "Poppins",
                                      fontWeight: 400,
                                      fontSize: "15px",
                                      color: "rgba(68, 68, 68, 1)",
                                    } as any
                                  }
                                ></Label>
                              </KTableColumn>
                              <KTableColumn
                                key="128889"
                                data-testid="TableTemplateColumn1_0"
                                id="128889"
                                title={ReactSystemFunctions.translate(
                                  this.ml,
                                  128889,
                                  "title",
                                  this.defaultML
                                )}
                                alwaysVisibleOnMobileResolution={false}
                                hideFiltering={false}
                                hideSorting={false}
                                hideSearch={false}
                                footerOptions="none"
                                footerFontSize={14}
                                footerFontColor="rgb(68, 68, 68)"
                                excludeFromExport={false}
                                footerFontWeight="Regular"
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 0,
                                    paddingRight: 8,
                                    paddingBottom: 0,
                                    paddingLeft: 8,
                                    alignItems: "center",
                                    textAlign: "-webkit-left",
                                    fontFamily: "Poppins",
                                    fontWeight: 400,
                                    fontSize: "15px",
                                    color: "rgba(68, 68, 68, 1)",
                                  } as any
                                }
                              >
                                <Label
                                  key="370804"
                                  data-testid="Label15_0"
                                  id="370804"
                                  value="[datafield:agirlik]"
                                  writingMode="horizontal"
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      paddingTop: 0,
                                      paddingRight: 0,
                                      paddingBottom: 0,
                                      paddingLeft: 0,
                                      alignItems: "center",
                                      textAlign: "-webkit-left",
                                      display: "inline",
                                      fontFamily: "Poppins",
                                      fontWeight: 400,
                                      fontSize: "15px",
                                      color: "rgba(68, 68, 68, 1)",
                                    } as any
                                  }
                                ></Label>
                              </KTableColumn>
                              <KTableColumn
                                key="474346"
                                data-testid="TableDefaultColumn2"
                                id="474346"
                                title={ReactSystemFunctions.translate(
                                  this.ml,
                                  474346,
                                  "title",
                                  this.defaultML
                                )}
                                isEditableColumn={true}
                                alwaysVisibleOnMobileResolution={false}
                                hideFiltering={false}
                                hideSorting={false}
                                hideSearch={false}
                                footerOptions="none"
                                footerFontSize={14}
                                footerFontWeight="Regular"
                                footerFontColor="rgb(68, 68, 68)"
                                excludeFromExport={false}
                                dateSearchFormat="DD.MM.YYYY"
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 0,
                                    paddingRight: 8,
                                    paddingBottom: 0,
                                    paddingLeft: 8,
                                    alignItems: "center",
                                    textAlign: "-webkit-left",
                                    fontFamily: "Poppins",
                                    fontWeight: 400,
                                    fontSize: "15px",
                                    color: "rgba(68, 68, 68, 1)",
                                  } as any
                                }
                              >
                                <Label
                                  key="292751"
                                  data-testid="Label20_0"
                                  id="292751"
                                  value="[datafield:bagajAdet]"
                                  writingMode="horizontal"
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      paddingTop: 0,
                                      paddingRight: 0,
                                      paddingBottom: 0,
                                      paddingLeft: 0,
                                      alignItems: "center",
                                      textAlign: "-webkit-left",
                                      display: "inline",
                                      fontFamily: "Poppins",
                                      fontWeight: 400,
                                      fontSize: "15px",
                                      color: "rgba(68, 68, 68, 1)",
                                    } as any
                                  }
                                ></Label>
                              </KTableColumn>
                              <KTableColumn
                                key="382877"
                                data-testid="TableDefaultColumn3"
                                id="382877"
                                title={ReactSystemFunctions.translate(
                                  this.ml,
                                  382877,
                                  "title",
                                  this.defaultML
                                )}
                                isEditableColumn={true}
                                alwaysVisibleOnMobileResolution={false}
                                hideFiltering={false}
                                hideSorting={false}
                                hideSearch={false}
                                footerOptions="none"
                                footerFontSize={14}
                                footerFontWeight="Regular"
                                footerFontColor="rgb(68, 68, 68)"
                                excludeFromExport={false}
                                dateSearchFormat="DD.MM.YYYY"
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 0,
                                    paddingRight: 8,
                                    paddingBottom: 0,
                                    paddingLeft: 8,
                                    alignItems: "center",
                                    textAlign: "-webkit-left",
                                    fontFamily: "Poppins",
                                    fontWeight: 400,
                                    fontSize: "15px",
                                    color: "rgba(68, 68, 68, 1)",
                                  } as any
                                }
                              >
                                <Label
                                  key="625246"
                                  data-testid="Label21_0"
                                  id="625246"
                                  value="[datafield:bagajAgirlik]"
                                  writingMode="horizontal"
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      paddingTop: 0,
                                      paddingRight: 0,
                                      paddingBottom: 0,
                                      paddingLeft: 0,
                                      alignItems: "center",
                                      textAlign: "-webkit-left",
                                      display: "inline",
                                      fontFamily: "Poppins",
                                      fontWeight: 400,
                                      fontSize: "15px",
                                      color: "rgba(68, 68, 68, 1)",
                                    } as any
                                  }
                                ></Label>
                              </KTableColumn>
                              <KTableColumn
                                key="252521"
                                data-testid="TableTemplateColumn2"
                                id="252521"
                                visibility={this.state.isComp252521Visible}
                                visibilityCondition={(rowData: object) =>
                                  ReactSystemFunctions.isEqualTo(
                                    this.state.UcusGorunumAyarla?.ucusDegistir?.toString(),
                                    "true"
                                  )
                                }
                                title={ReactSystemFunctions.translate(
                                  this.ml,
                                  252521,
                                  "title",
                                  this.defaultML
                                )}
                                alwaysVisibleOnMobileResolution={false}
                                hideFiltering={false}
                                hideSorting={false}
                                hideSearch={false}
                                footerOptions="none"
                                footerFontSize={14}
                                footerFontColor="rgb(68, 68, 68)"
                                excludeFromExport={false}
                                footerFontWeight="Regular"
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 0,
                                    paddingRight: 8,
                                    paddingBottom: 0,
                                    paddingLeft: 8,
                                    alignItems: "center",
                                    textAlign: "-webkit-left",
                                    fontFamily: "Poppins",
                                    fontWeight: 400,
                                    fontSize: "15px",
                                    color: "rgba(68, 68, 68, 1)",
                                  } as any
                                }
                              >
                                <HorizontalStack
                                  key="1049"
                                  data-testid="HorizontalStack1"
                                  id="1049"
                                  direction="horizontal"
                                  size={12}
                                  overflowX="auto"
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      paddingTop: 0,
                                      paddingRight: 0,
                                      paddingBottom: 0,
                                      paddingLeft: 0,
                                      fontFamily: "Poppins",
                                      fontWeight: 400,
                                      fontSize: "15px",
                                      color: "rgba(68, 68, 68, 1)",
                                    } as any
                                  }
                                >
                                  <Button
                                    key="127384"
                                    data-testid="Button1"
                                    id="127384"
                                    onClick={(e?: any) => {
                                      if (e && e.stopPropagation)
                                        e.stopPropagation();
                                      this.UcusFormComponent_127384_onClick();
                                    }}
                                    showCursorPointer
                                    label={ReactSystemFunctions.translate(
                                      this.ml,
                                      127384,
                                      "label",
                                      this.defaultML
                                    )}
                                    size="middle"
                                    loading={false}
                                    ghost={false}
                                    block={false}
                                    htmlType="button"
                                    icon="edit"
                                    iconPosition="left"
                                    danger={false}
                                    style={
                                      {
                                        borderTopLeftRadius: 8,
                                        borderTopRightRadius: 8,
                                        borderBottomRightRadius: 8,
                                        borderBottomLeftRadius: 8,
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        paddingTop: 0,
                                        paddingRight: 0,
                                        paddingBottom: 0,
                                        paddingLeft: 0,
                                        fontFamily: "Poppins",
                                        fontWeight: 500,
                                        fontSize: "24px",
                                        color: "rgba(155, 155, 155, 1)",
                                        letterSpacing: "1px",
                                      } as any
                                    }
                                  ></Button>
                                  <Button
                                    key="938114"
                                    data-testid="Button5"
                                    id="938114"
                                    onClick={(e?: any) => {
                                      if (e && e.stopPropagation)
                                        e.stopPropagation();
                                      this.UcusFormComponent_938114_onClick();
                                    }}
                                    showCursorPointer
                                    label={ReactSystemFunctions.translate(
                                      this.ml,
                                      938114,
                                      "label",
                                      this.defaultML
                                    )}
                                    size="middle"
                                    loading={false}
                                    ghost={false}
                                    block={false}
                                    htmlType="button"
                                    icon="delete"
                                    iconPosition="left"
                                    danger={false}
                                    style={
                                      {
                                        borderTopLeftRadius: 8,
                                        borderTopRightRadius: 8,
                                        borderBottomRightRadius: 8,
                                        borderBottomLeftRadius: 8,
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        paddingTop: 0,
                                        paddingRight: 0,
                                        paddingBottom: 0,
                                        paddingLeft: 0,
                                        fontFamily: "Poppins",
                                        fontWeight: 500,
                                        fontSize: "24px",
                                        color: "rgba(155, 155, 155, 1)",
                                        letterSpacing: "1px",
                                      } as any
                                    }
                                  ></Button>
                                </HorizontalStack>
                              </KTableColumn>
                            </KTableRow>
                          </KTable>
                        </KCol>
                      </KRow>
                    </KCol>
                  </KRow>
                  <KModal
                    key="595964"
                    data-testid="Modal1"
                    id="595964"
                    visible={this.state.NavVisible595964}
                    onOk={() => {
                      this.setState({ NavVisible595964: false }, () => {
                        this.callCallbackFunction(595964);
                      });
                    }}
                    onCancel={() => {
                      this.setState({ NavVisible595964: false }, () => {
                        this.callCallbackFunction(595964);
                      });
                    }}
                    closable={false}
                    width="800px"
                    footer={null}
                    height="80vh"
                    children={
                      this.state.NavVisible595964 && (
                        <InlineFormScope>
                          <YolcuForm_Screen
                            onClose={() => {
                              this.setState({ NavVisible595964: false }, () => {
                                this.callCallbackFunction(595964);
                              });
                            }}
                            screenInputs={window.kuika.navigationScreenInputs}
                            navigator={this.props.navigator}
                            form={this.props.form}
                            context={this.props.context}
                          />
                        </InlineFormScope>
                      )
                    }
                  ></KModal>
                  <KModal
                    key="833334"
                    data-testid="Modal2"
                    id="833334"
                    visible={this.state.NavVisible833334}
                    onOk={() => {
                      this.setState({ NavVisible833334: false }, () => {
                        this.callCallbackFunction(833334);
                      });
                    }}
                    onCancel={() => {
                      this.setState({ NavVisible833334: false }, () => {
                        this.callCallbackFunction(833334);
                      });
                    }}
                    closable={false}
                    width="800px"
                    footer={null}
                    height="80vh"
                    children={
                      this.state.NavVisible833334 && (
                        <InlineFormScope>
                          <YolcuForm_Screen
                            onClose={() => {
                              this.setState({ NavVisible833334: false }, () => {
                                this.callCallbackFunction(833334);
                              });
                            }}
                            screenInputs={window.kuika.navigationScreenInputs}
                            navigator={this.props.navigator}
                            form={this.props.form}
                            context={this.props.context}
                          />
                        </InlineFormScope>
                      )
                    }
                  ></KModal>
                  <KRow
                    key="928204"
                    data-testid="Row39"
                    id="928204"
                    editability={this.state.isComp928204Enabled}
                    align="top"
                    justify="start"
                    horizontalGutter={0}
                    verticalGutter={0}
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        paddingTop: 0,
                        paddingRight: 0,
                        paddingBottom: 0,
                        paddingLeft: 0,
                        alignItems: "flex-start",
                        textAlign: "-webkit-left",
                        fontFamily: "Poppins",
                        fontWeight: 400,
                        fontSize: "15px",
                        color: "rgba(68, 68, 68, 1)",
                      } as any
                    }
                  >
                    <KCol
                      key="178252"
                      data-testid="Col57_2"
                      id="178252"
                      xs={24}
                      sm={24}
                      md={24}
                      lg={24}
                      xl={24}
                      xxl={24}
                      order={0}
                      pull={0}
                      push={0}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 3,
                          paddingRight: 8,
                          paddingBottom: 3,
                          paddingLeft: 8,
                          alignItems: "flex-start",
                          textAlign: "-webkit-left",
                          fontFamily: "Poppins",
                          fontWeight: 400,
                          fontSize: "15px",
                          color: "rgba(68, 68, 68, 1)",
                        } as any
                      }
                    >
                      <KRow
                        key="92379"
                        data-testid="Row26"
                        id="92379"
                        align="top"
                        justify="start"
                        horizontalGutter={0}
                        verticalGutter={0}
                        style={
                          {
                            borderTopLeftRadius: 8,
                            borderTopRightRadius: 8,
                            borderBottomRightRadius: 8,
                            borderBottomLeftRadius: 8,
                            backgroundColor: "rgba(255, 255, 255, 1)",
                            backgroundRepeat: "no-repeat",
                            backgroundSize: "contain",
                            backgroundPosition: "left",
                            paddingTop: 0,
                            paddingRight: 8,
                            paddingBottom: 0,
                            paddingLeft: 8,
                            alignItems: "flex-start",
                            textAlign: "-webkit-left",
                            fontFamily: "Poppins",
                            fontWeight: 400,
                            fontSize: "15px",
                            color: "rgba(68, 68, 68, 1)",
                          } as any
                        }
                      >
                        <KCol
                          key="410621"
                          data-testid="Col2_33"
                          id="410621"
                          xs={24}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={4}
                          xxl={4}
                          order={0}
                          pull={0}
                          push={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 8,
                              paddingRight: 8,
                              paddingBottom: 8,
                              paddingLeft: 8,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              fontFamily: "Poppins",
                              fontWeight: 400,
                              fontSize: "15px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <Label
                            key="186862"
                            data-testid="Label24"
                            id="186862"
                            value={ReactSystemFunctions.translate(
                              this.ml,
                              186862,
                              "value",
                              this.defaultML
                            )}
                            writingMode="horizontal"
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                alignItems: "center",
                                textAlign: "-webkit-left",
                                display: "inline",
                                fontFamily: "Poppins",
                                fontWeight: 400,
                                fontSize: "15px",
                                color: "rgba(68, 68, 68, 1)",
                              } as any
                            }
                          ></Label>
                        </KCol>
                        <KCol
                          key="1923"
                          data-testid="Col2_34"
                          id="1923"
                          xs={24}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={20}
                          xxl={20}
                          order={0}
                          pull={0}
                          push={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 8,
                              paddingRight: 8,
                              paddingBottom: 8,
                              paddingLeft: 8,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              fontFamily: "Poppins",
                              fontWeight: 400,
                              fontSize: "15px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <Form.Item
                            className="kFormItem"
                            name="ucusform_143451_value"
                          >
                            <MultiSelect
                              key="143451"
                              data-testid="Sirketler"
                              id="143451"
                              options={this.state.SirketSelectAll}
                              placeholder={ReactSystemFunctions.translate(
                                this.ml,
                                143451,
                                "placeholder",
                                this.defaultML
                              )}
                              allowClear={false}
                              autoClearSearchValue={true}
                              mode="tags"
                              showSearch={true}
                              autoRefresh={true}
                              datavaluefield="sirket"
                              datatextfield="sirket"
                              style={
                                {
                                  borderTopLeftRadius: 8,
                                  borderTopRightRadius: 8,
                                  borderBottomRightRadius: 8,
                                  borderBottomLeftRadius: 8,
                                  borderTopWidth: 1,
                                  borderRightWidth: 1,
                                  borderBottomWidth: 1,
                                  borderLeftWidth: 1,
                                  borderColor: "rgba(218, 218, 218, 1)",
                                  borderStyle: "solid",
                                  backgroundColor: "rgba(255, 255, 255, 1)",
                                  backgroundRepeat: "no-repeat",
                                  backgroundSize: "contain",
                                  backgroundPosition: "left",
                                  paddingTop: 8,
                                  paddingRight: 8,
                                  paddingBottom: 8,
                                  paddingLeft: 8,
                                  alignItems: "center",
                                  textAlign: "-webkit-left",
                                  display: "block",
                                  fontFamily: "Poppins",
                                  fontWeight: 400,
                                  fontSize: "15px",
                                  color: "rgba(68, 68, 68, 1)",
                                } as any
                              }
                            ></MultiSelect>
                          </Form.Item>
                        </KCol>
                      </KRow>
                    </KCol>
                  </KRow>
                  <KRow
                    key="167272"
                    data-testid="Row33"
                    id="167272"
                    editability={this.state.isComp167272Enabled}
                    align="top"
                    justify="start"
                    horizontalGutter={0}
                    verticalGutter={0}
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        paddingTop: 0,
                        paddingRight: 0,
                        paddingBottom: 0,
                        paddingLeft: 0,
                        alignItems: "flex-start",
                        textAlign: "-webkit-left",
                        fontFamily: "Poppins",
                        fontWeight: 400,
                        fontSize: "15px",
                        color: "rgba(68, 68, 68, 1)",
                      } as any
                    }
                  >
                    <KCol
                      key="271789"
                      data-testid="Col57_0"
                      id="271789"
                      xs={24}
                      sm={24}
                      md={24}
                      lg={24}
                      xl={24}
                      xxl={24}
                      order={0}
                      pull={0}
                      push={0}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 3,
                          paddingRight: 8,
                          paddingBottom: 3,
                          paddingLeft: 8,
                          alignItems: "flex-start",
                          textAlign: "-webkit-left",
                          fontFamily: "Poppins",
                          fontWeight: 400,
                          fontSize: "15px",
                          color: "rgba(68, 68, 68, 1)",
                        } as any
                      }
                    >
                      <KRow
                        key="787385"
                        data-testid="Row15"
                        id="787385"
                        align="top"
                        justify="start"
                        horizontalGutter={0}
                        verticalGutter={0}
                        style={
                          {
                            borderTopLeftRadius: 8,
                            borderTopRightRadius: 8,
                            borderBottomRightRadius: 8,
                            borderBottomLeftRadius: 8,
                            backgroundColor: "rgba(255, 255, 255, 1)",
                            backgroundRepeat: "no-repeat",
                            backgroundSize: "contain",
                            backgroundPosition: "left",
                            paddingTop: 0,
                            paddingRight: 8,
                            paddingBottom: 0,
                            paddingLeft: 8,
                            alignItems: "flex-start",
                            textAlign: "-webkit-left",
                            fontFamily: "Poppins",
                            fontWeight: 400,
                            fontSize: "15px",
                            color: "rgba(68, 68, 68, 1)",
                          } as any
                        }
                      >
                        <KCol
                          key="259331"
                          data-testid="Col2_21"
                          id="259331"
                          xs={24}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={4}
                          xxl={4}
                          order={0}
                          pull={0}
                          push={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 8,
                              paddingRight: 8,
                              paddingBottom: 8,
                              paddingLeft: 8,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              fontFamily: "Poppins",
                              fontWeight: 400,
                              fontSize: "15px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <Label
                            key="385903"
                            data-testid="Label19"
                            id="385903"
                            value={ReactSystemFunctions.translate(
                              this.ml,
                              385903,
                              "value",
                              this.defaultML
                            )}
                            writingMode="horizontal"
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                alignItems: "center",
                                textAlign: "-webkit-left",
                                display: "inline",
                                fontFamily: "Poppins",
                                fontWeight: 400,
                                fontSize: "15px",
                                color: "rgba(68, 68, 68, 1)",
                              } as any
                            }
                          ></Label>
                        </KCol>
                        <KCol
                          key="12872"
                          data-testid="Col2_22"
                          id="12872"
                          xs={24}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={20}
                          xxl={20}
                          order={0}
                          pull={0}
                          push={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 8,
                              paddingRight: 8,
                              paddingBottom: 8,
                              paddingLeft: 8,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              fontFamily: "Poppins",
                              fontWeight: 400,
                              fontSize: "15px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <Form.Item
                            className="kFormItem"
                            name="ucusform_316139_value"
                          >
                            <MultiSelect
                              key="316139"
                              data-testid="Murettebat"
                              id="316139"
                              onChange={(e?: any) => {
                                if (e && e.stopPropagation) e.stopPropagation();
                                this.UcusFormComponent_316139_onChange();
                              }}
                              options={this.state.MurettebatListe}
                              placeholder={ReactSystemFunctions.translate(
                                this.ml,
                                316139,
                                "placeholder",
                                this.defaultML
                              )}
                              allowClear={false}
                              autoClearSearchValue={true}
                              mode="tags"
                              showSearch={true}
                              autoRefresh={true}
                              datavaluefield="adSoyad"
                              datatextfield="adSoyad"
                              style={
                                {
                                  borderTopLeftRadius: 8,
                                  borderTopRightRadius: 8,
                                  borderBottomRightRadius: 8,
                                  borderBottomLeftRadius: 8,
                                  borderTopWidth: 1,
                                  borderRightWidth: 1,
                                  borderBottomWidth: 1,
                                  borderLeftWidth: 1,
                                  borderColor: "rgba(218, 218, 218, 1)",
                                  borderStyle: "solid",
                                  backgroundColor: "rgba(255, 255, 255, 1)",
                                  backgroundRepeat: "no-repeat",
                                  backgroundSize: "contain",
                                  backgroundPosition: "left",
                                  paddingTop: 8,
                                  paddingRight: 8,
                                  paddingBottom: 8,
                                  paddingLeft: 8,
                                  alignItems: "center",
                                  textAlign: "-webkit-left",
                                  display: "block",
                                  fontFamily: "Poppins",
                                  fontWeight: 400,
                                  fontSize: "15px",
                                  color: "rgba(68, 68, 68, 1)",
                                } as any
                              }
                            ></MultiSelect>
                          </Form.Item>
                        </KCol>
                      </KRow>
                    </KCol>
                  </KRow>
                  <KRow
                    key="954041"
                    data-testid="Row38"
                    id="954041"
                    editability={this.state.isComp954041Enabled}
                    align="top"
                    justify="start"
                    horizontalGutter={0}
                    verticalGutter={0}
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        paddingTop: 0,
                        paddingRight: 0,
                        paddingBottom: 0,
                        paddingLeft: 0,
                        alignItems: "flex-start",
                        textAlign: "-webkit-left",
                        fontFamily: "Poppins",
                        fontWeight: 400,
                        fontSize: "15px",
                        color: "rgba(68, 68, 68, 1)",
                      } as any
                    }
                  >
                    <KCol
                      key="696089"
                      data-testid="Col57_1"
                      id="696089"
                      xs={24}
                      sm={24}
                      md={24}
                      lg={24}
                      xl={24}
                      xxl={24}
                      order={0}
                      pull={0}
                      push={0}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 3,
                          paddingRight: 8,
                          paddingBottom: 3,
                          paddingLeft: 8,
                          alignItems: "flex-start",
                          textAlign: "-webkit-left",
                          fontFamily: "Poppins",
                          fontWeight: 400,
                          fontSize: "15px",
                          color: "rgba(68, 68, 68, 1)",
                        } as any
                      }
                    >
                      <KRow
                        key="676930"
                        data-testid="Row25"
                        id="676930"
                        align="top"
                        justify="start"
                        horizontalGutter={0}
                        verticalGutter={0}
                        style={
                          {
                            borderTopLeftRadius: 8,
                            borderTopRightRadius: 8,
                            borderBottomRightRadius: 8,
                            borderBottomLeftRadius: 8,
                            backgroundColor: "rgba(255, 255, 255, 1)",
                            backgroundRepeat: "no-repeat",
                            backgroundSize: "contain",
                            backgroundPosition: "left",
                            paddingTop: 0,
                            paddingRight: 8,
                            paddingBottom: 0,
                            paddingLeft: 8,
                            alignItems: "flex-start",
                            textAlign: "-webkit-left",
                            fontFamily: "Poppins",
                            fontWeight: 400,
                            fontSize: "15px",
                            color: "rgba(68, 68, 68, 1)",
                          } as any
                        }
                      >
                        <KCol
                          key="391976"
                          data-testid="Col2_30"
                          id="391976"
                          xs={24}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={4}
                          xxl={4}
                          order={0}
                          pull={0}
                          push={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 8,
                              paddingRight: 8,
                              paddingBottom: 8,
                              paddingLeft: 8,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              fontFamily: "Poppins",
                              fontWeight: 400,
                              fontSize: "15px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <Label
                            key="347625"
                            data-testid="Label21"
                            id="347625"
                            value={ReactSystemFunctions.translate(
                              this.ml,
                              347625,
                              "value",
                              this.defaultML
                            )}
                            writingMode="horizontal"
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                alignItems: "center",
                                textAlign: "-webkit-left",
                                display: "inline",
                                fontFamily: "Poppins",
                                fontWeight: 400,
                                fontSize: "15px",
                                color: "rgba(68, 68, 68, 1)",
                              } as any
                            }
                          ></Label>
                        </KCol>
                        <KCol
                          key="192365"
                          data-testid="Col2_32"
                          id="192365"
                          xs={24}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={20}
                          xxl={20}
                          order={0}
                          pull={0}
                          push={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 8,
                              paddingRight: 8,
                              paddingBottom: 8,
                              paddingLeft: 8,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              fontFamily: "Poppins",
                              fontWeight: 400,
                              fontSize: "15px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <Form.Item
                            className="kFormItem"
                            name="ucusform_13544_value"
                          >
                            <KSelectBox
                              key="13544"
                              data-testid="Pilot"
                              id="13544"
                              kuikaRef={
                                this.ucusform_13544_value_kuikaSelectBoxRef
                              }
                              options={this.state.SplitStringBaknet}
                              placeholder={ReactSystemFunctions.translate(
                                this.ml,
                                13544,
                                "placeholder",
                                this.defaultML
                              )}
                              allowClear={true}
                              autoClearSearchValue={true}
                              showSearch={false}
                              widthType="fill"
                              containsNullItem={true}
                              sortBy="none"
                              options={this.state.dataSource_13544}
                              datavaluefield="str"
                              datatextfield="str"
                              style={
                                {
                                  borderTopLeftRadius: 8,
                                  borderTopRightRadius: 8,
                                  borderBottomRightRadius: 8,
                                  borderBottomLeftRadius: 8,
                                  borderTopWidth: 1,
                                  borderRightWidth: 1,
                                  borderBottomWidth: 1,
                                  borderLeftWidth: 1,
                                  borderColor: "rgba(218, 218, 218, 1)",
                                  borderStyle: "solid",
                                  backgroundColor: "rgba(255, 255, 255, 1)",
                                  backgroundRepeat: "no-repeat",
                                  backgroundSize: "contain",
                                  backgroundPosition: "left",
                                  paddingTop: 8,
                                  paddingRight: 8,
                                  paddingBottom: 8,
                                  paddingLeft: 8,
                                  alignItems: "center",
                                  textAlign: "-webkit-left",
                                  display: "block",
                                  fontFamily: "Poppins",
                                  fontWeight: 400,
                                  fontSize: "15px",
                                  color: "rgba(68, 68, 68, 1)",
                                } as any
                              }
                            ></KSelectBox>
                          </Form.Item>
                        </KCol>
                      </KRow>
                    </KCol>
                  </KRow>
                  <KRow
                    key="900752"
                    data-testid="Row40"
                    id="900752"
                    editability={this.state.isComp900752Enabled}
                    align="top"
                    justify="start"
                    horizontalGutter={0}
                    verticalGutter={0}
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        paddingTop: 0,
                        paddingRight: 0,
                        paddingBottom: 0,
                        paddingLeft: 0,
                        alignItems: "flex-start",
                        textAlign: "-webkit-left",
                        fontFamily: "Poppins",
                        fontWeight: 400,
                        fontSize: "15px",
                        color: "rgba(68, 68, 68, 1)",
                      } as any
                    }
                  >
                    <KCol
                      key="704064"
                      data-testid="Col57_3"
                      id="704064"
                      xs={24}
                      sm={24}
                      md={24}
                      lg={24}
                      xl={24}
                      xxl={24}
                      order={0}
                      pull={0}
                      push={0}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 3,
                          paddingRight: 8,
                          paddingBottom: 3,
                          paddingLeft: 8,
                          alignItems: "flex-start",
                          textAlign: "-webkit-left",
                          fontFamily: "Poppins",
                          fontWeight: 400,
                          fontSize: "15px",
                          color: "rgba(68, 68, 68, 1)",
                        } as any
                      }
                    >
                      <KRow
                        key="566349"
                        data-testid="Row31"
                        id="566349"
                        align="top"
                        justify="start"
                        horizontalGutter={0}
                        verticalGutter={0}
                        style={
                          {
                            borderTopLeftRadius: 8,
                            borderTopRightRadius: 8,
                            borderBottomRightRadius: 8,
                            borderBottomLeftRadius: 8,
                            backgroundColor: "rgba(255, 255, 255, 1)",
                            backgroundRepeat: "no-repeat",
                            backgroundSize: "contain",
                            backgroundPosition: "left",
                            paddingTop: 0,
                            paddingRight: 8,
                            paddingBottom: 0,
                            paddingLeft: 8,
                            alignItems: "flex-start",
                            textAlign: "-webkit-left",
                            fontFamily: "Poppins",
                            fontWeight: 400,
                            fontSize: "15px",
                            color: "rgba(68, 68, 68, 1)",
                          } as any
                        }
                      >
                        <KCol
                          key="50802"
                          data-testid="Col2_35"
                          id="50802"
                          xs={24}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={4}
                          xxl={4}
                          order={0}
                          pull={0}
                          push={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 8,
                              paddingRight: 8,
                              paddingBottom: 8,
                              paddingLeft: 8,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              fontFamily: "Poppins",
                              fontWeight: 400,
                              fontSize: "15px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <Label
                            key="752142"
                            data-testid="Label25"
                            id="752142"
                            value={ReactSystemFunctions.translate(
                              this.ml,
                              752142,
                              "value",
                              this.defaultML
                            )}
                            writingMode="horizontal"
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                alignItems: "center",
                                textAlign: "-webkit-left",
                                display: "inline",
                                fontFamily: "Poppins",
                                fontWeight: 400,
                                fontSize: "15px",
                                color: "rgba(68, 68, 68, 1)",
                              } as any
                            }
                          ></Label>
                        </KCol>
                        <KCol
                          key="704018"
                          data-testid="Col2_36"
                          id="704018"
                          xs={24}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={20}
                          xxl={20}
                          order={0}
                          pull={0}
                          push={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 8,
                              paddingRight: 8,
                              paddingBottom: 8,
                              paddingLeft: 8,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              fontFamily: "Poppins",
                              fontWeight: 400,
                              fontSize: "15px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <Form.Item
                            className="kFormItem"
                            name="ucusform_835559_value"
                          >
                            <MultiSelect
                              key="835559"
                              data-testid="MasrafCesitleri"
                              id="835559"
                              options={this.state.MasrafCesidiSelectAll}
                              placeholder={ReactSystemFunctions.translate(
                                this.ml,
                                835559,
                                "placeholder",
                                this.defaultML
                              )}
                              allowClear={false}
                              autoClearSearchValue={true}
                              mode="tags"
                              showSearch={true}
                              autoRefresh={true}
                              datavaluefield="kod"
                              datatextfield="ad"
                              style={
                                {
                                  borderTopLeftRadius: 8,
                                  borderTopRightRadius: 8,
                                  borderBottomRightRadius: 8,
                                  borderBottomLeftRadius: 8,
                                  borderTopWidth: 1,
                                  borderRightWidth: 1,
                                  borderBottomWidth: 1,
                                  borderLeftWidth: 1,
                                  borderColor: "rgba(218, 218, 218, 1)",
                                  borderStyle: "solid",
                                  backgroundColor: "rgba(255, 255, 255, 1)",
                                  backgroundRepeat: "no-repeat",
                                  backgroundSize: "contain",
                                  backgroundPosition: "left",
                                  paddingTop: 8,
                                  paddingRight: 8,
                                  paddingBottom: 8,
                                  paddingLeft: 8,
                                  alignItems: "center",
                                  textAlign: "-webkit-left",
                                  display: "block",
                                  fontFamily: "Poppins",
                                  fontWeight: 400,
                                  fontSize: "15px",
                                  color: "rgba(68, 68, 68, 1)",
                                } as any
                              }
                            ></MultiSelect>
                          </Form.Item>
                        </KCol>
                      </KRow>
                    </KCol>
                  </KRow>
                  <KRow
                    key="464650"
                    data-testid="Row44"
                    id="464650"
                    align="top"
                    justify="start"
                    horizontalGutter={0}
                    verticalGutter={0}
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        paddingTop: 0,
                        paddingRight: 0,
                        paddingBottom: 0,
                        paddingLeft: 0,
                        alignItems: "flex-start",
                        textAlign: "-webkit-left",
                        fontFamily: "Poppins",
                        fontWeight: 400,
                        fontSize: "15px",
                        color: "rgba(68, 68, 68, 1)",
                      } as any
                    }
                  >
                    <KCol
                      key="835914"
                      data-testid="Col57_5"
                      id="835914"
                      xs={24}
                      sm={24}
                      md={24}
                      lg={24}
                      xl={24}
                      xxl={24}
                      order={0}
                      pull={0}
                      push={0}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 3,
                          paddingRight: 8,
                          paddingBottom: 3,
                          paddingLeft: 8,
                          alignItems: "flex-start",
                          textAlign: "-webkit-left",
                          fontFamily: "Poppins",
                          fontWeight: 400,
                          fontSize: "15px",
                          color: "rgba(68, 68, 68, 1)",
                        } as any
                      }
                    >
                      <KRow
                        key="988451"
                        data-testid="Row45"
                        id="988451"
                        align="top"
                        justify="start"
                        horizontalGutter={0}
                        verticalGutter={0}
                        style={
                          {
                            borderTopLeftRadius: 8,
                            borderTopRightRadius: 8,
                            borderBottomRightRadius: 8,
                            borderBottomLeftRadius: 8,
                            backgroundColor: "rgba(255, 255, 255, 1)",
                            backgroundRepeat: "no-repeat",
                            backgroundSize: "contain",
                            backgroundPosition: "left",
                            paddingTop: 0,
                            paddingRight: 8,
                            paddingBottom: 0,
                            paddingLeft: 8,
                            alignItems: "flex-start",
                            textAlign: "-webkit-left",
                            fontFamily: "Poppins",
                            fontWeight: 400,
                            fontSize: "15px",
                            color: "rgba(68, 68, 68, 1)",
                          } as any
                        }
                      >
                        <KCol
                          key="344283"
                          data-testid="Col2_38"
                          id="344283"
                          xs={24}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={4}
                          xxl={4}
                          order={0}
                          pull={0}
                          push={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 8,
                              paddingRight: 8,
                              paddingBottom: 8,
                              paddingLeft: 8,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              fontFamily: "Poppins",
                              fontWeight: 400,
                              fontSize: "15px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <Label
                            key="450485"
                            data-testid="Label27"
                            id="450485"
                            value={ReactSystemFunctions.translate(
                              this.ml,
                              450485,
                              "value",
                              this.defaultML
                            )}
                            writingMode="horizontal"
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                alignItems: "center",
                                textAlign: "-webkit-left",
                                display: "inline",
                                fontFamily: "Poppins",
                                fontWeight: 400,
                                fontSize: "15px",
                                color: "rgba(68, 68, 68, 1)",
                              } as any
                            }
                          ></Label>
                        </KCol>
                        <KCol
                          key="179992"
                          data-testid="Col2_39"
                          id="179992"
                          xs={24}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={8}
                          xxl={8}
                          order={0}
                          pull={0}
                          push={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 8,
                              paddingRight: 8,
                              paddingBottom: 8,
                              paddingLeft: 8,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              fontFamily: "Poppins",
                              fontWeight: 400,
                              fontSize: "15px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <Form.Item
                            className="kFormItem"
                            name="ucusform_995117_value"
                          >
                            <KSelectBox
                              key="995117"
                              data-testid="MasrafDurum"
                              id="995117"
                              editability={this.state.isComp995117Enabled}
                              kuikaRef={
                                this.ucusform_995117_value_kuikaSelectBoxRef
                              }
                              options={this.state.MasrafDurumListe}
                              placeholder={ReactSystemFunctions.translate(
                                this.ml,
                                995117,
                                "placeholder",
                                this.defaultML
                              )}
                              allowClear={false}
                              autoClearSearchValue={true}
                              showSearch={false}
                              widthType="fill"
                              containsNullItem={false}
                              sortBy="none"
                              datavaluefield="durum"
                              datatextfield="ad"
                              style={
                                {
                                  borderTopLeftRadius: 8,
                                  borderTopRightRadius: 8,
                                  borderBottomRightRadius: 8,
                                  borderBottomLeftRadius: 8,
                                  borderTopWidth: 1,
                                  borderRightWidth: 1,
                                  borderBottomWidth: 1,
                                  borderLeftWidth: 1,
                                  borderColor: "rgba(218, 218, 218, 1)",
                                  borderStyle: "solid",
                                  backgroundColor: "rgba(255, 255, 255, 1)",
                                  backgroundRepeat: "no-repeat",
                                  backgroundSize: "contain",
                                  backgroundPosition: "left",
                                  paddingTop: 8,
                                  paddingRight: 8,
                                  paddingBottom: 8,
                                  paddingLeft: 8,
                                  alignItems: "center",
                                  textAlign: "-webkit-left",
                                  display: "block",
                                  fontFamily: "Poppins",
                                  fontWeight: 400,
                                  fontSize: "15px",
                                  color: "rgba(68, 68, 68, 1)",
                                } as any
                              }
                            ></KSelectBox>
                          </Form.Item>
                        </KCol>
                        <KCol
                          key="833338"
                          data-testid="Col68"
                          id="833338"
                          xs={24}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={4}
                          xxl={4}
                          order={0}
                          pull={0}
                          push={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 8,
                              paddingRight: 8,
                              paddingBottom: 8,
                              paddingLeft: 8,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              fontFamily: "Poppins",
                              fontWeight: 400,
                              fontSize: "15px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <Label
                            key="204870"
                            data-testid="Label28"
                            id="204870"
                            value={ReactSystemFunctions.translate(
                              this.ml,
                              204870,
                              "value",
                              this.defaultML
                            )}
                            writingMode="horizontal"
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                alignItems: "center",
                                textAlign: "-webkit-left",
                                display: "inline",
                                fontFamily: "Poppins",
                                fontWeight: 400,
                                fontSize: "15px",
                                color: "rgba(68, 68, 68, 1)",
                              } as any
                            }
                          ></Label>
                        </KCol>
                        <KCol
                          key="694100"
                          data-testid="Col69"
                          id="694100"
                          xs={24}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={8}
                          xxl={8}
                          order={0}
                          pull={0}
                          push={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 8,
                              paddingRight: 8,
                              paddingBottom: 8,
                              paddingLeft: 8,
                              alignItems: "flex-start",
                              textAlign: "-webkit-left",
                              fontFamily: "Poppins",
                              fontWeight: 400,
                              fontSize: "15px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <Form.Item
                            className="kFormItem"
                            name="ucusform_771172_value"
                          >
                            <TextInput
                              key="771172"
                              data-testid="MasrafOnaylayan"
                              id="771172"
                              editability={this.state.isComp771172Enabled}
                              kuikaRef={
                                this.ucusform_771172_value_kuikaTextInputRef
                              }
                              placeholder={ReactSystemFunctions.translate(
                                this.ml,
                                771172,
                                "placeholder",
                                this.defaultML
                              )}
                              allowClear={false}
                              bordered={true}
                              disabled={false}
                              type="text"
                              iconColor="rgba(0, 0, 0, 1)"
                              formatter="None"
                              isCharOnly={false}
                              autoComplete={true}
                              inputMode="all"
                              speechToText={false}
                              style={
                                {
                                  borderTopLeftRadius: 8,
                                  borderTopRightRadius: 8,
                                  borderBottomRightRadius: 8,
                                  borderBottomLeftRadius: 8,
                                  borderTopWidth: 1,
                                  borderRightWidth: 1,
                                  borderBottomWidth: 1,
                                  borderLeftWidth: 1,
                                  borderColor: "rgba(218, 218, 218, 1)",
                                  borderStyle: "solid",
                                  backgroundColor: "rgba(255, 255, 255, 1)",
                                  backgroundRepeat: "no-repeat",
                                  backgroundSize: "contain",
                                  backgroundPosition: "left",
                                  paddingTop: 8,
                                  paddingRight: 8,
                                  paddingBottom: 8,
                                  paddingLeft: 8,
                                  alignItems: "center",
                                  textAlign: "-webkit-left",
                                  display: "block",
                                  fontFamily: "Poppins",
                                  fontWeight: 400,
                                  fontSize: "15px",
                                  color: "rgba(68, 68, 68, 1)",
                                } as any
                              }
                            ></TextInput>
                          </Form.Item>
                        </KCol>
                      </KRow>
                    </KCol>
                  </KRow>
                  <KRow
                    key="667527"
                    data-testid="Row42"
                    id="667527"
                    align="top"
                    justify="start"
                    horizontalGutter={0}
                    verticalGutter={0}
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        paddingTop: 0,
                        paddingRight: 0,
                        paddingBottom: 0,
                        paddingLeft: 0,
                        alignItems: "flex-start",
                        textAlign: "-webkit-left",
                        fontFamily: "Poppins",
                        fontWeight: 400,
                        fontSize: "15px",
                        color: "rgba(68, 68, 68, 1)",
                      } as any
                    }
                  >
                    <KCol
                      key="496000"
                      data-testid="Col57_4"
                      id="496000"
                      xs={24}
                      sm={24}
                      md={24}
                      lg={24}
                      xl={24}
                      xxl={24}
                      order={0}
                      pull={0}
                      push={0}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 3,
                          paddingRight: 8,
                          paddingBottom: 3,
                          paddingLeft: 8,
                          alignItems: "flex-start",
                          textAlign: "-webkit-left",
                          fontFamily: "Poppins",
                          fontWeight: 400,
                          fontSize: "15px",
                          color: "rgba(68, 68, 68, 1)",
                        } as any
                      }
                    >
                      <KRow
                        key="450203"
                        data-testid="Row43"
                        id="450203"
                        align="top"
                        justify="start"
                        horizontalGutter={0}
                        verticalGutter={0}
                        style={
                          {
                            borderTopLeftRadius: 8,
                            borderTopRightRadius: 8,
                            borderBottomRightRadius: 8,
                            borderBottomLeftRadius: 8,
                            backgroundColor: "rgba(255, 255, 255, 1)",
                            backgroundRepeat: "no-repeat",
                            backgroundSize: "contain",
                            backgroundPosition: "left",
                            paddingTop: 0,
                            paddingRight: 8,
                            paddingBottom: 0,
                            paddingLeft: 8,
                            alignItems: "flex-start",
                            textAlign: "-webkit-left",
                            fontFamily: "Poppins",
                            fontWeight: 400,
                            fontSize: "15px",
                            color: "rgba(68, 68, 68, 1)",
                          } as any
                        }
                      >
                        <KCol
                          key="694130"
                          data-testid="Col2_37"
                          id="694130"
                          xs={24}
                          sm={24}
                          md={24}
                          lg={24}
                          xl={24}
                          xxl={24}
                          order={0}
                          pull={0}
                          push={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 8,
                              paddingRight: 8,
                              paddingBottom: 8,
                              paddingLeft: 8,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              fontFamily: "Poppins",
                              fontWeight: 400,
                              fontSize: "15px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <HorizontalStack
                            key="559677"
                            data-testid="HorizontalStack8"
                            id="559677"
                            direction="horizontal"
                            size={12}
                            overflowX="auto"
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                alignItems: "center",
                                fontFamily: "Poppins",
                                fontWeight: 400,
                                fontSize: "15px",
                                color: "rgba(68, 68, 68, 1)",
                              } as any
                            }
                          >
                            <Label
                              key="639952"
                              data-testid="Label26"
                              id="639952"
                              value={ReactSystemFunctions.translate(
                                this.ml,
                                639952,
                                "value",
                                this.defaultML
                              )}
                              writingMode="horizontal"
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  paddingTop: 0,
                                  paddingRight: 0,
                                  paddingBottom: 0,
                                  paddingLeft: 0,
                                  alignItems: "center",
                                  textAlign: "-webkit-left",
                                  display: "inline",
                                  fontFamily: "Poppins",
                                  fontWeight: 400,
                                  fontSize: "15px",
                                  color: "rgba(68, 68, 68, 1)",
                                } as any
                              }
                            ></Label>
                            <Button
                              key="629348"
                              data-testid="MasrafEkle"
                              id="629348"
                              onClick={(e?: any) => {
                                if (e && e.stopPropagation) e.stopPropagation();
                                this.UcusFormComponent_629348_onClick();
                              }}
                              showCursorPointer
                              visibility={this.state.isComp629348Visible}
                              label={ReactSystemFunctions.translate(
                                this.ml,
                                629348,
                                "label",
                                this.defaultML
                              )}
                              size="middle"
                              loading={false}
                              ghost={false}
                              block={false}
                              htmlType="button"
                              icon="add"
                              iconPosition="left"
                              danger={false}
                              style={
                                {
                                  borderTopLeftRadius: 8,
                                  borderTopRightRadius: 8,
                                  borderBottomRightRadius: 8,
                                  borderBottomLeftRadius: 8,
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  backgroundColor: "rgba(3, 88, 255, 1)",
                                  backgroundRepeat: "no-repeat",
                                  backgroundSize: "contain",
                                  backgroundPosition: "left",
                                  paddingTop: 8,
                                  paddingRight: 16,
                                  paddingBottom: 8,
                                  paddingLeft: 16,
                                  alignItems: "center",
                                  textAlign: "-webkit-center",
                                  display: "block",
                                  fontFamily: "Poppins",
                                  fontWeight: 500,
                                  fontSize: "16px",
                                  color: "rgba(255, 255, 255, 1)",
                                  lineHeight: "22px",
                                } as any
                              }
                            ></Button>
                          </HorizontalStack>
                          <KTable
                            key="524862"
                            data-testid="TblMasraflar"
                            id="524862"
                            kuikaRef={this.ucusform_524862_value_kuikaTableRef}
                            form={this.props.form}
                            screenId="83fd6de0-fc3c-4e49-9dae-d9f2dcd1e499"
                            dataSource={this.state.MasrafTmpListe}
                            size="middle"
                            bordered={true}
                            loading={false}
                            rowKey="id"
                            transformedOnMobileResolution={false}
                            hideHeaderOnMobileResolution={false}
                            showHeader={true}
                            fixedHeader={false}
                            editable={false}
                            tableWidthMode="fit"
                            globalSearch={false}
                            searchable={false}
                            shouldSearchOnChange={true}
                            searchDelay={200}
                            sorter={false}
                            filtering={false}
                            pagination={false}
                            pageSize={10}
                            showSizeChanger={false}
                            paginationSelectedTextColor="#246eff"
                            paginationUnselectedTextColor="#000"
                            columnChooser={false}
                            resizableColumns={false}
                            striped={true}
                            stripedColor="#F5F7FA"
                            rowHoverBgColor="#fafafa"
                            insertRowActive={false}
                            insertRowPosition="top"
                            showNoDataFound={true}
                            nodatafoundmessage={ReactSystemFunctions.translate(
                              this.ml,
                              524862,
                              "nodatafoundmessage",
                              this.defaultML
                            )}
                            multiSelect={false}
                            multiSelectScope="page"
                            export={false}
                            editableAlwaysActive={false}
                            showRowNumbers={false}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                fontFamily: "Poppins",
                                fontWeight: 400,
                                fontSize: "15px",
                                color: "rgba(68, 68, 68, 1)",
                              } as any
                            }
                          >
                            <KTableHeader
                              key="408442"
                              data-testid="TableHeader3"
                              id="408442"
                              hideOnMobileResolution={false}
                              textDirection="Default"
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  fontFamily: "Poppins",
                                  fontWeight: 400,
                                  fontSize: "14px",
                                  color: "rgba(155, 155, 155, 1)",
                                  lineHeight: "20px",
                                } as any
                              }
                            ></KTableHeader>
                            <KTableRow
                              key="714676"
                              data-testid="TableRow1_2"
                              id="714676"
                              hoverFontColor="red"
                              hoverBgColor="#F5F5F5"
                              style={
                                {
                                  borderTopWidth: 1,
                                  borderRightWidth: 1,
                                  borderBottomWidth: 1,
                                  borderLeftWidth: 1,
                                  borderColor: "rgba(218, 218, 218, 1)",
                                  borderStyle: "solid",
                                  paddingTop: 0,
                                  paddingRight: 0,
                                  paddingBottom: 0,
                                  paddingLeft: 0,
                                  fontFamily: "Poppins",
                                  fontWeight: 400,
                                  fontSize: "15px",
                                  color: "rgba(68, 68, 68, 1)",
                                } as any
                              }
                            >
                              <KTableColumn
                                key="927090"
                                data-testid="TableTemplateColumn4"
                                id="927090"
                                title={ReactSystemFunctions.translate(
                                  this.ml,
                                  927090,
                                  "title",
                                  this.defaultML
                                )}
                                alwaysVisibleOnMobileResolution={false}
                                hideFiltering={false}
                                hideSorting={false}
                                hideSearch={false}
                                footerOptions="none"
                                footerFontSize={14}
                                footerFontColor="rgb(68, 68, 68)"
                                excludeFromExport={false}
                                footerFontWeight="Regular"
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 0,
                                    paddingRight: 8,
                                    paddingBottom: 0,
                                    paddingLeft: 8,
                                    alignItems: "center",
                                    textAlign: "-webkit-left",
                                    fontFamily: "Poppins",
                                    fontWeight: 400,
                                    fontSize: "15px",
                                    color: "rgba(68, 68, 68, 1)",
                                  } as any
                                }
                              >
                                <Label
                                  key="599348"
                                  data-testid="Label36"
                                  id="599348"
                                  value="[datafield:siraNo]"
                                  writingMode="horizontal"
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      fontFamily: "Poppins",
                                      fontWeight: 400,
                                      fontSize: "15px",
                                      color: "rgba(68, 68, 68, 1)",
                                    } as any
                                  }
                                ></Label>
                              </KTableColumn>
                              <KTableColumn
                                key="147891"
                                data-testid="TableDefaultColumn8"
                                id="147891"
                                title={ReactSystemFunctions.translate(
                                  this.ml,
                                  147891,
                                  "title",
                                  this.defaultML
                                )}
                                isEditableColumn={true}
                                alwaysVisibleOnMobileResolution={false}
                                hideFiltering={false}
                                hideSorting={false}
                                hideSearch={false}
                                footerOptions="none"
                                footerFontSize={14}
                                footerFontWeight="Regular"
                                footerFontColor="rgb(68, 68, 68)"
                                excludeFromExport={false}
                                dateSearchFormat="DD.MM.YYYY"
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 8,
                                    paddingRight: 8,
                                    paddingBottom: 8,
                                    paddingLeft: 8,
                                    alignItems: "center",
                                    textAlign: "-webkit-left",
                                    fontFamily: "Poppins",
                                    fontWeight: 400,
                                    fontSize: "15px",
                                    color: "rgba(68, 68, 68, 1)",
                                  } as any
                                }
                              >
                                <Label
                                  key="875348"
                                  data-testid="Label38_0"
                                  id="875348"
                                  value="[datafield:sirketler]"
                                  writingMode="horizontal"
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      paddingTop: 0,
                                      paddingRight: 0,
                                      paddingBottom: 0,
                                      paddingLeft: 0,
                                      alignItems: "center",
                                      textAlign: "-webkit-left",
                                      display: "inline",
                                      fontFamily: "Poppins",
                                      fontWeight: 400,
                                      fontSize: "15px",
                                      color: "rgba(68, 68, 68, 1)",
                                    } as any
                                  }
                                ></Label>
                                <Form.Item
                                  className="kFormItem"
                                  name="ucusform_813134_value"
                                >
                                  <KuikaEditableCell
                                    rowValue="[datafield:sirketler]"
                                    rowId="[datafield:id]"
                                  >
                                    <TextInput
                                      key="813134"
                                      data-testid="TextInput9"
                                      id="813134"
                                      kuikaRef={
                                        this
                                          .ucusform_813134_value_kuikaTextInputRef
                                      }
                                      onChange={(e: any) => {
                                        this.props.form.setFieldValue(
                                          "Table_524862_sirketler",
                                          e?.target?.value ?? e
                                        );
                                      }}
                                      defaultValue="[datafield:sirketler]"
                                      placeholder={ReactSystemFunctions.translate(
                                        this.ml,
                                        813134,
                                        "placeholder",
                                        this.defaultML
                                      )}
                                      allowClear={false}
                                      bordered={true}
                                      disabled={false}
                                      type="text"
                                      iconColor="rgba(0, 0, 0, 1)"
                                      formatter="None"
                                      isCharOnly={false}
                                      autoComplete={true}
                                      inputMode="all"
                                      speechToText={false}
                                      style={
                                        {
                                          borderTopLeftRadius: 8,
                                          borderTopRightRadius: 8,
                                          borderBottomRightRadius: 8,
                                          borderBottomLeftRadius: 8,
                                          borderTopWidth: 1,
                                          borderRightWidth: 1,
                                          borderBottomWidth: 1,
                                          borderLeftWidth: 1,
                                          borderColor: "rgba(218, 218, 218, 1)",
                                          borderStyle: "solid",
                                          backgroundColor:
                                            "rgba(255, 255, 255, 1)",
                                          backgroundRepeat: "no-repeat",
                                          backgroundSize: "contain",
                                          backgroundPosition: "left",
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "center",
                                          textAlign: "-webkit-left",
                                          display: "block",
                                          fontFamily: "Poppins",
                                          fontWeight: 400,
                                          fontSize: "15px",
                                          color: "rgba(68, 68, 68, 1)",
                                        } as any
                                      }
                                    ></TextInput>
                                  </KuikaEditableCell>
                                </Form.Item>
                              </KTableColumn>
                              <KTableColumn
                                key="36151"
                                data-testid="TableDefaultColumn1_1"
                                id="36151"
                                title={ReactSystemFunctions.translate(
                                  this.ml,
                                  36151,
                                  "title",
                                  this.defaultML
                                )}
                                isEditableColumn={true}
                                alwaysVisibleOnMobileResolution={false}
                                hideFiltering={false}
                                hideSorting={false}
                                hideSearch={false}
                                footerOptions="none"
                                footerFontSize={14}
                                footerFontWeight="Regular"
                                footerFontColor="rgb(68, 68, 68)"
                                excludeFromExport={false}
                                dateSearchFormat="DD.MM.YYYY"
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 0,
                                    paddingRight: 8,
                                    paddingBottom: 0,
                                    paddingLeft: 8,
                                    alignItems: "center",
                                    textAlign: "-webkit-left",
                                    fontFamily: "Poppins",
                                    fontWeight: 400,
                                    fontSize: "15px",
                                    color: "rgba(68, 68, 68, 1)",
                                  } as any
                                }
                              >
                                <Label
                                  key="149408"
                                  data-testid="Label15_2"
                                  id="149408"
                                  value="[datafield:masrafKodu]"
                                  writingMode="horizontal"
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      paddingTop: 0,
                                      paddingRight: 0,
                                      paddingBottom: 0,
                                      paddingLeft: 0,
                                      alignItems: "center",
                                      textAlign: "-webkit-left",
                                      display: "inline",
                                      fontFamily: "Poppins",
                                      fontWeight: 400,
                                      fontSize: "15px",
                                      color: "rgba(68, 68, 68, 1)",
                                    } as any
                                  }
                                ></Label>
                                <Form.Item
                                  className="kFormItem"
                                  name="ucusform_988667_value"
                                >
                                  <KuikaEditableCell
                                    rowValue="[datafield:masrafKodu]"
                                    rowId="[datafield:id]"
                                  >
                                    <TextInput
                                      key="988667"
                                      data-testid="TextInput5"
                                      id="988667"
                                      kuikaRef={
                                        this
                                          .ucusform_988667_value_kuikaTextInputRef
                                      }
                                      onChange={(e: any) => {
                                        this.props.form.setFieldValue(
                                          "Table_524862_masrafKodu",
                                          e?.target?.value ?? e
                                        );
                                      }}
                                      defaultValue="[datafield:masrafKodu]"
                                      placeholder={ReactSystemFunctions.translate(
                                        this.ml,
                                        988667,
                                        "placeholder",
                                        this.defaultML
                                      )}
                                      allowClear={false}
                                      bordered={true}
                                      disabled={false}
                                      type="text"
                                      iconColor="rgba(0, 0, 0, 1)"
                                      formatter="None"
                                      isCharOnly={false}
                                      autoComplete={true}
                                      inputMode="all"
                                      speechToText={false}
                                      style={
                                        {
                                          borderTopLeftRadius: 8,
                                          borderTopRightRadius: 8,
                                          borderBottomRightRadius: 8,
                                          borderBottomLeftRadius: 8,
                                          borderTopWidth: 1,
                                          borderRightWidth: 1,
                                          borderBottomWidth: 1,
                                          borderLeftWidth: 1,
                                          borderColor: "rgba(218, 218, 218, 1)",
                                          borderStyle: "solid",
                                          backgroundColor:
                                            "rgba(255, 255, 255, 1)",
                                          backgroundRepeat: "no-repeat",
                                          backgroundSize: "contain",
                                          backgroundPosition: "left",
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "center",
                                          textAlign: "-webkit-left",
                                          display: "block",
                                          fontFamily: "Poppins",
                                          fontWeight: 400,
                                          fontSize: "15px",
                                          color: "rgba(68, 68, 68, 1)",
                                        } as any
                                      }
                                    ></TextInput>
                                  </KuikaEditableCell>
                                </Form.Item>
                              </KTableColumn>
                              <KTableColumn
                                key="31091"
                                data-testid="TableTemplateColumn1_1"
                                id="31091"
                                title={ReactSystemFunctions.translate(
                                  this.ml,
                                  31091,
                                  "title",
                                  this.defaultML
                                )}
                                alwaysVisibleOnMobileResolution={false}
                                hideFiltering={false}
                                hideSorting={false}
                                hideSearch={false}
                                footerOptions="none"
                                footerFontSize={14}
                                footerFontColor="rgb(68, 68, 68)"
                                excludeFromExport={false}
                                footerFontWeight="Regular"
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 0,
                                    paddingRight: 8,
                                    paddingBottom: 0,
                                    paddingLeft: 8,
                                    alignItems: "center",
                                    textAlign: "-webkit-left",
                                    fontFamily: "Poppins",
                                    fontWeight: 400,
                                    fontSize: "15px",
                                    color: "rgba(68, 68, 68, 1)",
                                  } as any
                                }
                              >
                                <Label
                                  key="698848"
                                  data-testid="Label15_3"
                                  id="698848"
                                  value="[datafield:masrafCesidi]"
                                  writingMode="horizontal"
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      paddingTop: 0,
                                      paddingRight: 0,
                                      paddingBottom: 0,
                                      paddingLeft: 0,
                                      alignItems: "center",
                                      textAlign: "-webkit-left",
                                      display: "inline",
                                      fontFamily: "Poppins",
                                      fontWeight: 400,
                                      fontSize: "15px",
                                      color: "rgba(68, 68, 68, 1)",
                                    } as any
                                  }
                                ></Label>
                              </KTableColumn>
                              <KTableColumn
                                key="652004"
                                data-testid="TableDefaultColumn4"
                                id="652004"
                                title={ReactSystemFunctions.translate(
                                  this.ml,
                                  652004,
                                  "title",
                                  this.defaultML
                                )}
                                isEditableColumn={true}
                                alwaysVisibleOnMobileResolution={false}
                                hideFiltering={false}
                                hideSorting={false}
                                hideSearch={false}
                                footerOptions="none"
                                footerOptionLabel="r23rrewr&nbsp;"
                                footerFontSize={14}
                                footerFontWeight="Regular"
                                footerFontColor="rgb(68, 68, 68)"
                                excludeFromExport={false}
                                dateSearchFormat="DD.MM.YYYY"
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 0,
                                    paddingRight: 8,
                                    paddingBottom: 0,
                                    paddingLeft: 8,
                                    alignItems: "center",
                                    textAlign: "-webkit-right",
                                    fontFamily: "Poppins",
                                    fontWeight: 400,
                                    fontSize: "15px",
                                    color: "rgba(68, 68, 68, 1)",
                                  } as any
                                }
                              >
                                <Label
                                  key="521220"
                                  data-testid="Label20_1"
                                  id="521220"
                                  value="[datafield:tutar]"
                                  formatter="money"
                                  writingMode="horizontal"
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      paddingTop: 0,
                                      paddingRight: 0,
                                      paddingBottom: 0,
                                      paddingLeft: 0,
                                      alignItems: "center",
                                      textAlign: "-webkit-left",
                                      display: "inline",
                                      fontFamily: "Poppins",
                                      fontWeight: 400,
                                      fontSize: "15px",
                                      color: "rgba(68, 68, 68, 1)",
                                    } as any
                                  }
                                ></Label>
                                <Form.Item
                                  className="kFormItem"
                                  name="ucusform_681735_value"
                                >
                                  <KuikaEditableCell
                                    rowValue="[datafield:tutar]"
                                    rowId="[datafield:id]"
                                  >
                                    <NumberInput
                                      key="681735"
                                      data-testid="NumberInput4"
                                      id="681735"
                                      onChange={(e: any) => {
                                        this.props.form.setFieldValue(
                                          "Table_524862_tutar",
                                          e?.target?.value ?? e
                                        );
                                      }}
                                      defaultValue="[datafield:tutar]"
                                      decimalSeparator="."
                                      decimalScale={2}
                                      disabled={false}
                                      placeholder={ReactSystemFunctions.translate(
                                        this.ml,
                                        681735,
                                        "placeholder",
                                        this.defaultML
                                      )}
                                      fixedDecimalScale={false}
                                      allowNegative={true}
                                      allowEmptyFormatting={false}
                                      isThousandSeperatorOn={true}
                                      style={
                                        {
                                          borderTopLeftRadius: 8,
                                          borderTopRightRadius: 8,
                                          borderBottomRightRadius: 8,
                                          borderBottomLeftRadius: 8,
                                          borderTopWidth: 1,
                                          borderRightWidth: 1,
                                          borderBottomWidth: 1,
                                          borderLeftWidth: 1,
                                          borderColor: "rgba(218, 218, 218, 1)",
                                          borderStyle: "solid",
                                          backgroundColor:
                                            "rgba(255, 255, 255, 1)",
                                          backgroundRepeat: "no-repeat",
                                          backgroundSize: "contain",
                                          backgroundPosition: "left",
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "center",
                                          textAlign: "-webkit-left",
                                          display: "block",
                                          fontFamily: "Poppins",
                                          fontWeight: 400,
                                          fontSize: "15px",
                                          color: "rgba(68, 68, 68, 1)",
                                        } as any
                                      }
                                    ></NumberInput>
                                  </KuikaEditableCell>
                                </Form.Item>
                              </KTableColumn>
                              <KTableColumn
                                key="341262"
                                data-testid="TableDefaultColumn5"
                                id="341262"
                                title={ReactSystemFunctions.translate(
                                  this.ml,
                                  341262,
                                  "title",
                                  this.defaultML
                                )}
                                isEditableColumn={true}
                                alwaysVisibleOnMobileResolution={false}
                                hideFiltering={false}
                                hideSorting={false}
                                hideSearch={false}
                                footerOptions="none"
                                footerFontSize={14}
                                footerFontWeight="Regular"
                                footerFontColor="rgb(68, 68, 68)"
                                excludeFromExport={false}
                                dateSearchFormat="DD.MM.YYYY"
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 0,
                                    paddingRight: 8,
                                    paddingBottom: 0,
                                    paddingLeft: 8,
                                    alignItems: "center",
                                    textAlign: "-webkit-left",
                                    fontFamily: "Poppins",
                                    fontWeight: 400,
                                    fontSize: "15px",
                                    color: "rgba(68, 68, 68, 1)",
                                  } as any
                                }
                              >
                                <Label
                                  key="436727"
                                  data-testid="Label21_1"
                                  id="436727"
                                  value="[datafield:pBr]"
                                  writingMode="horizontal"
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      paddingTop: 0,
                                      paddingRight: 0,
                                      paddingBottom: 0,
                                      paddingLeft: 0,
                                      alignItems: "center",
                                      textAlign: "-webkit-left",
                                      display: "inline",
                                      fontFamily: "Poppins",
                                      fontWeight: 400,
                                      fontSize: "15px",
                                      color: "rgba(68, 68, 68, 1)",
                                    } as any
                                  }
                                ></Label>
                                <Form.Item
                                  className="kFormItem"
                                  name="ucusform_41634_value"
                                >
                                  <KuikaEditableCell
                                    rowValue="[datafield:pBr]"
                                    rowId="[datafield:id]"
                                  >
                                    <TextInput
                                      key="41634"
                                      data-testid="TextInput6"
                                      id="41634"
                                      kuikaRef={
                                        this
                                          .ucusform_41634_value_kuikaTextInputRef
                                      }
                                      onChange={(e: any) => {
                                        this.props.form.setFieldValue(
                                          "Table_524862_pBr",
                                          e?.target?.value ?? e
                                        );
                                      }}
                                      defaultValue="[datafield:pBr]"
                                      placeholder={ReactSystemFunctions.translate(
                                        this.ml,
                                        41634,
                                        "placeholder",
                                        this.defaultML
                                      )}
                                      allowClear={false}
                                      bordered={true}
                                      disabled={false}
                                      type="text"
                                      iconColor="rgba(0, 0, 0, 1)"
                                      formatter="None"
                                      isCharOnly={false}
                                      autoComplete={true}
                                      inputMode="all"
                                      speechToText={false}
                                      style={
                                        {
                                          borderTopLeftRadius: 8,
                                          borderTopRightRadius: 8,
                                          borderBottomRightRadius: 8,
                                          borderBottomLeftRadius: 8,
                                          borderTopWidth: 1,
                                          borderRightWidth: 1,
                                          borderBottomWidth: 1,
                                          borderLeftWidth: 1,
                                          borderColor: "rgba(218, 218, 218, 1)",
                                          borderStyle: "solid",
                                          backgroundColor:
                                            "rgba(255, 255, 255, 1)",
                                          backgroundRepeat: "no-repeat",
                                          backgroundSize: "contain",
                                          backgroundPosition: "left",
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "center",
                                          textAlign: "-webkit-left",
                                          display: "block",
                                          fontFamily: "Poppins",
                                          fontWeight: 400,
                                          fontSize: "15px",
                                          color: "rgba(68, 68, 68, 1)",
                                        } as any
                                      }
                                    ></TextInput>
                                  </KuikaEditableCell>
                                </Form.Item>
                              </KTableColumn>
                              <KTableColumn
                                key="37639"
                                data-testid="TableDefaultColumn7"
                                id="37639"
                                title={ReactSystemFunctions.translate(
                                  this.ml,
                                  37639,
                                  "title",
                                  this.defaultML
                                )}
                                isEditableColumn={true}
                                alwaysVisibleOnMobileResolution={false}
                                hideFiltering={false}
                                hideSorting={false}
                                hideSearch={false}
                                footerOptions="none"
                                footerFontSize={14}
                                footerFontWeight="Regular"
                                footerFontColor="rgb(68, 68, 68)"
                                excludeFromExport={false}
                                dateSearchFormat="DD.MM.YYYY"
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 0,
                                    paddingRight: 8,
                                    paddingBottom: 0,
                                    paddingLeft: 8,
                                    alignItems: "center",
                                    textAlign: "-webkit-left",
                                    fontFamily: "Poppins",
                                    fontWeight: 400,
                                    fontSize: "15px",
                                    color: "rgba(68, 68, 68, 1)",
                                  } as any
                                }
                              >
                                <Label
                                  key="119928"
                                  data-testid="Label37_0"
                                  id="119928"
                                  value="[datafield:aciklama]"
                                  writingMode="horizontal"
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      paddingTop: 0,
                                      paddingRight: 0,
                                      paddingBottom: 0,
                                      paddingLeft: 0,
                                      alignItems: "center",
                                      textAlign: "-webkit-left",
                                      display: "inline",
                                      fontFamily: "Poppins",
                                      fontWeight: 400,
                                      fontSize: "15px",
                                      color: "rgba(68, 68, 68, 1)",
                                    } as any
                                  }
                                ></Label>
                                <Form.Item
                                  className="kFormItem"
                                  name="ucusform_318005_value"
                                >
                                  <KuikaEditableCell
                                    rowValue="[datafield:aciklama]"
                                    rowId="[datafield:id]"
                                  >
                                    <TextInput
                                      key="318005"
                                      data-testid="TextInput7"
                                      id="318005"
                                      kuikaRef={
                                        this
                                          .ucusform_318005_value_kuikaTextInputRef
                                      }
                                      onChange={(e: any) => {
                                        this.props.form.setFieldValue(
                                          "Table_524862_aciklama",
                                          e?.target?.value ?? e
                                        );
                                      }}
                                      defaultValue="[datafield:aciklama]"
                                      placeholder={ReactSystemFunctions.translate(
                                        this.ml,
                                        318005,
                                        "placeholder",
                                        this.defaultML
                                      )}
                                      allowClear={false}
                                      bordered={true}
                                      disabled={false}
                                      type="text"
                                      iconColor="rgba(0, 0, 0, 1)"
                                      formatter="None"
                                      isCharOnly={false}
                                      autoComplete={true}
                                      inputMode="all"
                                      speechToText={false}
                                      style={
                                        {
                                          borderTopLeftRadius: 8,
                                          borderTopRightRadius: 8,
                                          borderBottomRightRadius: 8,
                                          borderBottomLeftRadius: 8,
                                          borderTopWidth: 1,
                                          borderRightWidth: 1,
                                          borderBottomWidth: 1,
                                          borderLeftWidth: 1,
                                          borderColor: "rgba(218, 218, 218, 1)",
                                          borderStyle: "solid",
                                          backgroundColor:
                                            "rgba(255, 255, 255, 1)",
                                          backgroundRepeat: "no-repeat",
                                          backgroundSize: "contain",
                                          backgroundPosition: "left",
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "center",
                                          textAlign: "-webkit-left",
                                          display: "block",
                                          fontFamily: "Poppins",
                                          fontWeight: 400,
                                          fontSize: "15px",
                                          color: "rgba(68, 68, 68, 1)",
                                        } as any
                                      }
                                    ></TextInput>
                                  </KuikaEditableCell>
                                </Form.Item>
                              </KTableColumn>
                              <KTableColumn
                                key="575369"
                                data-testid="TableTemplateColumn8"
                                id="575369"
                                title={ReactSystemFunctions.translate(
                                  this.ml,
                                  575369,
                                  "title",
                                  this.defaultML
                                )}
                                alwaysVisibleOnMobileResolution={false}
                                hideFiltering={false}
                                hideSorting={false}
                                hideSearch={false}
                                footerOptions="none"
                                footerFontSize={14}
                                footerFontColor="rgb(68, 68, 68)"
                                excludeFromExport={false}
                                footerFontWeight="Regular"
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 8,
                                    paddingRight: 8,
                                    paddingBottom: 8,
                                    paddingLeft: 8,
                                    alignItems: "center",
                                    textAlign: "-webkit-left",
                                    fontFamily: "Poppins",
                                    fontWeight: 400,
                                    fontSize: "15px",
                                    color: "rgba(68, 68, 68, 1)",
                                  } as any
                                }
                              >
                                <HorizontalStack
                                  key="201853"
                                  data-testid="HorizontalStack9"
                                  id="201853"
                                  direction="horizontal"
                                  size={12}
                                  overflowX="auto"
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      paddingTop: 0,
                                      paddingRight: 0,
                                      paddingBottom: 0,
                                      paddingLeft: 0,
                                      fontFamily: "Poppins",
                                      fontWeight: 400,
                                      fontSize: "15px",
                                      color: "rgba(68, 68, 68, 1)",
                                    } as any
                                  }
                                >
                                  <Label
                                    key="967293"
                                    data-testid="Label39"
                                    id="967293"
                                    onClick={(e?: any) => {
                                      if (e && e.stopPropagation)
                                        e.stopPropagation();
                                      this.UcusFormComponent_967293_onClick();
                                    }}
                                    showCursorPointer
                                    value="[datafield:dosyaAd1]"
                                    writingMode="horizontal"
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        paddingTop: 0,
                                        paddingRight: 0,
                                        paddingBottom: 0,
                                        paddingLeft: 0,
                                        alignItems: "center",
                                        textAlign: "-webkit-left",
                                        display: "inline",
                                        fontFamily: "Poppins",
                                        fontWeight: 400,
                                        fontSize: "15px",
                                        color: "rgba(68, 142, 247, 1)",
                                        textDecoration: "underline",
                                      } as any
                                    }
                                  ></Label>
                                  <Label
                                    key="309815"
                                    data-testid="Label40"
                                    id="309815"
                                    onClick={(e?: any) => {
                                      if (e && e.stopPropagation)
                                        e.stopPropagation();
                                      this.UcusFormComponent_309815_onClick();
                                    }}
                                    showCursorPointer
                                    value="[datafield:dosyaAd2]"
                                    writingMode="horizontal"
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        paddingTop: 0,
                                        paddingRight: 0,
                                        paddingBottom: 0,
                                        paddingLeft: 0,
                                        alignItems: "center",
                                        textAlign: "-webkit-left",
                                        display: "inline",
                                        fontFamily: "Poppins",
                                        fontWeight: 400,
                                        fontSize: "15px",
                                        color: "rgba(68, 142, 247, 1)",
                                        textDecoration: "underline",
                                      } as any
                                    }
                                  ></Label>
                                  <Label
                                    key="930625"
                                    data-testid="Label41"
                                    id="930625"
                                    onClick={(e?: any) => {
                                      if (e && e.stopPropagation)
                                        e.stopPropagation();
                                      this.UcusFormComponent_930625_onClick();
                                    }}
                                    showCursorPointer
                                    value="[datafield:dosyaAd3]"
                                    writingMode="horizontal"
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        paddingTop: 0,
                                        paddingRight: 0,
                                        paddingBottom: 0,
                                        paddingLeft: 0,
                                        alignItems: "center",
                                        textAlign: "-webkit-left",
                                        display: "inline",
                                        fontFamily: "Poppins",
                                        fontWeight: 400,
                                        fontSize: "15px",
                                        color: "rgba(68, 142, 247, 1)",
                                        textDecoration: "underline",
                                      } as any
                                    }
                                  ></Label>
                                </HorizontalStack>
                              </KTableColumn>
                              <KTableColumn
                                key="884140"
                                data-testid="TableTemplateColumn5"
                                id="884140"
                                visibility="visible"
                                visibilityCondition={(rowData: object) =>
                                  ReactSystemFunctions.isEqualTo(
                                    this.state.UcusGorunumAyarla?.masrafDegistir?.toString(),
                                    "true"
                                  ) &&
                                  ReactSystemFunctions.isNotEqualTo(
                                    rowData.masrafKodu,
                                    "TOPLAM"
                                  )
                                }
                                title={ReactSystemFunctions.translate(
                                  this.ml,
                                  884140,
                                  "title",
                                  this.defaultML
                                )}
                                alwaysVisibleOnMobileResolution={false}
                                hideFiltering={false}
                                hideSorting={false}
                                hideSearch={false}
                                footerOptions="none"
                                footerFontSize={14}
                                footerFontColor="rgb(68, 68, 68)"
                                excludeFromExport={false}
                                footerFontWeight="Regular"
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 0,
                                    paddingRight: 8,
                                    paddingBottom: 0,
                                    paddingLeft: 8,
                                    alignItems: "center",
                                    textAlign: "-webkit-left",
                                    fontFamily: "Poppins",
                                    fontWeight: 400,
                                    fontSize: "15px",
                                    color: "rgba(68, 68, 68, 1)",
                                  } as any
                                }
                              >
                                <HorizontalStack
                                  key="177428"
                                  data-testid="HorizontalStack2"
                                  id="177428"
                                  direction="horizontal"
                                  size={12}
                                  overflowX="auto"
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      paddingTop: 0,
                                      paddingRight: 0,
                                      paddingBottom: 0,
                                      paddingLeft: 0,
                                      fontFamily: "Poppins",
                                      fontWeight: 400,
                                      fontSize: "15px",
                                      color: "rgba(68, 68, 68, 1)",
                                    } as any
                                  }
                                >
                                  <Button
                                    key="233334"
                                    data-testid="Button2"
                                    id="233334"
                                    onClick={(e?: any) => {
                                      if (e && e.stopPropagation)
                                        e.stopPropagation();
                                      this.UcusFormComponent_233334_onClick();
                                    }}
                                    showCursorPointer
                                    label={ReactSystemFunctions.translate(
                                      this.ml,
                                      233334,
                                      "label",
                                      this.defaultML
                                    )}
                                    size="middle"
                                    loading={false}
                                    ghost={false}
                                    block={false}
                                    htmlType="button"
                                    icon="edit"
                                    iconPosition="left"
                                    danger={false}
                                    style={
                                      {
                                        borderTopLeftRadius: 8,
                                        borderTopRightRadius: 8,
                                        borderBottomRightRadius: 8,
                                        borderBottomLeftRadius: 8,
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        paddingTop: 0,
                                        paddingRight: 0,
                                        paddingBottom: 0,
                                        paddingLeft: 0,
                                        fontFamily: "Poppins",
                                        fontWeight: 500,
                                        fontSize: "24px",
                                        color: "rgba(155, 155, 155, 1)",
                                        letterSpacing: "1px",
                                      } as any
                                    }
                                  ></Button>
                                  <Button
                                    key="452466"
                                    data-testid="Button6"
                                    id="452466"
                                    onClick={(e?: any) => {
                                      if (e && e.stopPropagation)
                                        e.stopPropagation();
                                      this.UcusFormComponent_452466_onClick();
                                    }}
                                    showCursorPointer
                                    label={ReactSystemFunctions.translate(
                                      this.ml,
                                      452466,
                                      "label",
                                      this.defaultML
                                    )}
                                    size="middle"
                                    loading={false}
                                    ghost={false}
                                    block={false}
                                    htmlType="button"
                                    icon="delete"
                                    iconPosition="left"
                                    danger={false}
                                    style={
                                      {
                                        borderTopLeftRadius: 8,
                                        borderTopRightRadius: 8,
                                        borderBottomRightRadius: 8,
                                        borderBottomLeftRadius: 8,
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        paddingTop: 0,
                                        paddingRight: 0,
                                        paddingBottom: 0,
                                        paddingLeft: 0,
                                        fontFamily: "Poppins",
                                        fontWeight: 500,
                                        fontSize: "24px",
                                        color: "rgba(155, 155, 155, 1)",
                                        letterSpacing: "1px",
                                      } as any
                                    }
                                  ></Button>
                                </HorizontalStack>
                              </KTableColumn>
                            </KTableRow>
                          </KTable>
                        </KCol>
                      </KRow>
                    </KCol>
                  </KRow>
                  <KRow
                    key="985853"
                    data-testid="Row24"
                    id="985853"
                    align="top"
                    justify="start"
                    horizontalGutter={0}
                    verticalGutter={0}
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        paddingTop: 0,
                        paddingRight: 0,
                        paddingBottom: 0,
                        paddingLeft: 0,
                        alignItems: "flex-start",
                        textAlign: "-webkit-left",
                        fontFamily: "Poppins",
                        fontWeight: 400,
                        fontSize: "15px",
                        color: "rgba(68, 68, 68, 1)",
                      } as any
                    }
                  >
                    <KCol
                      key="971958"
                      data-testid="Col52"
                      id="971958"
                      xs={24}
                      sm={24}
                      md={24}
                      lg={24}
                      xl={24}
                      xxl={24}
                      order={0}
                      pull={0}
                      push={0}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 3,
                          paddingRight: 8,
                          paddingBottom: 3,
                          paddingLeft: 8,
                          alignItems: "flex-start",
                          textAlign: "-webkit-left",
                          fontFamily: "Poppins",
                          fontWeight: 400,
                          fontSize: "15px",
                          color: "rgba(68, 68, 68, 1)",
                        } as any
                      }
                    >
                      <KRow
                        key="96157"
                        data-testid="Row16"
                        id="96157"
                        align="top"
                        justify="start"
                        horizontalGutter={0}
                        verticalGutter={0}
                        style={
                          {
                            borderTopLeftRadius: 8,
                            borderTopRightRadius: 8,
                            borderBottomRightRadius: 8,
                            borderBottomLeftRadius: 8,
                            backgroundColor: "rgba(255, 255, 255, 1)",
                            backgroundRepeat: "no-repeat",
                            backgroundSize: "contain",
                            backgroundPosition: "left",
                            paddingTop: 0,
                            paddingBottom: 0,
                            fontFamily: "Poppins",
                            fontWeight: 400,
                            fontSize: "15px",
                            color: "rgba(68, 68, 68, 1)",
                          } as any
                        }
                      >
                        <KCol
                          key="851924"
                          data-testid="Col2_28"
                          id="851924"
                          xs={24}
                          sm={24}
                          md={24}
                          lg={24}
                          xl={24}
                          xxl={24}
                          order={0}
                          pull={0}
                          push={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              alignItems: "center",
                              fontFamily: "Poppins",
                              fontWeight: 400,
                              fontSize: "15px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <KRow
                            key="686586"
                            data-testid="Row14"
                            id="686586"
                            align="top"
                            justify="start"
                            horizontalGutter={0}
                            verticalGutter={0}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                alignItems: "flex-start",
                                textAlign: "-webkit-left",
                                fontFamily: "Poppins",
                                fontWeight: 400,
                                fontSize: "15px",
                                color: "rgba(68, 68, 68, 1)",
                              } as any
                            }
                          >
                            <KCol
                              key="537528"
                              data-testid="Col15"
                              id="537528"
                              xs={24}
                              sm={24}
                              md={24}
                              lg={24}
                              xl={24}
                              xxl={24}
                              order={0}
                              pull={0}
                              push={0}
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  paddingTop: 3,
                                  paddingRight: 0,
                                  paddingBottom: 0,
                                  paddingLeft: 0,
                                  alignItems: "flex-start",
                                  textAlign: "-webkit-left",
                                  fontFamily: "Poppins",
                                  fontWeight: 400,
                                  fontSize: "15px",
                                  color: "rgba(68, 68, 68, 1)",
                                } as any
                              }
                            >
                              <KRow
                                key="864921"
                                data-testid="Row29"
                                id="864921"
                                align="top"
                                justify="start"
                                horizontalGutter={0}
                                verticalGutter={0}
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 8,
                                    paddingRight: 8,
                                    paddingBottom: 0,
                                    paddingLeft: 8,
                                    alignItems: "flex-start",
                                    textAlign: "-webkit-left",
                                    fontFamily: "Poppins",
                                    fontWeight: 400,
                                    fontSize: "15px",
                                    color: "rgba(68, 68, 68, 1)",
                                  } as any
                                }
                              >
                                <KCol
                                  key="29397"
                                  data-testid="Col56_0"
                                  id="29397"
                                  xs={24}
                                  sm={24}
                                  md={24}
                                  lg={24}
                                  xl={24}
                                  xxl={24}
                                  order={0}
                                  pull={0}
                                  push={0}
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      paddingTop: 8,
                                      paddingRight: 8,
                                      paddingBottom: 0,
                                      paddingLeft: 8,
                                      alignItems: "flex-start",
                                      textAlign: "-webkit-left",
                                      fontFamily: "Poppins",
                                      fontWeight: 400,
                                      fontSize: "15px",
                                      color: "rgba(68, 68, 68, 1)",
                                    } as any
                                  }
                                >
                                  <Label
                                    key="308589"
                                    data-testid="Label20"
                                    id="308589"
                                    value={ReactSystemFunctions.translate(
                                      this.ml,
                                      308589,
                                      "value",
                                      this.defaultML
                                    )}
                                    writingMode="horizontal"
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        paddingTop: 0,
                                        paddingRight: 0,
                                        paddingBottom: 0,
                                        paddingLeft: 0,
                                        alignItems: "center",
                                        textAlign: "-webkit-left",
                                        display: "inline",
                                        fontFamily: "Poppins",
                                        fontWeight: 400,
                                        fontSize: "15px",
                                        color: "rgba(68, 68, 68, 1)",
                                      } as any
                                    }
                                  ></Label>
                                </KCol>
                              </KRow>
                            </KCol>
                          </KRow>
                          <KRow
                            key="395728"
                            data-testid="Row32"
                            id="395728"
                            align="top"
                            justify="start"
                            horizontalGutter={0}
                            verticalGutter={0}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 8,
                                paddingBottom: 0,
                                paddingLeft: 8,
                                alignItems: "flex-start",
                                textAlign: "-webkit-left",
                                fontFamily: "Poppins",
                                fontWeight: 400,
                                fontSize: "15px",
                                color: "rgba(68, 68, 68, 1)",
                              } as any
                            }
                          >
                            <KCol
                              key="563778"
                              data-testid="Col54_0"
                              id="563778"
                              xs={24}
                              sm={24}
                              md={24}
                              lg={24}
                              xl={24}
                              xxl={24}
                              order={0}
                              pull={0}
                              push={0}
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  paddingTop: 0,
                                  paddingRight: 0,
                                  paddingBottom: 0,
                                  paddingLeft: 0,
                                  fontFamily: "Poppins",
                                  fontWeight: 400,
                                  fontSize: "15px",
                                  color: "rgba(68, 68, 68, 1)",
                                } as any
                              }
                            >
                              <KTable
                                key="412266"
                                data-testid="TblYazisma"
                                id="412266"
                                kuikaRef={
                                  this.ucusform_412266_value_kuikaTableRef
                                }
                                form={this.props.form}
                                screenId="83fd6de0-fc3c-4e49-9dae-d9f2dcd1e499"
                                dataSource={this.state.YazismaGetir}
                                size="middle"
                                bordered={true}
                                loading={false}
                                rowKey="id"
                                transformedOnMobileResolution={false}
                                hideHeaderOnMobileResolution={false}
                                showHeader={true}
                                fixedHeader={false}
                                editable={true}
                                tableWidthMode="fit"
                                globalSearch={false}
                                searchable={false}
                                shouldSearchOnChange={true}
                                searchDelay={200}
                                sorter={false}
                                filtering={false}
                                pagination={false}
                                pageSize={10}
                                showSizeChanger={false}
                                paginationSelectedTextColor="#246eff"
                                paginationUnselectedTextColor="#000"
                                columnChooser={false}
                                resizableColumns={false}
                                hideTableOnEmpty={true}
                                striped={false}
                                stripedColor="#F5F7FA"
                                rowHoverBgColor="rgba(255, 255, 255, 1)"
                                insertRowActive={false}
                                insertRowPosition="top"
                                showNoDataFound={true}
                                nodatafoundmessage={ReactSystemFunctions.translate(
                                  this.ml,
                                  412266,
                                  "nodatafoundmessage",
                                  this.defaultML
                                )}
                                multiSelect={false}
                                multiSelectScope="page"
                                export={false}
                                editableAlwaysActive={false}
                                showRowNumbers={false}
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 0,
                                    paddingRight: 0,
                                    paddingBottom: 0,
                                    paddingLeft: 0,
                                    fontFamily: "Poppins",
                                    fontWeight: 400,
                                    fontSize: "15px",
                                    color: "rgba(68, 68, 68, 1)",
                                  } as any
                                }
                              >
                                <KTableRow
                                  key="327126"
                                  data-testid="TableRow1_1"
                                  id="327126"
                                  hoverFontColor="red"
                                  hoverBgColor="#F5F5F5"
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      paddingTop: 0,
                                      paddingRight: 0,
                                      paddingBottom: 0,
                                      paddingLeft: 0,
                                      fontFamily: "Poppins",
                                      fontWeight: 400,
                                      fontSize: "15px",
                                      color: "rgba(68, 68, 68, 1)",
                                    } as any
                                  }
                                >
                                  <KTableColumn
                                    key="777940"
                                    data-testid="TableTemplateColumn6"
                                    id="777940"
                                    title={ReactSystemFunctions.translate(
                                      this.ml,
                                      777940,
                                      "title",
                                      this.defaultML
                                    )}
                                    alwaysVisibleOnMobileResolution={false}
                                    hideFiltering={false}
                                    hideSorting={false}
                                    hideSearch={false}
                                    footerOptions="none"
                                    footerFontSize={14}
                                    footerFontColor="rgb(68, 68, 68)"
                                    excludeFromExport={false}
                                    footerFontWeight="Regular"
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        paddingTop: 0,
                                        paddingRight: 0,
                                        paddingBottom: 0,
                                        paddingLeft: 0,
                                        fontFamily: "Poppins",
                                        fontWeight: 400,
                                        fontSize: "15px",
                                        color: "rgba(68, 68, 68, 1)",
                                      } as any
                                    }
                                  >
                                    <KRow
                                      key="203119"
                                      data-testid="Row27"
                                      id="203119"
                                      visibility={
                                        this.state.isComp203119Visible
                                      }
                                      visibilityCondition={(rowData: object) =>
                                        ReactSystemFunctions.isEqualTo(
                                          rowData.isYolcu,
                                          "true"
                                        )
                                      }
                                      align="top"
                                      justify="start"
                                      horizontalGutter={0}
                                      verticalGutter={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 0,
                                          paddingRight: 0,
                                          paddingBottom: 0,
                                          paddingLeft: 0,
                                          fontFamily: "Poppins",
                                          fontWeight: 400,
                                          fontSize: "15px",
                                          color: "rgba(68, 68, 68, 1)",
                                        } as any
                                      }
                                    >
                                      <KCol
                                        key="352682"
                                        data-testid="Col56_0"
                                        id="352682"
                                        xs={24}
                                        sm={24}
                                        md={24}
                                        lg={24}
                                        xl={24}
                                        xxl={24}
                                        order={0}
                                        pull={0}
                                        push={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 10,
                                            paddingLeft: 0,
                                            alignItems: "flex-start",
                                            textAlign: "-webkit-left",
                                            fontFamily: "Poppins",
                                            fontWeight: 400,
                                            fontSize: "15px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      >
                                        <VerticalStack
                                          key="848871"
                                          data-testid="VerticalStack1"
                                          id="848871"
                                          visibility={
                                            this.state.isComp848871Visible
                                          }
                                          visibilityCondition={(
                                            rowData: object
                                          ) =>
                                            ReactSystemFunctions.isEqualTo(
                                              rowData.isYolcu,
                                              "true"
                                            )
                                          }
                                          direction="vertical"
                                          size={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              fontFamily: "Poppins",
                                              fontWeight: 400,
                                              fontSize: "15px",
                                              color: "rgba(68, 68, 68, 1)",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="296137"
                                            data-testid="Label34"
                                            id="296137"
                                            value="[datafield:metin]"
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderTopLeftRadius: 200,
                                                borderTopRightRadius: 200,
                                                borderBottomRightRadius: 200,
                                                borderBottomLeftRadius: 200,
                                                borderTopWidth: 1,
                                                borderRightWidth: 1,
                                                borderBottomWidth: 1,
                                                borderLeftWidth: 1,
                                                borderColor:
                                                  "rgba(218, 218, 218, 1)",
                                                borderStyle: "solid",
                                                paddingTop: 8,
                                                paddingRight: 20,
                                                paddingBottom: 8,
                                                paddingLeft: 20,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 400,
                                                fontSize: "15px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          ></Label>
                                          <HorizontalStack
                                            key="344800"
                                            data-testid="HorizontalStack6"
                                            id="344800"
                                            direction="horizontal"
                                            size={12}
                                            overflowX="auto"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                fontFamily: "Poppins",
                                                fontWeight: 400,
                                                fontSize: "15px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <Label
                                              key="565085"
                                              data-testid="Label30"
                                              id="565085"
                                              value="[datafield:talepEden]"
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 400,
                                                  fontSize: "11px",
                                                  color:
                                                    "rgba(115, 115, 115, 1)",
                                                } as any
                                              }
                                            ></Label>
                                            <Label
                                              key="987221"
                                              data-testid="Label31"
                                              id="987221"
                                              value="[datafield:talepEdenZaman]"
                                              formatter="custom date"
                                              customFormatter="DD.MM.YYYY HH:mm"
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 400,
                                                  fontSize: "11px",
                                                  color:
                                                    "rgba(115, 115, 115, 1)",
                                                } as any
                                              }
                                            ></Label>
                                          </HorizontalStack>
                                        </VerticalStack>
                                      </KCol>
                                    </KRow>
                                    <KRow
                                      key="808818"
                                      data-testid="Row28"
                                      id="808818"
                                      visibility={
                                        this.state.isComp808818Visible
                                      }
                                      visibilityCondition={(rowData: object) =>
                                        ReactSystemFunctions.isEqualTo(
                                          rowData.isYolcu,
                                          "false"
                                        )
                                      }
                                      align="top"
                                      justify="start"
                                      horizontalGutter={0}
                                      verticalGutter={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 0,
                                          paddingRight: 0,
                                          paddingBottom: 0,
                                          paddingLeft: 0,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                          fontFamily: "Poppins",
                                          fontWeight: 400,
                                          fontSize: "15px",
                                          color: "rgba(68, 68, 68, 1)",
                                        } as any
                                      }
                                    >
                                      <KCol
                                        key="439790"
                                        data-testid="Col56_3"
                                        id="439790"
                                        xs={24}
                                        sm={24}
                                        md={24}
                                        lg={24}
                                        xl={24}
                                        xxl={24}
                                        order={0}
                                        pull={0}
                                        push={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            alignItems: "flex-start",
                                            textAlign: "-webkit-right",
                                            fontFamily: "Poppins",
                                            fontWeight: 400,
                                            fontSize: "15px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      >
                                        <VerticalStack
                                          key="354518"
                                          data-testid="VerticalStack2"
                                          id="354518"
                                          visibility={
                                            this.state.isComp354518Visible
                                          }
                                          visibilityCondition={(
                                            rowData: object
                                          ) =>
                                            ReactSystemFunctions.isEqualTo(
                                              rowData.isYolcu,
                                              "false"
                                            )
                                          }
                                          direction="vertical"
                                          size={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              textAlign: "-webkit-right",
                                              fontFamily: "Poppins",
                                              fontWeight: 400,
                                              fontSize: "15px",
                                              color: "rgba(68, 68, 68, 1)",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="54829"
                                            data-testid="Label35"
                                            id="54829"
                                            value="[datafield:metin]"
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderTopLeftRadius: 200,
                                                borderTopRightRadius: 200,
                                                borderBottomRightRadius: 200,
                                                borderBottomLeftRadius: 200,
                                                borderTopWidth: 1,
                                                borderRightWidth: 1,
                                                borderBottomWidth: 1,
                                                borderLeftWidth: 1,
                                                borderColor:
                                                  "rgba(218, 218, 218, 1)",
                                                borderStyle: "solid",
                                                paddingTop: 8,
                                                paddingRight: 20,
                                                paddingBottom: 8,
                                                paddingLeft: 20,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 400,
                                                fontSize: "15px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          ></Label>
                                          <HorizontalStack
                                            key="314673"
                                            data-testid="HorizontalStack5"
                                            id="314673"
                                            direction="horizontal"
                                            size={12}
                                            overflowX="auto"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                fontFamily: "Poppins",
                                                fontWeight: 400,
                                                fontSize: "15px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <Label
                                              key="487355"
                                              data-testid="Label33"
                                              id="487355"
                                              value="[datafield:onaylayanZaman]"
                                              formatter="custom date"
                                              customFormatter="DD.MM.YYYY HH:mm"
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 400,
                                                  fontSize: "11px",
                                                  color:
                                                    "rgba(115, 115, 115, 1)",
                                                } as any
                                              }
                                            ></Label>
                                            <Label
                                              key="132389"
                                              data-testid="Label32"
                                              id="132389"
                                              value="[datafield:onaylayan]"
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 400,
                                                  fontSize: "11px",
                                                  color:
                                                    "rgba(115, 115, 115, 1)",
                                                } as any
                                              }
                                            ></Label>
                                          </HorizontalStack>
                                        </VerticalStack>
                                      </KCol>
                                    </KRow>
                                  </KTableColumn>
                                </KTableRow>
                              </KTable>
                            </KCol>
                          </KRow>
                          <KRow
                            key="141226"
                            data-testid="Row34"
                            id="141226"
                            align="top"
                            justify="start"
                            horizontalGutter={0}
                            verticalGutter={0}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                fontFamily: "Poppins",
                                fontWeight: 400,
                                fontSize: "15px",
                                color: "rgba(68, 68, 68, 1)",
                              } as any
                            }
                          >
                            <KCol
                              key="415072"
                              data-testid="Col54_3"
                              id="415072"
                              xs={24}
                              sm={24}
                              md={24}
                              lg={24}
                              xl={24}
                              xxl={24}
                              order={0}
                              pull={0}
                              push={0}
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  paddingTop: 0,
                                  paddingRight: 8,
                                  paddingBottom: 8,
                                  paddingLeft: 8,
                                  alignItems: "flex-start",
                                  textAlign: "-webkit-left",
                                  fontFamily: "Poppins",
                                  fontWeight: 400,
                                  fontSize: "15px",
                                  color: "rgba(68, 68, 68, 1)",
                                } as any
                              }
                            >
                              <KRow
                                key="193097"
                                data-testid="Row30"
                                id="193097"
                                align="top"
                                justify="start"
                                horizontalGutter={0}
                                verticalGutter={0}
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 0,
                                    paddingRight: 0,
                                    paddingBottom: 0,
                                    paddingLeft: 0,
                                    fontFamily: "Poppins",
                                    fontWeight: 400,
                                    fontSize: "15px",
                                    color: "rgba(68, 68, 68, 1)",
                                  } as any
                                }
                              >
                                <KCol
                                  key="270005"
                                  data-testid="Col56_1"
                                  id="270005"
                                  xs={12}
                                  sm={12}
                                  md={12}
                                  lg={12}
                                  xl={22}
                                  xxl={22}
                                  order={0}
                                  pull={0}
                                  push={0}
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      paddingTop: 0,
                                      paddingRight: 0,
                                      paddingBottom: 0,
                                      paddingLeft: 0,
                                      fontFamily: "Poppins",
                                      fontWeight: 400,
                                      fontSize: "15px",
                                      color: "rgba(68, 68, 68, 1)",
                                    } as any
                                  }
                                >
                                  <Form.Item
                                    className="kFormItem"
                                    name="ucusform_755702_value"
                                  >
                                    <TextArea
                                      key="755702"
                                      data-testid="YazismaMesaj"
                                      id="755702"
                                      placeholder={ReactSystemFunctions.translate(
                                        this.ml,
                                        755702,
                                        "placeholder",
                                        this.defaultML
                                      )}
                                      allowClear={false}
                                      autoSize={false}
                                      showCount={false}
                                      formatter="None"
                                      readOnly={false}
                                      speechToText={false}
                                      style={
                                        {
                                          borderTopLeftRadius: 8,
                                          borderTopRightRadius: 8,
                                          borderBottomRightRadius: 8,
                                          borderBottomLeftRadius: 8,
                                          borderTopWidth: 1,
                                          borderRightWidth: 1,
                                          borderBottomWidth: 1,
                                          borderLeftWidth: 1,
                                          borderColor: "rgba(218, 218, 218, 1)",
                                          borderStyle: "solid",
                                          backgroundColor:
                                            "rgba(255, 255, 255, 1)",
                                          backgroundRepeat: "no-repeat",
                                          backgroundSize: "contain",
                                          backgroundPosition: "left",
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "center",
                                          textAlign: "-webkit-left",
                                          display: "block",
                                          fontFamily: "Poppins",
                                          fontWeight: 400,
                                          fontSize: "15px",
                                          color: "rgba(68, 68, 68, 1)",
                                        } as any
                                      }
                                    ></TextArea>
                                  </Form.Item>
                                </KCol>
                                <KCol
                                  key="755455"
                                  data-testid="Col59"
                                  id="755455"
                                  xs={12}
                                  sm={12}
                                  md={12}
                                  lg={12}
                                  xl={2}
                                  xxl={2}
                                  order={0}
                                  pull={0}
                                  push={0}
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      paddingTop: 8,
                                      paddingRight: 8,
                                      paddingBottom: 8,
                                      paddingLeft: 8,
                                      alignItems: "center",
                                      textAlign: "-webkit-right",
                                      fontFamily: "Poppins",
                                      fontWeight: 400,
                                      fontSize: "15px",
                                      color: "rgba(68, 68, 68, 1)",
                                    } as any
                                  }
                                >
                                  <Button
                                    key="631587"
                                    data-testid="btnGonder"
                                    id="631587"
                                    onClick={(e?: any) => {
                                      if (e && e.stopPropagation)
                                        e.stopPropagation();
                                      this.UcusFormComponent_631587_onClick();
                                    }}
                                    showCursorPointer
                                    label={ReactSystemFunctions.translate(
                                      this.ml,
                                      631587,
                                      "label",
                                      this.defaultML
                                    )}
                                    size="middle"
                                    loading={false}
                                    ghost={false}
                                    block={false}
                                    htmlType="button"
                                    icon="send"
                                    iconPosition="left"
                                    danger={false}
                                    style={
                                      {
                                        borderTopLeftRadius: 8,
                                        borderTopRightRadius: 8,
                                        borderBottomRightRadius: 8,
                                        borderBottomLeftRadius: 8,
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        backgroundColor: "rgba(3, 88, 255, 1)",
                                        backgroundRepeat: "no-repeat",
                                        backgroundSize: "contain",
                                        backgroundPosition: "left",
                                        paddingTop: 8,
                                        paddingRight: 16,
                                        paddingBottom: 8,
                                        paddingLeft: 16,
                                        minWidth: "120px",
                                        alignItems: "center",
                                        textAlign: "-webkit-center",
                                        display: "inline",
                                        fontFamily: "Poppins",
                                        fontWeight: 500,
                                        fontSize: "16px",
                                        color: "rgba(255, 255, 255, 1)",
                                        lineHeight: "22px",
                                      } as any
                                    }
                                  ></Button>
                                </KCol>
                              </KRow>
                            </KCol>
                          </KRow>
                        </KCol>
                      </KRow>
                    </KCol>
                  </KRow>
                  <KModal
                    key="78493"
                    data-testid="Modal5"
                    id="78493"
                    visible={this.state.NavVisible78493}
                    onOk={() => {
                      this.setState({ NavVisible78493: false }, () => {
                        this.callCallbackFunction(78493);
                      });
                    }}
                    onCancel={() => {
                      this.setState({ NavVisible78493: false }, () => {
                        this.callCallbackFunction(78493);
                      });
                    }}
                    closable={true}
                    width="500px"
                    footer={null}
                    height="250px"
                    children={
                      this.state.NavVisible78493 && (
                        <InlineFormScope>
                          <MesajKutusu_Screen
                            onClose={() => {
                              this.setState({ NavVisible78493: false }, () => {
                                this.callCallbackFunction(78493);
                              });
                            }}
                            screenInputs={window.kuika.navigationScreenInputs}
                            navigator={this.props.navigator}
                            form={this.props.form}
                            context={this.props.context}
                          />
                        </InlineFormScope>
                      )
                    }
                  ></KModal>
                  <KDrawer
                    key="352231"
                    data-testid="Drawer1"
                    id="352231"
                    placement="left"
                    onClose={() => {
                      this.setState({ NavVisible352231: false }, () => {
                        this.callCallbackFunction(352231);
                      });
                    }}
                    visible={this.state.NavVisible352231}
                    width="380px"
                    height="100vh"
                    push={true}
                    closable={true}
                    children={
                      this.state.NavVisible352231 && (
                        <InlineFormScope>
                          <LeftMenu_Screen
                            onClose={() => {
                              this.setState({ NavVisible352231: false }, () => {
                                this.callCallbackFunction(352231);
                              });
                            }}
                            screenInputs={window.kuika.navigationScreenInputs}
                            navigator={this.props.navigator}
                            form={this.props.form}
                            context={this.props.context}
                          />
                        </InlineFormScope>
                      )
                    }
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        paddingTop: 0,
                        paddingRight: 0,
                        paddingBottom: 0,
                        paddingLeft: 0,
                        fontFamily: "Poppins",
                        fontWeight: 400,
                        fontSize: "15px",
                        color: "rgba(68, 68, 68, 1)",
                      } as any
                    }
                  ></KDrawer>
                  <KModal
                    key="166670"
                    data-testid="Modal7"
                    id="166670"
                    visible={this.state.NavVisible166670}
                    onOk={() => {
                      this.setState({ NavVisible166670: false }, () => {
                        this.callCallbackFunction(166670);
                      });
                    }}
                    onCancel={() => {
                      this.setState({ NavVisible166670: false }, () => {
                        this.callCallbackFunction(166670);
                      });
                    }}
                    closable={true}
                    width="500px"
                    footer={null}
                    height="350px"
                    children={
                      this.state.NavVisible166670 && (
                        <InlineFormScope>
                          <MesajKutusu_Screen
                            onClose={() => {
                              this.setState({ NavVisible166670: false }, () => {
                                this.callCallbackFunction(166670);
                              });
                            }}
                            screenInputs={window.kuika.navigationScreenInputs}
                            navigator={this.props.navigator}
                            form={this.props.form}
                            context={this.props.context}
                          />
                        </InlineFormScope>
                      )
                    }
                  ></KModal>
                  <KModal
                    key="909141"
                    data-testid="Modal9"
                    id="909141"
                    visible={this.state.NavVisible909141}
                    onOk={() => {
                      this.setState({ NavVisible909141: false }, () => {
                        this.callCallbackFunction(909141);
                      });
                    }}
                    onCancel={() => {
                      this.setState({ NavVisible909141: false }, () => {
                        this.callCallbackFunction(909141);
                      });
                    }}
                    closable={true}
                    width="500px"
                    footer={null}
                    height="350px"
                    children={
                      this.state.NavVisible909141 && (
                        <InlineFormScope>
                          <MesajKutusu_Screen
                            onClose={() => {
                              this.setState({ NavVisible909141: false }, () => {
                                this.callCallbackFunction(909141);
                              });
                            }}
                            screenInputs={window.kuika.navigationScreenInputs}
                            navigator={this.props.navigator}
                            form={this.props.form}
                            context={this.props.context}
                          />
                        </InlineFormScope>
                      )
                    }
                  ></KModal>
                  <KModal
                    key="817067"
                    data-testid="Modal8"
                    id="817067"
                    visible={this.state.NavVisible817067}
                    onOk={() => {
                      this.setState({ NavVisible817067: false }, () => {
                        this.callCallbackFunction(817067);
                      });
                    }}
                    onCancel={() => {
                      this.setState({ NavVisible817067: false }, () => {
                        this.callCallbackFunction(817067);
                      });
                    }}
                    closable={true}
                    width="500px"
                    footer={null}
                    height="350px"
                    children={
                      this.state.NavVisible817067 && (
                        <InlineFormScope>
                          <MesajKutusu_Screen
                            onClose={() => {
                              this.setState({ NavVisible817067: false }, () => {
                                this.callCallbackFunction(817067);
                              });
                            }}
                            screenInputs={window.kuika.navigationScreenInputs}
                            navigator={this.props.navigator}
                            form={this.props.form}
                            context={this.props.context}
                          />
                        </InlineFormScope>
                      )
                    }
                  ></KModal>
                  <KModal
                    key="139274"
                    data-testid="Modal10"
                    id="139274"
                    visible={this.state.NavVisible139274}
                    onOk={() => {
                      this.setState({ NavVisible139274: false }, () => {
                        this.callCallbackFunction(139274);
                      });
                    }}
                    onCancel={() => {
                      this.setState({ NavVisible139274: false }, () => {
                        this.callCallbackFunction(139274);
                      });
                    }}
                    closable={true}
                    width="500px"
                    footer={null}
                    height="350px"
                    children={
                      this.state.NavVisible139274 && (
                        <InlineFormScope>
                          <MesajKutusu_Screen
                            onClose={() => {
                              this.setState({ NavVisible139274: false }, () => {
                                this.callCallbackFunction(139274);
                              });
                            }}
                            screenInputs={window.kuika.navigationScreenInputs}
                            navigator={this.props.navigator}
                            form={this.props.form}
                            context={this.props.context}
                          />
                        </InlineFormScope>
                      )
                    }
                  ></KModal>
                  <KModal
                    key="48533"
                    data-testid="Modal11"
                    id="48533"
                    visible={this.state.NavVisible48533}
                    onOk={() => {
                      this.setState({ NavVisible48533: false }, () => {
                        this.callCallbackFunction(48533);
                      });
                    }}
                    onCancel={() => {
                      this.setState({ NavVisible48533: false }, () => {
                        this.callCallbackFunction(48533);
                      });
                    }}
                    closable={true}
                    width="500px"
                    footer={null}
                    height="350px"
                    children={
                      this.state.NavVisible48533 && (
                        <InlineFormScope>
                          <MesajKutusu_Screen
                            onClose={() => {
                              this.setState({ NavVisible48533: false }, () => {
                                this.callCallbackFunction(48533);
                              });
                            }}
                            screenInputs={window.kuika.navigationScreenInputs}
                            navigator={this.props.navigator}
                            form={this.props.form}
                            context={this.props.context}
                          />
                        </InlineFormScope>
                      )
                    }
                  ></KModal>
                  <KModal
                    key="187396"
                    data-testid="Modal12"
                    id="187396"
                    visible={this.state.NavVisible187396}
                    onOk={() => {
                      this.setState({ NavVisible187396: false }, () => {
                        this.callCallbackFunction(187396);
                      });
                    }}
                    onCancel={() => {
                      this.setState({ NavVisible187396: false }, () => {
                        this.callCallbackFunction(187396);
                      });
                    }}
                    closable={false}
                    width="800px"
                    footer={null}
                    height="70vh"
                    children={
                      this.state.NavVisible187396 && (
                        <InlineFormScope>
                          <MasrafForm_Screen
                            onClose={() => {
                              this.setState({ NavVisible187396: false }, () => {
                                this.callCallbackFunction(187396);
                              });
                            }}
                            screenInputs={window.kuika.navigationScreenInputs}
                            navigator={this.props.navigator}
                            form={this.props.form}
                            context={this.props.context}
                          />
                        </InlineFormScope>
                      )
                    }
                  ></KModal>
                  <KModal
                    key="608600"
                    data-testid="Modal15"
                    id="608600"
                    visible={this.state.NavVisible608600}
                    onOk={() => {
                      this.setState({ NavVisible608600: false }, () => {
                        this.callCallbackFunction(608600);
                      });
                    }}
                    onCancel={() => {
                      this.setState({ NavVisible608600: false }, () => {
                        this.callCallbackFunction(608600);
                      });
                    }}
                    closable={true}
                    width="500px"
                    footer={null}
                    height="350px"
                    children={
                      this.state.NavVisible608600 && (
                        <InlineFormScope>
                          <MesajKutusu_Screen
                            onClose={() => {
                              this.setState({ NavVisible608600: false }, () => {
                                this.callCallbackFunction(608600);
                              });
                            }}
                            screenInputs={window.kuika.navigationScreenInputs}
                            navigator={this.props.navigator}
                            form={this.props.form}
                            context={this.props.context}
                          />
                        </InlineFormScope>
                      )
                    }
                  ></KModal>
                  <KModal
                    key="313635"
                    data-testid="Modal15"
                    id="313635"
                    visible={this.state.NavVisible313635}
                    onOk={() => {
                      this.setState({ NavVisible313635: false }, () => {
                        this.callCallbackFunction(313635);
                      });
                    }}
                    onCancel={() => {
                      this.setState({ NavVisible313635: false }, () => {
                        this.callCallbackFunction(313635);
                      });
                    }}
                    closable={true}
                    width="500px"
                    footer={null}
                    height="350px"
                    children={
                      this.state.NavVisible313635 && (
                        <InlineFormScope>
                          <MesajKutusu_Screen
                            onClose={() => {
                              this.setState({ NavVisible313635: false }, () => {
                                this.callCallbackFunction(313635);
                              });
                            }}
                            screenInputs={window.kuika.navigationScreenInputs}
                            navigator={this.props.navigator}
                            form={this.props.form}
                            context={this.props.context}
                          />
                        </InlineFormScope>
                      )
                    }
                  ></KModal>
                  <KModal
                    key="71920"
                    data-testid="Modal16"
                    id="71920"
                    visible={this.state.NavVisible71920}
                    onOk={() => {
                      this.setState({ NavVisible71920: false }, () => {
                        this.callCallbackFunction(71920);
                      });
                    }}
                    onCancel={() => {
                      this.setState({ NavVisible71920: false }, () => {
                        this.callCallbackFunction(71920);
                      });
                    }}
                    closable={true}
                    width="800px"
                    footer={null}
                    height="70vh"
                    children={
                      this.state.NavVisible71920 && (
                        <InlineFormScope>
                          <DosyaGoster_Screen
                            onClose={() => {
                              this.setState({ NavVisible71920: false }, () => {
                                this.callCallbackFunction(71920);
                              });
                            }}
                            screenInputs={window.kuika.navigationScreenInputs}
                            navigator={this.props.navigator}
                            form={this.props.form}
                            context={this.props.context}
                          />
                        </InlineFormScope>
                      )
                    }
                  ></KModal>
                  <KModal
                    key="190842"
                    data-testid="Modal18"
                    id="190842"
                    visible={this.state.NavVisible190842}
                    onOk={() => {
                      this.setState({ NavVisible190842: false }, () => {
                        this.callCallbackFunction(190842);
                      });
                    }}
                    onCancel={() => {
                      this.setState({ NavVisible190842: false }, () => {
                        this.callCallbackFunction(190842);
                      });
                    }}
                    closable={true}
                    width="800px"
                    footer={null}
                    height="70vh"
                    children={
                      this.state.NavVisible190842 && (
                        <InlineFormScope>
                          <DosyaGoster_Screen
                            onClose={() => {
                              this.setState({ NavVisible190842: false }, () => {
                                this.callCallbackFunction(190842);
                              });
                            }}
                            screenInputs={window.kuika.navigationScreenInputs}
                            navigator={this.props.navigator}
                            form={this.props.form}
                            context={this.props.context}
                          />
                        </InlineFormScope>
                      )
                    }
                  ></KModal>
                  <KModal
                    key="323320"
                    data-testid="Modal18"
                    id="323320"
                    visible={this.state.NavVisible323320}
                    onOk={() => {
                      this.setState({ NavVisible323320: false }, () => {
                        this.callCallbackFunction(323320);
                      });
                    }}
                    onCancel={() => {
                      this.setState({ NavVisible323320: false }, () => {
                        this.callCallbackFunction(323320);
                      });
                    }}
                    closable={true}
                    width="800px"
                    footer={null}
                    height="70vh"
                    children={
                      this.state.NavVisible323320 && (
                        <InlineFormScope>
                          <DosyaGoster_Screen
                            onClose={() => {
                              this.setState({ NavVisible323320: false }, () => {
                                this.callCallbackFunction(323320);
                              });
                            }}
                            screenInputs={window.kuika.navigationScreenInputs}
                            navigator={this.props.navigator}
                            form={this.props.form}
                            context={this.props.context}
                          />
                        </InlineFormScope>
                      )
                    }
                  ></KModal>
                  <KModal
                    key="228696"
                    data-testid="Modal17"
                    id="228696"
                    visible={this.state.NavVisible228696}
                    onOk={() => {
                      this.setState({ NavVisible228696: false }, () => {
                        this.callCallbackFunction(228696);
                      });
                    }}
                    onCancel={() => {
                      this.setState({ NavVisible228696: false }, () => {
                        this.callCallbackFunction(228696);
                      });
                    }}
                    closable={false}
                    width="800px"
                    footer={null}
                    height="70vh"
                    children={
                      this.state.NavVisible228696 && (
                        <InlineFormScope>
                          <MasrafForm_Screen
                            onClose={() => {
                              this.setState({ NavVisible228696: false }, () => {
                                this.callCallbackFunction(228696);
                              });
                            }}
                            screenInputs={window.kuika.navigationScreenInputs}
                            navigator={this.props.navigator}
                            form={this.props.form}
                            context={this.props.context}
                          />
                        </InlineFormScope>
                      )
                    }
                  ></KModal>
                  <KDrawer
                    key="288527"
                    data-testid="Drawer2"
                    id="288527"
                    placement="right"
                    onClose={() => {
                      this.setState({ NavVisible288527: false }, () => {
                        this.callCallbackFunction(288527);
                      });
                    }}
                    visible={this.state.NavVisible288527}
                    width="100vw"
                    height="100vh"
                    push={false}
                    closable={false}
                    children={
                      this.state.NavVisible288527 && (
                        <InlineFormScope>
                          <TarihceList_Screen
                            onClose={() => {
                              this.setState({ NavVisible288527: false }, () => {
                                this.callCallbackFunction(288527);
                              });
                            }}
                            screenInputs={window.kuika.navigationScreenInputs}
                            navigator={this.props.navigator}
                            form={this.props.form}
                            context={this.props.context}
                          />
                        </InlineFormScope>
                      )
                    }
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        paddingTop: 0,
                        paddingRight: 0,
                        paddingBottom: 0,
                        paddingLeft: 0,
                        fontFamily: "Poppins",
                        fontWeight: 400,
                        fontSize: "15px",
                        color: "rgba(68, 68, 68, 1)",
                      } as any
                    }
                  ></KDrawer>
                </div>
                <Footer
                  key="-3"
                  id="ucusform_footer"
                  style={
                    {
                      borderStyle: "solid",
                      borderTopWidth: 0,
                      borderRightWidth: 0,
                      borderBottomWidth: 0,
                      borderLeftWidth: 0,
                      backgroundColor: "rgba(3, 88, 255, 0.1)",
                      paddingTop: 0,
                      paddingRight: 0,
                      paddingBottom: 0,
                      paddingLeft: 0,
                      fontFamily: "Poppins",
                      fontWeight: 400,
                      fontSize: "15px",
                      color: "rgba(68, 68, 68, 1)",
                    } as any
                  }
                >
                  <KRow
                    key="995044"
                    data-testid="Row18"
                    id="995044"
                    align="top"
                    justify="start"
                    horizontalGutter={0}
                    verticalGutter={0}
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        paddingTop: 8,
                        paddingRight: 8,
                        paddingBottom: 8,
                        paddingLeft: 8,
                        alignItems: "flex-start",
                        textAlign: "-webkit-left",
                        fontFamily: "Poppins",
                        fontWeight: 400,
                        fontSize: "15px",
                        color: "rgba(68, 68, 68, 1)",
                      } as any
                    }
                  >
                    <KCol
                      key="983441"
                      data-testid="Col43_0"
                      id="983441"
                      xs={24}
                      sm={24}
                      md={24}
                      lg={24}
                      xl={24}
                      xxl={24}
                      order={0}
                      pull={0}
                      push={0}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 8,
                          paddingRight: 8,
                          paddingBottom: 8,
                          paddingLeft: 8,
                          alignItems: "flex-start",
                          textAlign: "-webkit-center",
                          fontFamily: "Poppins",
                          fontWeight: 400,
                          fontSize: "15px",
                          color: "rgba(68, 68, 68, 1)",
                        } as any
                      }
                    >
                      <HorizontalStack
                        key="365541"
                        data-testid="HorizontalStack3"
                        id="365541"
                        direction="horizontal"
                        size={5}
                        overflowX="auto"
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 0,
                            paddingRight: 0,
                            paddingBottom: 0,
                            paddingLeft: 0,
                            fontFamily: "Poppins",
                            fontWeight: 400,
                            fontSize: "15px",
                            color: "rgba(68, 68, 68, 1)",
                          } as any
                        }
                      >
                        <Button
                          key="854746"
                          data-testid="btnVazgec"
                          id="854746"
                          onClick={(e?: any) => {
                            if (e && e.stopPropagation) e.stopPropagation();
                            this.UcusFormComponent_854746_onClick();
                          }}
                          showCursorPointer
                          label={ReactSystemFunctions.translate(
                            this.ml,
                            854746,
                            "label",
                            this.defaultML
                          )}
                          size="middle"
                          loading={false}
                          ghost={false}
                          block={false}
                          htmlType="button"
                          icon="arrow_back_ios"
                          iconPosition="left"
                          danger={false}
                          style={
                            {
                              borderTopLeftRadius: 8,
                              borderTopRightRadius: 8,
                              borderBottomRightRadius: 8,
                              borderBottomLeftRadius: 8,
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              backgroundColor: "rgba(3, 88, 255, 1)",
                              backgroundRepeat: "no-repeat",
                              backgroundSize: "contain",
                              backgroundPosition: "left",
                              paddingTop: 8,
                              paddingRight: 16,
                              paddingBottom: 8,
                              paddingLeft: 16,
                              alignItems: "center",
                              textAlign: "-webkit-center",
                              display: "inline",
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "16px",
                              color: "rgba(255, 255, 255, 1)",
                              lineHeight: "22px",
                            } as any
                          }
                        ></Button>
                        <Button
                          key="162835"
                          data-testid="btnKaydetUcus"
                          id="162835"
                          onClick={(e?: any) => {
                            if (e && e.stopPropagation) e.stopPropagation();
                            this.UcusFormComponent_162835_onClick();
                          }}
                          showCursorPointer
                          visibility={this.state.isComp162835Visible}
                          label={ReactSystemFunctions.translate(
                            this.ml,
                            162835,
                            "label",
                            this.defaultML
                          )}
                          size="middle"
                          loading={false}
                          ghost={false}
                          block={false}
                          htmlType="button"
                          icon="save"
                          iconPosition="left"
                          danger={false}
                          style={
                            {
                              borderTopLeftRadius: 8,
                              borderTopRightRadius: 8,
                              borderBottomRightRadius: 8,
                              borderBottomLeftRadius: 8,
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              backgroundColor: "rgba(3, 88, 255, 1)",
                              backgroundRepeat: "no-repeat",
                              backgroundSize: "contain",
                              backgroundPosition: "left",
                              paddingTop: 8,
                              paddingRight: 16,
                              paddingBottom: 8,
                              paddingLeft: 16,
                              alignItems: "center",
                              textAlign: "-webkit-center",
                              display: "inline",
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "16px",
                              color: "rgba(255, 255, 255, 1)",
                              lineHeight: "22px",
                            } as any
                          }
                        ></Button>
                        <Button
                          key="796340"
                          data-testid="btnKaydetMasraf"
                          id="796340"
                          onClick={(e?: any) => {
                            if (e && e.stopPropagation) e.stopPropagation();
                            this.UcusFormComponent_796340_onClick();
                          }}
                          showCursorPointer
                          visibility={this.state.isComp796340Visible}
                          label={ReactSystemFunctions.translate(
                            this.ml,
                            796340,
                            "label",
                            this.defaultML
                          )}
                          size="middle"
                          loading={false}
                          ghost={false}
                          block={false}
                          htmlType="button"
                          icon="save"
                          iconPosition="left"
                          danger={false}
                          style={
                            {
                              borderTopLeftRadius: 8,
                              borderTopRightRadius: 8,
                              borderBottomRightRadius: 8,
                              borderBottomLeftRadius: 8,
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              backgroundColor: "rgba(3, 88, 255, 1)",
                              backgroundRepeat: "no-repeat",
                              backgroundSize: "contain",
                              backgroundPosition: "left",
                              paddingTop: 8,
                              paddingRight: 16,
                              paddingBottom: 8,
                              paddingLeft: 16,
                              alignItems: "center",
                              textAlign: "-webkit-center",
                              display: "inline",
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "16px",
                              color: "rgba(255, 255, 255, 1)",
                              lineHeight: "22px",
                            } as any
                          }
                        ></Button>
                        <Button
                          key="46886"
                          data-testid="btnKaydetMasrafOnaysiz"
                          id="46886"
                          onClick={(e?: any) => {
                            if (e && e.stopPropagation) e.stopPropagation();
                            this.UcusFormComponent_46886_onClick();
                          }}
                          showCursorPointer
                          visibility={this.state.isComp46886Visible}
                          label={ReactSystemFunctions.translate(
                            this.ml,
                            46886,
                            "label",
                            this.defaultML
                          )}
                          size="middle"
                          loading={false}
                          ghost={false}
                          block={false}
                          htmlType="button"
                          icon="save"
                          iconPosition="left"
                          danger={false}
                          style={
                            {
                              borderTopLeftRadius: 8,
                              borderTopRightRadius: 8,
                              borderBottomRightRadius: 8,
                              borderBottomLeftRadius: 8,
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              backgroundColor: "rgba(3, 88, 255, 1)",
                              backgroundRepeat: "no-repeat",
                              backgroundSize: "contain",
                              backgroundPosition: "left",
                              paddingTop: 8,
                              paddingRight: 16,
                              paddingBottom: 8,
                              paddingLeft: 16,
                              alignItems: "center",
                              textAlign: "-webkit-center",
                              display: "inline",
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "16px",
                              color: "rgba(255, 255, 255, 1)",
                              lineHeight: "22px",
                            } as any
                          }
                        ></Button>
                        <Button
                          key="845903"
                          data-testid="btnMasrafTamamla"
                          id="845903"
                          onClick={(e?: any) => {
                            if (e && e.stopPropagation) e.stopPropagation();
                            this.UcusFormComponent_845903_onClick();
                          }}
                          showCursorPointer
                          visibility={this.state.isComp845903Visible}
                          label={ReactSystemFunctions.translate(
                            this.ml,
                            845903,
                            "label",
                            this.defaultML
                          )}
                          size="middle"
                          loading={false}
                          ghost={false}
                          block={false}
                          htmlType="button"
                          icon="save"
                          iconPosition="left"
                          danger={false}
                          style={
                            {
                              borderTopLeftRadius: 8,
                              borderTopRightRadius: 8,
                              borderBottomRightRadius: 8,
                              borderBottomLeftRadius: 8,
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              backgroundColor: "rgba(3, 88, 255, 1)",
                              backgroundRepeat: "no-repeat",
                              backgroundSize: "contain",
                              backgroundPosition: "left",
                              paddingTop: 8,
                              paddingRight: 16,
                              paddingBottom: 8,
                              paddingLeft: 16,
                              alignItems: "center",
                              textAlign: "-webkit-center",
                              display: "inline",
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "16px",
                              color: "rgba(255, 255, 255, 1)",
                              lineHeight: "22px",
                            } as any
                          }
                        ></Button>
                        <Button
                          key="388008"
                          data-testid="btnOnayla"
                          id="388008"
                          onClick={(e?: any) => {
                            if (e && e.stopPropagation) e.stopPropagation();
                            this.UcusFormComponent_388008_onClick();
                          }}
                          showCursorPointer
                          visibility={this.state.isComp388008Visible}
                          label={ReactSystemFunctions.translate(
                            this.ml,
                            388008,
                            "label",
                            this.defaultML
                          )}
                          size="middle"
                          loading={false}
                          ghost={false}
                          block={false}
                          htmlType="button"
                          icon="thumb_up_alt"
                          iconPosition="left"
                          danger={false}
                          style={
                            {
                              borderTopLeftRadius: 8,
                              borderTopRightRadius: 8,
                              borderBottomRightRadius: 8,
                              borderBottomLeftRadius: 8,
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              backgroundColor: "rgba(114, 194, 64, 1)",
                              backgroundRepeat: "no-repeat",
                              backgroundSize: "contain",
                              backgroundPosition: "left",
                              paddingTop: 8,
                              paddingRight: 16,
                              paddingBottom: 8,
                              paddingLeft: 16,
                              alignItems: "center",
                              textAlign: "-webkit-center",
                              display: "inline",
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "16px",
                              color: "rgba(255, 255, 255, 1)",
                              lineHeight: "22px",
                            } as any
                          }
                        ></Button>
                        <Button
                          key="236180"
                          data-testid="btnMasrafOnayla"
                          id="236180"
                          onClick={(e?: any) => {
                            if (e && e.stopPropagation) e.stopPropagation();
                            this.UcusFormComponent_236180_onClick();
                          }}
                          showCursorPointer
                          visibility={
                            this.state.isComp236180Visible == "hidden" ||
                            this.state
                              .isCompucusform_236180AuthorizationVisible ==
                              "hidden"
                              ? "hidden"
                              : "visible"
                          }
                          visibilityByAuthorization={
                            this.state
                              .isCompucusform_236180AuthorizationVisible ==
                            "hidden"
                              ? "hidden"
                              : "visible"
                          }
                          label={ReactSystemFunctions.translate(
                            this.ml,
                            236180,
                            "label",
                            this.defaultML
                          )}
                          size="middle"
                          loading={false}
                          ghost={false}
                          block={false}
                          htmlType="button"
                          icon="thumb_up_alt"
                          iconPosition="left"
                          danger={false}
                          style={
                            {
                              borderTopLeftRadius: 8,
                              borderTopRightRadius: 8,
                              borderBottomRightRadius: 8,
                              borderBottomLeftRadius: 8,
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              backgroundColor: "rgba(114, 194, 64, 1)",
                              backgroundRepeat: "no-repeat",
                              backgroundSize: "contain",
                              backgroundPosition: "left",
                              paddingTop: 8,
                              paddingRight: 16,
                              paddingBottom: 8,
                              paddingLeft: 16,
                              alignItems: "center",
                              textAlign: "-webkit-center",
                              display: "inline",
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "16px",
                              color: "rgba(255, 255, 255, 1)",
                              lineHeight: "22px",
                            } as any
                          }
                        ></Button>
                        <Button
                          key="855300"
                          data-testid="btnMasrafRed"
                          id="855300"
                          onClick={(e?: any) => {
                            if (e && e.stopPropagation) e.stopPropagation();
                            this.UcusFormComponent_855300_onClick();
                          }}
                          showCursorPointer
                          visibility={
                            this.state.isComp855300Visible == "hidden" ||
                            this.state
                              .isCompucusform_855300AuthorizationVisible ==
                              "hidden"
                              ? "hidden"
                              : "visible"
                          }
                          visibilityByAuthorization={
                            this.state
                              .isCompucusform_855300AuthorizationVisible ==
                            "hidden"
                              ? "hidden"
                              : "visible"
                          }
                          label={ReactSystemFunctions.translate(
                            this.ml,
                            855300,
                            "label",
                            this.defaultML
                          )}
                          size="middle"
                          loading={false}
                          ghost={false}
                          block={false}
                          htmlType="button"
                          icon="thumb_down_alt"
                          iconPosition="left"
                          danger={false}
                          style={
                            {
                              borderTopLeftRadius: 8,
                              borderTopRightRadius: 8,
                              borderBottomRightRadius: 8,
                              borderBottomLeftRadius: 8,
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              backgroundColor: "rgba(235, 145, 58, 1)",
                              backgroundRepeat: "no-repeat",
                              backgroundSize: "contain",
                              backgroundPosition: "left",
                              paddingTop: 8,
                              paddingRight: 16,
                              paddingBottom: 8,
                              paddingLeft: 16,
                              alignItems: "center",
                              textAlign: "-webkit-center",
                              display: "inline",
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "16px",
                              color: "rgba(255, 255, 255, 1)",
                              lineHeight: "22px",
                            } as any
                          }
                        ></Button>
                        <Button
                          key="175518"
                          data-testid="btnSil"
                          id="175518"
                          onClick={(e?: any) => {
                            if (e && e.stopPropagation) e.stopPropagation();
                            this.UcusFormComponent_175518_onClick();
                          }}
                          showCursorPointer
                          visibility={this.state.isComp175518Visible}
                          label={ReactSystemFunctions.translate(
                            this.ml,
                            175518,
                            "label",
                            this.defaultML
                          )}
                          size="middle"
                          loading={false}
                          ghost={false}
                          block={false}
                          htmlType="button"
                          icon="delete_forever"
                          iconPosition="left"
                          danger={false}
                          style={
                            {
                              borderTopLeftRadius: 8,
                              borderTopRightRadius: 8,
                              borderBottomRightRadius: 8,
                              borderBottomLeftRadius: 8,
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              backgroundColor: "rgba(225, 60, 57, 1)",
                              backgroundRepeat: "no-repeat",
                              backgroundSize: "contain",
                              backgroundPosition: "left",
                              paddingTop: 8,
                              paddingRight: 16,
                              paddingBottom: 8,
                              paddingLeft: 16,
                              alignItems: "center",
                              textAlign: "-webkit-center",
                              display: "inline",
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "16px",
                              color: "rgba(255, 255, 255, 1)",
                              lineHeight: "22px",
                            } as any
                          }
                        ></Button>
                      </HorizontalStack>
                    </KCol>
                  </KRow>
                </Footer>
              </div>
            </Form>
          </KuikaTabOrderProvider>
        </Spin>
      </>
    );
  }
}

const mapStateToProps = (state: AppState) => {
  return {
    spinnerCount: state.spinnerReducer.spinnerCount,
    photoTakeVisible: state.photoTakeReducer.visible,
    isImportMappedExcelModalVisible:
      state.importMappedExcelModalReducer.visible,
  };
};
const mapDispatchToProps = (dispatch) => ({
  showPhotoTake: () => dispatch(showPhotoTake()),
  hidePhotoTake: () => dispatch(hidePhotoTake()),
  showStripeDrawer: (data, callback, that, future) =>
    dispatch(showStripeDrawer(data, callback, that, future)),
  hideStripeDrawer: (data, callback, that) =>
    dispatch(hideStripeDrawer(data, callback, that)),
  showIyzicoDrawer: (data, callback, that) =>
    dispatch(showIyzicoDrawer(data, callback, that)),
  hideIyzicoDrawer: (data, callback, that) =>
    dispatch(hideIyzicoDrawer(data, callback, that)),
  showImportMappedExcelModal: (
    dsId,
    tableName,
    primaryKey,
    columnMapping,
    parameters
  ) =>
    dispatch(
      showImportMappedExcelModal(
        dsId,
        tableName,
        primaryKey,
        columnMapping,
        parameters
      )
    ),
  hideImportMappedExcelModal: () => dispatch(hideImportMappedExcelModal()),
});
const tmp = withGoogleLogin(
  withContext(
    withScreenInput(
      withForm(
        withHistory(
          withInlineOverlayNav(
            connect(mapStateToProps, mapDispatchToProps)(UcusForm_Screen)
          )
        )
      )
    )
  )
);
export { tmp as UcusForm_Screen };
//export default tmp;
//export { tmp as UcusForm_Screen };
